import {
  Box,
  SimpleGrid,
  Button,
  useDisclosure,
  useToast,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
  useColorModeValue,
  InputGroup,
  InputLeftElement,
  Checkbox,
  Divider,
  Flex,
  VStack,
  HStack,
  Avatar,
  IconButton,
  InputRightElement,
  Badge,
  List,
  ListItem,
  RadioGroup,
  Radio,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  Stepper,
  Step,
  StepIndicator,
  StepStatus,
  StepIcon,
  StepNumber,
  StepSeparator,
  StepTitle,
  StepDescription,
  useSteps,
  Image,
} from "@chakra-ui/react";
import { MdVisibility, MdEdit, MdDelete, MdSend, MdChat, MdClose, MdVolumeUp, MdCancel, MdCheckCircle, MdAttachFile, MdDownload, MdMoreVert, MdArrowForward, MdArrowBack, MdAdd, MdImage, MdMic, MdPhone, MdAutorenew, MdToggleOff } from "react-icons/md";
import ComplexTable from "views/admin/missions/components/ComplexTable";
import { columnsDataComplex } from "views/admin/missions/variables/columnsData";
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import config, { BASE_URL } from "config/api";
import { io } from "socket.io-client";
import { Autocomplete } from '@react-google-maps/api';
import { useNavigate } from 'react-router-dom';
import GoogleMapsLoader, { useGoogleMaps } from "components/GoogleMapsLoader";
import LoadingSpinner from "components/LoadingSpinner";
import { getMissions, getMission, updateMission, deleteMission, createMission, getUsers, getUser, getVehicules, getAllPatients, getDoctors, getNurses, getMessages, createMessage, markMessageRead, markAllMessagesRead, getUnreadMessagesCounts, createNotification, checkToken } from "../../../api/api";
import { sendSMS } from "../../../api/external";
import { useNavbarAction } from 'contexts/NavbarActionContext';
import MissionStatCard from 'components/card/MissionStatCard';
import teleconsultationImg from "assets/img/Téléconsultation.png";
import consultationDomicileImg from "assets/img/Consultation à domicile.png";
import acteInfirmierImg from "assets/img/Acte infirmier.png";
import ambulanceImg from "assets/img/ambulance.png";
import missioncImg from "assets/img/missionc.png";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { v4 as uuidv4 } from 'uuid'; // Ajout pour générer un UUID
import * as JsSIP from 'jssip';
import { useCalls } from 'contexts/CallsContext';
import { usePermissions } from 'hooks/usePermissions';

const getSocketServerUrl = () => {
  try {
    return new URL(BASE_URL).origin;
  } catch (_) {
    return BASE_URL;
  }
};

dayjs.extend(utc);
dayjs.extend(timezone);

// Intégrer le composant AddressAutocomplete directement dans le fichier
const MissionAddressAutocomplete = ({ value, onChange, placeholder, onLocationSelect }) => {
  const [predictions, setPredictions] = React.useState([]);
  const [showPredictions, setShowPredictions] = React.useState(false);
  const [addressDetails, setAddressDetails] = React.useState(null);
  const [isApiLoaded, setIsApiLoaded] = React.useState(false);
  const inputRef = React.useRef(null);
  const autocompleteRef = React.useRef(null);
  const toast = useToast();

  const parseGoogleMapsLink = (raw) => {
    try {
      if (!raw) return null;
      const decoded = decodeURIComponent(String(raw).trim());
      const cleaned = decoded.replace(/^[@\s]+/, '');

      // 1) Essayer via URL et search params (q=lat,lng)
      try {
        const url = new URL(cleaned.startsWith('http') ? cleaned : `https://${cleaned.replace(/^\/*/, '')}`);
        const q = url.searchParams.get('q');
        if (q && /[-+0-9.]+,\s*[-+0-9.]+/.test(q)) {
          const [latStr, lngStr] = q.split(',');
          const lat = parseFloat(latStr);
          const lng = parseFloat(lngStr);
          if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };
        }
      } catch (_) {
        // not a full URL, fallthrough to regex parsing
      }

      // 2) Format dans le path: /@lat,lng,17z
      const atMatch = cleaned.match(/@\s*([-+0-9.]+),\s*([-+0-9.]+)(?:,|\b)/);
      if (atMatch) {
        const lat = parseFloat(atMatch[1]);
        const lng = parseFloat(atMatch[2]);
        if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };
      }

      // 3) Paramètre q=lat,lng dans une chaîne brute
      const qMatch = cleaned.match(/[?&]q=([-+0-9.]+),\s*([-+0-9.]+)/);
      if (qMatch) {
        const lat = parseFloat(qMatch[1]);
        const lng = parseFloat(qMatch[2]);
        if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };
      }

      // 4) Fallback: première paire lat,lng trouvée dans le texte
      const pairMatch = cleaned.match(/([-+0-9.]+)\s*,\s*([-+0-9.]+)/);
      if (pairMatch) {
        const lat = parseFloat(pairMatch[1]);
        const lng = parseFloat(pairMatch[2]);
        if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };
      }

      return null;
    } catch (_) {
      return null;
    }
  };

  const reverseGeocodeCoordinates = (lat, lng) => {
    return new Promise((resolve, reject) => {
      try {
        if (!window.google || !window.google.maps) {
          reject(new Error('Google Maps non chargé'));
          return;
        }
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === 'OK' && results && results.length > 0) {
            resolve(results[0]);
          } else {
            reject(new Error('Géocodage inverse échoué'));
          }
        });
      } catch (e) {
        reject(e);
      }
    });
  };

  // Check if Google Maps API is loaded
  React.useEffect(() => {
    const checkApiLoaded = () => {
      if (window.google && window.google.maps && window.google.maps.places) {
        setIsApiLoaded(true);
      }
    };

    // Check immediately
    checkApiLoaded();

    // Set up interval to check periodically
    const interval = setInterval(checkApiLoaded, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleInputChange = async (e) => {
    const value = e.target.value;
    onChange(value);

    if (!isApiLoaded) {
      console.warn('Google Maps Places API not loaded yet');
      return;
    }

    // 1) Si l'utilisateur colle un lien Google Maps contenant lat,lng
    const coords = parseGoogleMapsLink(value);
    if (coords) {
      try {
        const result = await reverseGeocodeCoordinates(coords.lat, coords.lng);
        const formattedAddress = result.formatted_address;
        const addressData = {
          streetNumber: '',
          route: '',
          postalCode: '',
          city: '',
          formattedAddress,
          placeId: result.place_id,
          location: { lat: coords.lat, lng: coords.lng },
          name: result.address_components?.find(c => c.types.includes('point_of_interest'))?.long_name || ''
        };
        setAddressDetails(addressData);
        onChange(formattedAddress);
        if (onLocationSelect) {
          onLocationSelect(addressData);
        }
        setPredictions([]);
        setShowPredictions(false);
        toast({ title: "Adresse détectée depuis le lien Google Maps", status: "success", isClosable: true });
        return;
      } catch (err) {
        // En cas d'échec, continuer avec l'autocomplete normal
      }
    }

    if (value && value.length > 2) {
      try {
        const service = new window.google.maps.places.AutocompleteService();
        service.getPlacePredictions(
          {
            input: value,
            componentRestrictions: { country: 'MA' }

          },
          (predictions, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              setPredictions(predictions);
              setShowPredictions(true);
            } else {
              setPredictions([]);
              setShowPredictions(false);
            }
          }
        );
      } catch (error) {
        console.error('Error using Google Places API:', error);
        setPredictions([]);
        setShowPredictions(false);
      }
    } else {
      setPredictions([]);
      setShowPredictions(false);
    }
  };

  const handlePredictionClick = async (prediction) => {
    try {
      const service = new window.google.maps.places.PlacesService(document.createElement('div'));

      service.getDetails(
        {
          placeId: prediction.place_id,
          fields: ['address_components', 'formatted_address', 'geometry', 'name']
        },
        (place, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
            let streetNumber = '';
            let route = '';
            let postalCode = '';
            let city = '';
            let formattedAddress = '';
            let location = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng()
            };

            place.address_components.forEach(component => {
              const types = component.types;

              if (types.includes('street_number')) {
                streetNumber = component.long_name;
              } else if (types.includes('route')) {
                route = component.long_name;
              } else if (types.includes('postal_code')) {
                postalCode = component.long_name;
              } else if (types.includes('locality')) {
                city = component.long_name;
              }
            });

            if (streetNumber && route) {
              formattedAddress = `${streetNumber} ${route}`;
              if (postalCode && city) {
                formattedAddress += `, ${postalCode} ${city}`;
              }
            } else {
              formattedAddress = place.formatted_address;
            }

            const addressData = {
              streetNumber,
              route,
              postalCode,
              city,
              formattedAddress,
              placeId: place.place_id,
              location: location,
              name: place.name
            };

            setAddressDetails(addressData);
            onChange(formattedAddress);

            if (onLocationSelect) {
              onLocationSelect(addressData);
            }

            setShowPredictions(false);
          } else {
            console.error('Error getting place details:', status);
            toast({
              title: "Error",
              description: "Failed to get place details",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
          }
        }
      );
    } catch (error) {
      console.error('Error getting place details:', error);
      toast({
        title: "Error",
        description: "Failed to get place details",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Fermer les suggestions quand on clique en dehors
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setShowPredictions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Box position="relative" ref={inputRef}>
      <Input
        type="text"
        value={value || ''}
        onChange={handleInputChange}
        placeholder={placeholder}
        w="100%"
        onFocus={() => value && value.length > 2 && setShowPredictions(true)}
      />

      {showPredictions && predictions.length > 0 && (
        <List
          position="absolute"
          zIndex={1000}
          width="100%"
          bg="white"
          boxShadow="md"
          borderRadius="md"
          mt={1}
          maxH="200px"
          overflowY="auto"
        >
          {predictions.map((prediction) => (
            <ListItem
              key={prediction.place_id}
              p={2}
              cursor="pointer"
              _hover={{ bg: 'gray.100' }}
              onClick={() => handlePredictionClick(prediction)}
            >
              {prediction.description}
            </ListItem>
          ))}
        </List>
      )}

      {addressDetails && (
        <Text fontSize="sm" color="gray.500" mt={1}>
          {addressDetails.formattedAddress}
        </Text>
      )}
    </Box>
  );
};

export default function MissionSettings() {
  return (
    <GoogleMapsLoader>
      <MissionSettingsContent />
    </GoogleMapsLoader>
  );
}

// Déplacer tout le code d'état et logique ici (MissionSettingsContent)
function MissionSettingsContent() {
  const [tableData, setTableData] = useState([]);
  const [users, setUsers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const { hasPermission } = usePermissions();
  const [selectedId, setSelectedId] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [missionLocations, setMissionLocations] = useState({});
  const [currentUser, setCurrentUser] = useState(null);
  const cancelRef = useRef();
  const toast = useToast();
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const navigate = useNavigate();
  const { showStats } = useNavbarAction();
  const [viewMode, setViewMode] = useState('list');
  const callsContext = useCalls();

  // État pour la connexion téléphone (SIP)
  const [phoneExtension, setPhoneExtension] = useState('303');
  const [sipPassword, setSipPassword] = useState('');
  const [sipDomain, setSipDomain] = useState(''); // Domaine SIP optionnel (ex: pbx.local ou IP)
  const [isPhoneConnected, setIsPhoneConnected] = useState(false); // WebSocket connecté
  const {
    isOpen: isPhoneModalOpen,
    onOpen: onPhoneModalOpen,
    onClose: onPhoneModalClose,
  } = useDisclosure();

  // États pour le softphone WebRTC (JsSIP)
  const [sipUA, setSipUA] = useState(null);
  const [currentSipSession, setCurrentSipSession] = useState(null);
  const remoteAudioRef = useRef(null);
  const [dialNumber, setDialNumber] = useState('');
  const [incomingCall, setIncomingCall] = useState(null); // { session, from, channel }
  const [sipRegistered, setSipRegistered] = useState(false); // REGISTER SIP ok
  const incomingBeepRef = useRef(null);

  // Synchroniser le channel AMI depuis CallsContext quand un appel entrant arrive
  useEffect(() => {
    if (incomingCall?.session && callsContext?.incomingCall?.channel) {
      // Si on a déjà un incomingCall missions mais pas encore de channel, on l'ajoute
      if (!incomingCall.channel) {
        console.log('🔗 Ajout du channel AMI à l\'appel entrant:', callsContext.incomingCall.channel);
        setIncomingCall(prev => ({
          ...prev,
          channel: callsContext.incomingCall.channel
        }));
      }
    }
  }, [callsContext?.incomingCall, incomingCall]);

  // IP du PBX (adapter si nécessaire ou passer par config/env)
  const PBX_IP = '172.21.5.212';

  // Gestion des événements d'une session WebRTC
  function attachSessionEvents(session) {
    // Fonction pour attacher l'audio distant
    const attachRemoteAudio = () => {
      try {
        const pc = session.connection;
        if (!pc) {
          console.warn('⚠️ PeerConnection non disponible');
          return;
        }

        const remoteStream = new MediaStream();
        pc.getReceivers().forEach((receiver) => {
          if (receiver.track && receiver.track.kind === 'audio') {
            remoteStream.addTrack(receiver.track);
            console.log('🔊 Track audio distant ajouté:', receiver.track.id);
          }
        });

        if (remoteAudioRef.current && remoteStream.getAudioTracks().length > 0) {
          remoteAudioRef.current.srcObject = remoteStream;
          // Forcer la lecture de l'audio
          remoteAudioRef.current.play().catch((err) => {
            console.error('❌ Erreur lecture audio:', err);
            // Certains navigateurs nécessitent une interaction utilisateur
            toast({
              title: 'Audio activé',
              description: 'L\'audio devrait maintenant fonctionner.',
              status: 'info',
              duration: 2000,
              isClosable: true,
            });
          });
          console.log('✅ Audio distant attaché et lecture démarrée');
        } else {
          console.warn('⚠️ Aucun track audio distant trouvé ou élément audio manquant');
        }
      } catch (err) {
        console.error('❌ Erreur attachement audio distant:', err);
      }
    };

    // Nettoyage SDP pour éviter le conflit G726-32 (comme dans softphone.js)
    session.on('sdp', (e) => {
      console.log('   📝 SDP', e.type, '- length:', e.sdp?.length);

      if (e.sdp && e.type === 'offer') {
        let sdp = e.sdp;

        const lines = sdp.split('\r\n');
        const filteredLines = lines.filter(line => {
          if (line.match(/^a=rtpmap:2\s+G726/i)) {
            console.log('   🔧 Removing conflicting codec line:', line);
            return false;
          }
          return true;
        });

        // Remove payload type 2 from m=audio line
        e.sdp = filteredLines.map(line => {
          if (line.startsWith('m=audio')) {
            const fixed = line.replace(/\s+2(?=\s|$)/, '');
            if (fixed !== line) {
              console.log('   🔧 Fixed m=audio line, removed payload type 2');
            }
            return fixed;
          }
          return line;
        }).join('\r\n');

        console.log('   ✅ SDP cleaned');
      }
    });

    session.on('progress', () => {
      console.log('📞 Appel en progression (sonnerie)...');
    });

    session.on('accepted', () => {
      console.log('✅ Appel accepté par le destinataire');
    });

    // Écouter quand le stream local est créé par JsSIP
    session.on('peerconnection', (e) => {
      const pc = e.peerconnection;
      console.log('🔌 PeerConnection créé');

      // Écouter les changements d'état de la connexion
      pc.addEventListener('connectionstatechange', () => {
        const state = pc.connectionState;
        console.log('🔌 État connexion WebRTC:', state);
        if (state === 'failed') {
          console.error('❌ Connexion WebRTC échouée');
          console.error('  - Signaling state:', pc.signalingState);
          console.error('  - ICE connection state:', pc.iceConnectionState);
          console.error('  - ICE gathering state:', pc.iceGatheringState);
        } else if (state === 'connected') {
          console.log('✅ Connexion WebRTC établie');
        } else if (state === 'disconnected' || state === 'closed') {
          console.warn('⚠️ Connexion WebRTC déconnectée/fermée:', state);
          // Vérifier si la session est toujours active (pas encore terminée)
          if (session.status !== 8) { // 8 = STATUS_TERMINATED dans JsSIP
            console.log('🧹 Nettoyage de l\'appel suite à la fermeture de la connexion');
            // Utiliser setTimeout pour éviter les problèmes de closure
            setTimeout(() => {
              stopCallRecording();
              if (remoteAudioRef.current) {
                remoteAudioRef.current.srcObject = null;
              }
              setCurrentSipSession(prev => {
                // Nettoyer seulement si c'est bien cette session
                if (prev === session) {
                  return null;
                }
                return prev;
              });
              setIncomingCall(null);
              toast({
                title: 'Appel terminé',
                description: 'La connexion a été fermée.',
                status: 'info',
                duration: 3000,
                isClosable: true,
              });
            }, 100);
          }
        }
      });

      pc.addEventListener('iceconnectionstatechange', () => {
        const iceState = pc.iceConnectionState;
        console.log('🧊 État ICE:', iceState);
        if (iceState === 'failed') {
          console.error('❌ Connexion ICE échouée');
          console.error('  - Signaling state:', pc.signalingState);
          console.error('  - Connection state:', pc.connectionState);
          console.error('  - ICE gathering state:', pc.iceGatheringState);
        } else if (iceState === 'connected') {
          console.log('✅ Connexion ICE établie');
        } else if (iceState === 'disconnected' || iceState === 'closed') {
          console.warn('⚠️ Connexion ICE déconnectée/fermée:', iceState);
          // Si la session est toujours active, nettoyer après un court délai
          // (pour laisser le temps à l'événement 'ended' de se déclencher si c'est une fin normale)
          if (session.status !== 8) {
            setTimeout(() => {
              // Vérifier à nouveau si la session n'a pas été terminée entre-temps
              if (session.status !== 8) {
                console.log('🧹 Nettoyage de l\'appel suite à la fermeture ICE');
                stopCallRecording();
                if (remoteAudioRef.current) {
                  remoteAudioRef.current.srcObject = null;
                }
                setCurrentSipSession(prev => {
                  // Nettoyer seulement si c'est bien cette session
                  if (prev === session) {
                    return null;
                  }
                  return prev;
                });
                setIncomingCall(null);
                toast({
                  title: 'Appel terminé',
                  description: 'La connexion a été fermée.',
                  status: 'info',
                  duration: 3000,
                  isClosable: true,
                });
              }
            }, 500);
          }
        } else if (iceState === 'checking') {
          console.log('🔍 Vérification des candidats ICE...');
        }
      });

      pc.addEventListener('icegatheringstatechange', () => {
        console.log('🧊 État collecte ICE:', pc.iceGatheringState);
      });

      // Écouter les candidats ICE
      pc.addEventListener('icecandidate', (event) => {
        if (event.candidate) {
          console.log('🧊 Candidat ICE trouvé:', {
            candidate: event.candidate.candidate,
            sdpMLineIndex: event.candidate.sdpMLineIndex,
            sdpMid: event.candidate.sdpMid
          });
        } else {
          console.log('✅ Collecte des candidats ICE terminée');
        }
      });

      // Écouter les erreurs
      pc.addEventListener('icecandidateerror', (event) => {
        console.error('❌ Erreur candidat ICE:', {
          errorCode: event.errorCode,
          errorText: event.errorText,
          url: event.url,
          address: event.address,
          port: event.port
        });
      });

      // Écouter les erreurs de setRemoteDescription
      pc.addEventListener('negotiationneeded', () => {
        console.log('📡 Négociation WebRTC nécessaire');
      });

      // Écouter les erreurs générales
      pc.addEventListener('error', (event) => {
        console.error('❌ Erreur PeerConnection:', event);
      });
    });

    session.on('confirmed', () => {
      console.log('✅ Appel WebRTC connecté et confirmé');

      // Vérifier le stream local créé par JsSIP
      const localStream = session.localMediaStream;
      if (localStream) {
        console.log('🎤 Stream local JsSIP:', {
          id: localStream.id,
          active: localStream.active,
          tracksCount: localStream.getTracks().length
        });
        localStream.getAudioTracks().forEach(track => {
          console.log('  - Track local:', track.id, 'enabled:', track.enabled);
        });
      }

      // Attacher l'audio distant immédiatement
      attachRemoteAudio();

      // Démarrer l'enregistrement automatique de l'appel
      setTimeout(() => {
        startCallRecording(session);
      }, 1000); // Attendre 1 seconde pour que les tracks soient bien établis

      // Écouter les nouveaux tracks (au cas où ils arrivent après)
      const pc = session.connection;
      if (pc) {
        pc.addEventListener('track', (event) => {
          console.log('📡 Nouveau track reçu:', {
            kind: event.track.kind,
            id: event.track.id,
            enabled: event.track.enabled,
            readyState: event.track.readyState
          });
          if (event.track.kind === 'audio') {
            attachRemoteAudio();
          }
        });
      }
    });

    session.on('ended', (e) => {
      console.log('🔴 Appel WebRTC terminé (ended event)');
      console.log('   Cause:', e?.cause || 'N/A');
      console.log('   Message:', e?.message || 'N/A');

      // Arrêter l'enregistrement automatique
      stopCallRecording();

      // Nettoyer l'audio
      if (remoteAudioRef.current) {
        remoteAudioRef.current.srcObject = null;
      }

      // Nettoyer l'état
      setCurrentSipSession(null);
      setIncomingCall(null);

      toast({
        title: 'Appel terminé',
        description: 'L\'appel a été terminé.',
        status: 'info',
        duration: 3000,
        isClosable: true,
      });
    });

    session.on('failed', (e) => {
      const pc = session.connection;
      const connectionError = pc?._connectionPromiseQueue?.reason || null;

      console.error('❌ Appel WebRTC échoué:', {
        cause: e.cause,
        message: e.message,
        response: e.response,
        error: e.error,
        connectionError: connectionError,
        pcState: pc?.connectionState,
        iceState: pc?.iceConnectionState,
        session: session
      });

      // Si l'erreur vient de setRemoteDescription, afficher plus de détails
      if (connectionError && connectionError.message && connectionError.message.includes('setRemoteDescription')) {
        console.error('❌ Erreur setRemoteDescription détectée:', connectionError);
        console.error('  - Détails:', {
          name: connectionError.name,
          message: connectionError.message,
          stack: connectionError.stack
        });

        // Essayer de récupérer le SDP pour diagnostic
        if (pc) {
          const localSdp = pc.localDescription?.sdp || 'N/A';
          const remoteSdp = pc.remoteDescription?.sdp || 'N/A';

          console.error('  - Local Description (premiers 500 chars):', localSdp.substring(0, 500));
          console.error('  - Remote Description (premiers 500 chars):', remoteSdp.substring(0, 500));

          // Analyser le SDP distant pour voir les codecs
          if (remoteSdp !== 'N/A') {
            const audioCodecs = remoteSdp.match(/m=audio.*\r\n([\s\S]*?)(?=m=|$)/)?.[1] || '';
            const videoCodecs = remoteSdp.match(/m=video.*\r\n([\s\S]*?)(?=m=|$)/)?.[1] || '';
            console.error('  - Codecs audio dans SDP distant:', audioCodecs.substring(0, 300));
            if (videoCodecs) {
              console.error('  - ⚠️ Codecs vidéo détectés dans SDP (peut causer problème):', videoCodecs.substring(0, 300));
            }
          }

          // Vérifier l'état de signalisation
          console.error('  - Signaling state:', pc.signalingState);
          console.error('  - Connection state:', pc.connectionState);
          console.error('  - ICE connection state:', pc.iceConnectionState);
        }

        // Essayer de récupérer le SDP de la requête INVITE
        const request = session._request;
        if (request && request.body) {
          const inviteSdp = request.body;
          console.error('  - SDP de la requête INVITE (longueur:', inviteSdp.length, ')');
          console.error('  - SDP INVITE (premiers 1000 chars):', inviteSdp.substring(0, 1000));

          // Analyser le SDP INVITE
          const videoMatches = inviteSdp.match(/m=video[\s\S]*?(?=m=|$)/g);
          if (videoMatches) {
            console.error('  - ⚠️ Blocs vidéo trouvés dans SDP INVITE:', videoMatches.length);
            videoMatches.forEach((match, idx) => {
              console.error(`    Bloc vidéo ${idx + 1} (premiers 200 chars):`, match.substring(0, 200));
            });
          }

          const bundleLine = inviteSdp.match(/a=group:BUNDLE.*/);
          if (bundleLine) {
            console.error('  - Ligne BUNDLE:', bundleLine[0]);
          }
        }

        // Essayer de récupérer l'erreur exacte de setRemoteDescription
        if (connectionError) {
          try {
            const errorDetails = {
              name: connectionError.name,
              message: connectionError.message,
              errorDetail: connectionError.errorDetail,
              sdpLineNumber: connectionError.sdpLineNumber,
              sdp: connectionError.sdp
            };
            console.error('  - Détails complets de l\'erreur setRemoteDescription:', errorDetails);
          } catch (err) {
            console.error('  - Impossible d\'extraire les détails de l\'erreur:', err);
          }
        }
      }

      // Arrêter l'enregistrement automatique
      stopCallRecording();

      // Nettoyer l'audio
      if (remoteAudioRef.current) {
        remoteAudioRef.current.srcObject = null;
      }

      // Arrêter les tracks locaux
      try {
        if (pc) {
          pc.getSenders().forEach(sender => {
            if (sender.track) {
              sender.track.stop();
            }
          });
        }
      } catch (err) {
        console.warn('Erreur nettoyage tracks:', err);
      }

      setCurrentSipSession(null);
      setIncomingCall(null);

      // Afficher un message d'erreur plus détaillé
      let errorMsg = `Erreur WebRTC: ${e.cause || 'Inconnue'}`;
      if (e.cause === 'WebRTC Error') {
        if (connectionError && connectionError.message && connectionError.message.includes('setRemoteDescription')) {
          errorMsg = 'Erreur de négociation SDP (setRemoteDescription). Cela peut être dû à un problème de codec audio ou de configuration du PBX. Vérifiez que le PBX supporte les codecs WebRTC (Opus, PCMU, PCMA).';
        } else {
          errorMsg = 'Erreur de connexion WebRTC. Vérifiez votre connexion réseau et les paramètres du PBX.';
        }
      } else if (e.cause === 'Not Acceptable') {
        errorMsg = 'Le codec audio n\'est pas supporté. Vérifiez la configuration du PBX (codecs: Opus, PCMU, PCMA).';
      } else if (e.cause === 'Request Timeout') {
        errorMsg = 'Timeout: Le serveur n\'a pas répondu à temps.';
      }

      toast({
        title: '❌ Appel échoué',
        description: errorMsg,
        status: 'error',
        duration: 7000,
        isClosable: true,
      });
    });
  }

  // Fonction pour démarrer l'enregistrement automatique d'un appel WebRTC
  const startCallRecording = async (session) => {
    try {
      const pc = session.connection;
      if (!pc) {
        console.warn('⚠️ Pas de PeerConnection pour l\'enregistrement');
        return;
      }

      console.log('🎙️ Démarrage de l\'enregistrement automatique de l\'appel...');

      // Récupérer les tracks audio locaux (notre micro)
      const senders = pc.getSenders();
      const localAudioTrack = senders.find(s => s.track && s.track.kind === 'audio')?.track;

      // Récupérer les tracks audio distants (leur voix)
      const receivers = pc.getReceivers();
      const remoteAudioTrack = receivers.find(r => r.track && r.track.kind === 'audio')?.track;

      if (!localAudioTrack && !remoteAudioTrack) {
        console.warn('⚠️ Aucun track audio trouvé pour l\'enregistrement');
        return;
      }

      // Créer un AudioContext pour mixer les deux streams
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const destination = audioContext.createMediaStreamDestination();

      // Ajouter l'audio local
      if (localAudioTrack) {
        const localStream = new MediaStream([localAudioTrack]);
        const localSource = audioContext.createMediaStreamSource(localStream);
        localSource.connect(destination);
        console.log('🎤 Audio local ajouté à l\'enregistrement');
      }

      // Ajouter l'audio distant
      if (remoteAudioTrack) {
        const remoteStream = new MediaStream([remoteAudioTrack]);
        const remoteSource = audioContext.createMediaStreamSource(remoteStream);
        remoteSource.connect(destination);
        console.log('🔊 Audio distant ajouté à l\'enregistrement');
      }

      // Créer le MediaRecorder
      const recordingStream = destination.stream;
      callRecordingStreamRef.current = recordingStream;
      const chunks = [];
      callRecordingChunksRef.current = chunks;

      const mimeType = MediaRecorder.isTypeSupported('audio/webm;codecs=opus')
        ? 'audio/webm;codecs=opus'
        : MediaRecorder.isTypeSupported('audio/webm')
          ? 'audio/webm'
          : 'audio/ogg';

      const recorder = new MediaRecorder(recordingStream, { mimeType });

      recorder.ondataavailable = (event) => {
        if (event.data && event.data.size > 0) {
          chunks.push(event.data);
          callRecordingChunksRef.current = [...chunks];
        }
      };

      recorder.onstop = async () => {
        console.log('🎙️ Enregistrement arrêté, chunks:', chunks.length);
        await saveCallRecording(session, chunks, mimeType);
        // Nettoyer
        audioContext.close();
        callRecordingStreamRef.current = null;
        callRecordingChunksRef.current = [];
        callRecordingRef.current = null;
      };

      recorder.start(1000); // Enregistrer par chunks de 1 seconde
      callRecordingRef.current = recorder;
      console.log('✅ Enregistrement automatique démarré');

    } catch (error) {
      console.error('❌ Erreur lors du démarrage de l\'enregistrement:', error);
    }
  };

  // Fonction pour arrêter l'enregistrement et sauvegarder
  const stopCallRecording = async () => {
    console.log('🎙️ stopCallRecording appelé');
    const recorder = callRecordingRef.current;
    if (recorder && recorder.state !== 'inactive') {
      try {
        console.log('🎙️ Arrêt de l\'enregistrement (état actuel:', recorder.state, ')...');
        recorder.stop();
        console.log('✅ stop() appelé sur MediaRecorder');
      } catch (error) {
        console.error('❌ Erreur lors de l\'arrêt de l\'enregistrement:', error);
        callRecordingRef.current = null;
        callRecordingChunksRef.current = [];
        callRecordingStreamRef.current = null;
      }
    } else {
      console.log('⚠️ Pas d\'enregistrement actif à arrêter (callRecordingRef:', !!recorder, ', état:', recorder?.state || 'N/A', ')');
    }
  };

  // Fonction pour sauvegarder l'enregistrement sur le serveur FTP
  const saveCallRecording = async (session, chunks, mimeType) => {
    try {
      if (chunks.length === 0) {
        console.warn('⚠️ Aucun chunk d\'enregistrement à sauvegarder');
        return;
      }

      const blob = new Blob(chunks, { type: mimeType });
      console.log('💾 Taille de l\'enregistrement:', Math.round(blob.size / 1024), 'KB');

      // Générer le nom de fichier
      const caller = session.remote_identity?.uri?.user || 'unknown';
      const extension = phoneExtension || 'unknown';
      const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
      const direction = session.direction === 'incoming' ? 'incoming' : 'outgoing';
      const filename = `appel_${extension}_${caller}_${direction}_${timestamp}.webm`;

      // Convertir en base64
      const reader = new FileReader();
      reader.onloadend = async () => {
        try {
          const base64Audio = reader.result; // Garder le format complet (data:audio/webm;base64,...)

          // Envoyer au serveur via l'API /api/audio/upload
          // Les cookies (incluant le token) sont envoyés automatiquement avec credentials: 'include'
          const response = await fetch(`${BASE_URL}/api/audio/upload`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include', // Envoie automatiquement les cookies (token)
            body: JSON.stringify({
              audioData: base64Audio,
              filename: filename,
              date: new Date().toISOString(),
            }),
          });

          const result = await response.json();

          if (result.success || response.ok) {
            console.log('✅ Enregistrement sauvegardé sur le serveur FTP:', result.remotePath || result.filename || filename);
            toast({
              title: 'Enregistrement sauvegardé',
              description: `Fichier: ${result.remotePath || result.filename || filename}`,
              status: 'success',
              duration: 5000,
              isClosable: true,
            });
          } else {
            console.error('❌ Échec de la sauvegarde:', result.error || result.message);
            toast({
              title: 'Erreur sauvegarde',
              description: result.error || result.message || 'Impossible de sauvegarder l\'enregistrement',
              status: 'error',
              duration: 5000,
              isClosable: true,
            });
          }
        } catch (error) {
          console.error('❌ Erreur lors de l\'envoi de l\'enregistrement:', error);
          toast({
            title: 'Erreur',
            description: 'Impossible d\'envoyer l\'enregistrement au serveur',
            status: 'error',
            duration: 5000,
            isClosable: true,
          });
        }
      };

      reader.readAsDataURL(blob);
    } catch (error) {
      console.error('❌ Erreur lors de la sauvegarde de l\'enregistrement:', error);
    }
  };

  // Vérification de la session et du rôle (via cookie httpOnly auth_token)
  useEffect(() => {
    const checkTokenAndUser = async () => {
      try {
        // 1. Vérifier la validité de la session
        const check = await checkToken(); // le backend lit le cookie
        if (!check.data.valid) {
          navigate('/auth/sign-in');
          return;
        }

        // 2. Récupérer les infos utilisateur
        const user = await getUser(); // le backend lit le cookie
        setCurrentUser(user); // Stocker l'utilisateur actuel
        const userRole = user.rôle || user['rÃ´le'] || user.role;
        if (
          userRole !== 'admin' &&
          userRole !== 'régulateur' &&
          userRole !== 'rÃ©gulateur' &&
          userRole !== 'médecin regulateur' &&
          userRole !== 'medecin regulateur'
        ) {
          navigate('/auth/sign-in');
          return;
        }

        // Si tout est ok, on charge les données
        fetchData();
      } catch (error) {
        console.error("Error:", error);
        navigate('/auth/sign-in');
      }
    };
    checkTokenAndUser();
  }, [navigate]);

  // Demander la permission pour les notifications système
  useEffect(() => {
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          console.log('Notification permission granted');
        } else {
          console.log('Notification permission denied');
        }
      });
    }
  }, []);

  // Add effect to check URL parameters and open chat
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const openChatId = params.get('openChat');

    if (openChatId) {
      handleOpenChat(openChatId);
      // Remove the parameter from URL without refreshing the page
      window.history.replaceState({}, '', '/admin/missions');
    }
  }, [tableData]); // Add tableData as dependency to ensure it's available

  // Edit Modal
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const [editData, setEditData] = useState(null);
  const [initialData, setInitialData] = useState(null);
  const [unsaved, setUnsaved] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isActionsMenuOpen, setIsActionsMenuOpen] = useState(false);

  // Fonction pour fermer le modal d'édition et réinitialiser editData
  const handleEditClose = () => {
    setEditData(null);
    setInitialData(null);
    onEditClose();
  };

  // Add Modal
  const {
    isOpen: isAddOpen,
    onOpen: onAddOpen,
    onClose: onAddClose,
  } = useDisclosure();

  // Stepper state
  const steps = [
    { title: 'Type de Mission', description: 'Sélectionnez le type' },
    { title: 'Informations générales', description: 'Détails initiaux' },
    { title: 'Patient', description: 'Infos du patient' },
    { title: 'Confirmation', description: 'Validation' },
  ];
  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: steps.length,
  });
  const [createdMissionId, setCreatedMissionId] = useState(null);

  // Fonction pour fermer le modal d'ajout et réinitialiser newMissionData
  const handleAddClose = () => {
    setNewMissionData({
      type_mission: "",
      cause: "",
      date_mission: dayjs().tz('Africa/Casablanca').format('YYYY-MM-DDTHH:mm'),
      adresse: "",
      adresse_destination: null,
      bon_de_commande: "",
      demande_materiel: "",
      patient_id: "",
      doctor_id: "",
      ambulance_id: "",
      statut: "créée",
      prix: "0",
      paiement: "espèces",
      paye: 0,
      ville: "",
      type_ambulance: "",
      ambulancier_id: "",
      nurse_id: "",
      nurse_type: "",
      etat_mission: "urgente",
      urgence: true,
      add_new_patient: false,
      type_client: "particulier",
      perimetre: '',
      loc: "",
      new_patient: {
        nom: "",
        prenom: "",
        téléphone: "",
        adresse: "",
        ville: "",
        type_client: "B2C",
        client_id: ""
      }
    });
    setInvalidFields({});
    setAvailableAmbulanciers([]);
    setActiveStep(0);
    setCreatedMissionId(null);
    onAddClose();
  };
  const [newMissionData, setNewMissionData] = useState({
    type_mission: "Téléconsultation",
    cause: "",
    date_mission: dayjs().tz('Africa/Casablanca').format('YYYY-MM-DDTHH:mm'),
    adresse: "",
    adresse_destination: null,
    bon_de_commande: "",
    demande_materiel: "",
    patient_id: "",
    doctor_id: "",
    ambulance_id: "",
    statut: "créée",
    prix: "0",
    paiement: "espèces",
    paye: 0,
    ville: "",
    type_ambulance: "",
    ambulancier_id: "",
    nurse_id: "",
    nurse_type: "",
    etat_mission: "urgente",
    urgence: true,
    add_new_patient: false,
    client_id: "",
    type_client: "particulier", // Ajout du type_client par défaut
    perimetre: '',
    loc: "",
    correspondance: "",
    correspondance_details: "",
    new_patient: {
      nom: "",
      prenom: "",
      téléphone: "",
      adresse: "",
      ville: "",
      type_client: "B2C",
      client_id: ""
    }

  });

  const [uniqueVilles, setUniqueVilles] = useState([]);
  const [filteredAmbulances, setFilteredAmbulances] = useState([]);

  // Add this function to fetch vehicles and extract unique villes
  const fetchVehicles = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/vehicules`, {
        withCredentials: true
      });
      setVehicles(response.data);

      // Extract unique villes
      const villes = [...new Set(response.data.map(vehicle => vehicle.ville))];
      setUniqueVilles(villes);
    } catch (err) {
      console.error("Error fetching vehicles:", err);
      toast({
        title: "Error",
        description: "Failed to fetch vehicles",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Add this useEffect to fetch vehicles on component mount
  useEffect(() => {
    fetchVehicles();
  }, []);

  // Add this useEffect to filter ambulances when ville changes
  useEffect(() => {
    if (newMissionData.ville) {
      let filtered;
      if (newMissionData.type_ambulance) {
        // Si le type d'ambulance est sélectionné, filtrer par ville ET type
        filtered = vehicles.filter(vehicle =>
          vehicle.ville?.trim().toLowerCase() === newMissionData.ville?.trim().toLowerCase() &&
          vehicle.type_vehicule === newMissionData.type_ambulance
        );
      } else {
        // Si le type d'ambulance n'est pas encore sélectionné, filtrer seulement par ville
        filtered = vehicles.filter(vehicle =>
          vehicle.ville?.trim().toLowerCase() === newMissionData.ville?.trim().toLowerCase()
        );
      }
      setFilteredAmbulances(filtered);
    } else {
      setFilteredAmbulances([]);
    }
  }, [newMissionData.ville, newMissionData.type_ambulance, vehicles]);

  const {
    isOpen: isAlertOpen,
    onOpen: onAlertOpen,
    onClose: onAlertClose,
  } = useDisclosure();

  // View Modal
  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  const [availableAmbulanciers, setAvailableAmbulanciers] = useState([]);
  const [patients, setPatients] = useState([]);
  const [searchPatient, setSearchPatient] = useState("");

  const [doctors, setDoctors] = useState([]);
  const [nurses, setNurses] = useState([]); // Add state for nurses

  // Add function to fetch nurses
  const fetchNurses = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/users`, {
        withCredentials: true
      });

      const normalize = (value) => {
        if (!value || typeof value !== 'string') return '';
        return value
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      };

      const nursesList = res.data.filter(user => {
        const roleRaw = user.rôle ?? user.role ?? user['rÃ´le'];
        const role = normalize(roleRaw);
        return role === 'infirmier' || role === 'infirmiere' || role === 'nurse';
      });

      setNurses(nursesList);
    } catch (err) {
      console.error("Error fetching nurses:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Error fetching nurses", status: "error", isClosable: true });
    }
  };

  // Add useEffect to fetch nurses
  useEffect(() => {
    fetchNurses();
  }, []);

  // Add state for mission planning confirmation
  const [missionConfirmationData, setMissionConfirmationData] = useState(null);
  const {
    isOpen: isMissionConfirmationOpen,
    onOpen: onMissionConfirmationOpen,
    onClose: onMissionConfirmationClose,
  } = useDisclosure();

  // Add chat states
  const [chatMessages, setChatMessages] = useState({});
  const [newMessage, setNewMessage] = useState("");
  const [openChats, setOpenChats] = useState({});
  const [socket, setSocket] = useState(null);
  const messagesEndRef = useRef(null);
  const imageInputRef = useRef(null);
  const audioInputRef = useRef(null);
  const [selectedMission, setSelectedMission] = useState(null);
  const [messages, setMessages] = useState([]);
  const [user, setUser] = useState(null);
  const [decodedUser, setDecodedUser] = useState(null);

  // Audio recording states
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [recordedChunks, setRecordedChunks] = useState([]);

  // État pour l'image collée depuis le presse-papier
  const [pastedImage, setPastedImage] = useState(null); // { dataUrl, missionId }

  // États pour l'enregistrement automatique des appels WebRTC
  // Utiliser useRef pour éviter les problèmes de closure dans les callbacks
  const callRecordingRef = useRef(null);
  const callRecordingChunksRef = useRef([]);
  const callRecordingStreamRef = useRef(null);

  // Notification sound states (basé sur NavbarLinksAdmin.js)
  const [notificationSound] = useState(new Audio('/notification.mp3'));
  const [playedSoundForMessages, setPlayedSoundForMessages] = useState(new Set());
  const [hasUserInteracted, setHasUserInteracted] = useState(false);

  // Ajouter un nouvel état pour stocker le dernier message ID
  const [lastMessageIds, setLastMessageIds] = useState({});

  // Ajouter un nouvel état pour gérer les chats minimisés
  const [minimizedChats, setMinimizedChats] = useState({});

  // Ajouter un nouvel état pour les messages non lus
  const [unreadMessages, setUnreadMessages] = useState({});

  // Ajouter un état pour stocker les messages non lus par mission
  const [unreadMessagesByMission, setUnreadMessagesByMission] = useState({});

  // États pour la prévisualisation d'image
  const { isOpen: isImagePreviewOpen, onOpen: onImagePreviewOpen, onClose: onImagePreviewClose } = useDisclosure();
  const [previewImageUrl, setPreviewImageUrl] = useState("");

  const handlePreviewImage = (url) => {
    setPreviewImageUrl(url);
    onImagePreviewOpen();
  };

  const downloadImage = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = `image_${new Date().getTime()}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Créer une référence stable pour les données de la table
  const tableDataRef = useRef(tableData);
  const unreadMessagesRef = useRef(unreadMessagesByMission);

  // Mettre à jour les références quand les données changent
  useEffect(() => {
    tableDataRef.current = tableData;
  }, [tableData]);

  useEffect(() => {
    unreadMessagesRef.current = unreadMessagesByMission;
  }, [unreadMessagesByMission]);

  // Ajouter un useEffect pour détecter l'interaction utilisateur (basé sur NavbarLinksAdmin.js)
  useEffect(() => {
    const handleUserInteraction = () => {
      setHasUserInteracted(true);
      // Supprimer les écouteurs après la première interaction
      document.removeEventListener('click', handleUserInteraction);
      document.removeEventListener('keydown', handleUserInteraction);
    };

    document.addEventListener('click', handleUserInteraction);
    document.addEventListener('keydown', handleUserInteraction);

    return () => {
      document.removeEventListener('click', handleUserInteraction);
      document.removeEventListener('keydown', handleUserInteraction);
    };
  }, []);

  // Précharger les sons (basé sur NavbarLinksAdmin.js)
  useEffect(() => {
    notificationSound.load();
  }, [notificationSound]);

  // Modifier le useEffect pour le polling des messages
  useEffect(() => {
    let isMounted = true;
    let pollingInterval = null;

    const fetchNewMessages = async () => {
      if (!isMounted) return;

      try {

        // Récupérer uniquement les messages pour les chats ouverts
        const openChatIds = Object.keys(openChats).filter(id => openChats[id]);

        // Utiliser Promise.all pour récupérer les messages en parallèle
        await Promise.all(openChatIds.map(async (missionId) => {
          if (!isMounted) return;

          try {
            const response = await getMessages(missionId);

            // Transformer les messages
            const transformedMessages = response.data.map(message => ({
              ...message,
              user_id: message.sender_id,
              content: message.message,
              media_data: message.media_data,
              type: message.type,
              user_name: `${message.nom} ${message.prenom}`,
              user_photo: message.photo
            }));

            // Mettre à jour uniquement les messages pour le chat ouvert
            setChatMessages(prev => {
              const currentMessages = prev[missionId] || [];
              const newMessages = transformedMessages.filter(newMsg =>
                !currentMessages.some(existingMsg => existingMsg.id === newMsg.id)
              );

              if (newMessages.length === 0) return prev;

              return {
                ...prev,
                [missionId]: [...currentMessages, ...newMessages]
              };
            });

            // Faire défiler vers le bas pour le chat actif
            if (!minimizedChats[missionId]) {
              setTimeout(scrollToBottom, 100);
            }
          } catch (error) {
            console.error(`Error fetching messages for mission ${missionId}:`, error);
          }
        }));
      } catch (error) {
        console.error('Error in polling:', error);
      }
    };

    // Démarrer le polling uniquement si des chats sont ouverts (fallback si le socket échoue)
    const startPolling = () => {
      if (Object.values(openChats).some(isOpen => isOpen)) {
        fetchNewMessages(); // Exécuter immédiatement
        pollingInterval = setInterval(fetchNewMessages, 15000);
      }
    };

    // Arrêter le polling si aucun chat n'est ouvert
    const stopPolling = () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
        pollingInterval = null;
      }
    };

    // Gérer le polling en fonction de l'état des chats
    if (Object.values(openChats).some(isOpen => isOpen)) {
      startPolling();
    } else {
      stopPolling();
    }

    // Nettoyer l'intervalle et le flag isMounted
    return () => {
      isMounted = false;
      stopPolling();
    };
  }, [openChats, minimizedChats]);

  // Modifier le useEffect pour les messages non lus
  useEffect(() => {
    let isMounted = true;
    let unreadInterval = null;

    const fetchUnreadMessages = async () => {
      if (!isMounted) return;

      try {
        const response = await getUnreadMessagesCounts();
        const unreadCounts = response.data;

        // Mettre à jour l'état uniquement si les valeurs ont changé
        setUnreadMessagesByMission(prev => {
          const hasChanges = Object.keys(unreadCounts).some(key =>
            prev[key] !== unreadCounts[key]
          ) || Object.keys(prev).some(key =>
            !unreadCounts.hasOwnProperty(key) && prev[key] > 0
          );

          if (hasChanges) {
            return unreadCounts;
          }
          return prev;
        });
      } catch (error) {
        console.error('Error fetching unread messages counts:', error);
      }
    };

    const startPolling = () => {
      fetchUnreadMessages();
      unreadInterval = setInterval(fetchUnreadMessages, 15000);
    };
    startPolling();

    return () => {
      isMounted = false;
      if (unreadInterval) clearInterval(unreadInterval);
    };
  }, [decodedUser]);

  // Fonction pour rejoindre automatiquement toutes les missions de l'utilisateur
  const joinUserMissions = async (socket) => {
    try {
      if (!decodedUser || !socket) return;

      const userRole = decodedUser.rôle || decodedUser['rÃ´le'] || decodedUser.role;
      let accessibleMissions = [];

      if (
        userRole === 'admin' ||
        userRole === 'régulateur' ||
        userRole === 'rÃ©gulateur' ||
        userRole === 'médecin regulateur' ||
        userRole === 'medecin regulateur'
      ) {
        // Admin/régulateur peuvent accéder à toutes les missions
        const missionsRes = await axios.get(`${BASE_URL}/missions/my-missions`, {
          withCredentials: true
        });
        accessibleMissions = missionsRes.data.map(m => m.id);
      } else {
        // Pour les autres rôles, utiliser la nouvelle route qui filtre côté serveur
        const missionsRes = await axios.get(`${BASE_URL}/missions/my-missions`, {
          withCredentials: true
        });
        accessibleMissions = missionsRes.data.map(m => m.id);
      }

      // Rejoindre chaque mission
      accessibleMissions.forEach(missionId => {
        socket.emit('join_mission', { missionId });
        console.log(`Joined mission room: ${missionId}`);
      });

      console.log(`User joined ${accessibleMissions.length} mission rooms for notifications`);
    } catch (error) {
      console.error('Error joining user missions:', error);
    }
  };

  const openChatsRef = useRef(openChats);
  const minimizedChatsRef = useRef(minimizedChats);
  const decodedUserRef = useRef(decodedUser);
  const playedSoundRef = useRef(playedSoundForMessages);

  useEffect(() => {
    openChatsRef.current = openChats;
  }, [openChats]);

  useEffect(() => {
    minimizedChatsRef.current = minimizedChats;
  }, [minimizedChats]);

  useEffect(() => {
    decodedUserRef.current = decodedUser;
  }, [decodedUser]);

  useEffect(() => {
    playedSoundRef.current = playedSoundForMessages;
  }, [playedSoundForMessages]);

  useEffect(() => {
    const newSocket = io(getSocketServerUrl(), {
      withCredentials: true,
      transports: ['websocket'], // Utiliser directement websocket pour la rapidité
      upgrade: true,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      timeout: 20000
    });

    newSocket.on('connect', () => {
      console.log('Socket connected');
    });

    newSocket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
      if (error.message.includes('authentication')) {
        navigate('/auth/sign-in');
      }
    });

    newSocket.on('disconnect', (reason) => {
      if (reason === 'io server disconnect') {
        newSocket.connect();
      }
    });

    newSocket.on('message', (message) => {
      try {
        const currentUser = decodedUserRef.current;
        const currentOpenChats = openChatsRef.current;
        const currentMinimizedChats = minimizedChatsRef.current;

        const transformedMessage = {
          ...message,
          user_id: message.sender_id,
          content: message.message,
          media_data: message.media_data,
          type: message.type,
          user_name: `${message.nom} ${message.prenom}`,
          user_photo: message.photo
        };

        // Mettre à jour les messages uniquement pour la mission concernée
        setChatMessages(prev => {
          const currentMessages = prev[message.mission_id] || [];
          const messageExists = currentMessages.some(m => m.id === transformedMessage.id);
          if (messageExists) {
            return prev;
          }
          return {
            ...prev,
            [message.mission_id]: [...currentMessages, transformedMessage]
          };
        });

        // Mettre à jour les messages non lus uniquement si le chat n'est pas ouvert
        if (!currentOpenChats[message.mission_id] && message.sender_id !== currentUser?.id) {
          setUnreadMessagesByMission(prev => ({
            ...prev,
            [message.mission_id]: (prev[message.mission_id] || 0) + 1
          }));

          // Vérifier les nouveaux messages non lus
          if (!playedSoundRef.current.has(message.id)) {
            try {
              notificationSound.currentTime = 0;
              notificationSound.play().catch(error => {
                console.error('Error playing notification sound:', error);
              });

              setPlayedSoundForMessages(prev => {
                const newSet = new Set(prev);
                newSet.add(message.id);
                return newSet;
              });
            } catch (error) {
              console.error('Error with notification sound:', error);
            }
          }

          toast({
            title: "Nouveau message",
            description: `Message de ${transformedMessage.user_name} dans la mission #${message.mission_id}`,
            status: "info",
            duration: 3000,
            isClosable: true,
          });

          if (Notification.permission === 'granted') {
            const notification = new Notification('Nouveau message', {
              body: `Message de ${transformedMessage.user_name} dans la mission #${message.mission_id}`,
              icon: '/favicon.ico',
              tag: `mission-${message.mission_id}`,
              requireInteraction: false
            });

            setTimeout(() => {
              notification.close();
            }, 50000);

            notification.onclick = () => {
              handleOpenChat(message.mission_id);
              window.focus();
              notification.close();
            };
          }
        } else if (currentOpenChats[message.mission_id] && !currentMinimizedChats[message.mission_id]) {
          setTimeout(scrollToBottom, 100);
        }
      } catch (error) {
        console.error('Error processing new message:', error);
      }
    });

    setSocket(newSocket);

    return () => {
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, [navigate]);

  // useEffect pour rejoindre automatiquement les missions quand socket et user sont disponibles
  useEffect(() => {
    if (socket && decodedUser) {
      joinUserMissions(socket);
    }
  }, [socket, decodedUser]);

  // Gérer le bip d'appel entrant uniquement quand la popup missions est affichée
  useEffect(() => {
    // Si on a un appel entrant (popup visible) et pas encore de session connectée
    if (incomingCall && !currentSipSession && !incomingBeepRef.current) {
      const playBeep = () => {
        try {
          const AudioCtx = window.AudioContext || window.webkitAudioContext;
          if (!AudioCtx) return;
          const ctx = new AudioCtx();
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.connect(gain);
          gain.connect(ctx.destination);
          osc.frequency.value = 440;
          gain.gain.value = 0.2;
          osc.start();
          osc.stop(ctx.currentTime + 0.2);
          osc.onended = () => {
            try {
              ctx.close();
            } catch (e) { }
          };
        } catch (e) {
          console.warn('Erreur bip appel entrant:', e);
        }
      };

      // Bip immédiat puis toutes les 2s tant que la popup est là
      playBeep();
      incomingBeepRef.current = setInterval(playBeep, 2000);
    }

    // Si plus d'appel entrant ou session en cours, on coupe le bip
    if ((!incomingCall || currentSipSession) && incomingBeepRef.current) {
      clearInterval(incomingBeepRef.current);
      incomingBeepRef.current = null;
    }

    // Nettoyage à l'unmount
    return () => {
      if (incomingBeepRef.current) {
        clearInterval(incomingBeepRef.current);
        incomingBeepRef.current = null;
      }
    };
  }, [incomingCall, currentSipSession]);

  // Modifier la fonction scrollToBottom pour être plus robuste
  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end"
      });
    }
  };

  // Ajouter un useEffect pour gérer le défilement automatique
  useEffect(() => {
    Object.keys(openChats).forEach(missionId => {
      if (openChats[missionId] && !minimizedChats[missionId]) {
        setTimeout(scrollToBottom, 100);
      }
    });
  }, [chatMessages, minimizedChats, openChats]);

  // Modifier la fonction handleOpenChat pour gérer correctement l'ouverture/fermeture
  const handleOpenChat = async (missionId) => {
    try {
      // Si le chat est ouvert mais minimisé, on le maximise
      if (openChats[missionId] && minimizedChats[missionId]) {
        setMinimizedChats(prev => ({
          ...prev,
          [missionId]: false
        }));
        return;
      }

      // Si le chat n'est pas ouvert, on l'ouvre
      if (!openChats[missionId]) {
        // Récupérer les messages
        const messagesResponse = await axios.get(`${BASE_URL}/messages/${missionId}`, {
          withCredentials: true
        });



        // Marquer tous les messages comme lus en un seul appel
        await markAllMessagesRead(missionId);

        // Réinitialiser les messages non lus pour cette mission
        setUnreadMessagesByMission(prev => ({
          ...prev,
          [missionId]: 0
        }));

        // Réinitialiser les messages pour lesquels on a joué le son
        // setPlayedSoundForMessages(prev => {
        //   const newSet = new Set(prev);
        //   messagesResponse.data.forEach(msg => newSet.delete(msg.id));
        //   return newSet;
        // });

        const transformedMessages = messagesResponse.data.map(message => ({
          ...message,
          user_id: message.sender_id,
          content: message.message,
          media_data: message.media_data,
          type: message.type,
          user_name: `${message.nom} ${message.prenom}`,
          user_photo: message.photo
        }));

        setChatMessages(prev => ({
          ...prev,
          [missionId]: transformedMessages
        }));

        setOpenChats(prev => ({
          ...prev,
          [missionId]: true
        }));

        // Rejoindre la room socket pour cette mission
        if (socket) {
          socket.emit('join_mission', { missionId });
        }

        // Faire défiler vers le bas pour voir les messages
        setTimeout(scrollToBottom, 100);
      }
    } catch (err) {
      console.error('Error fetching messages:', err);
      toast({ title: "Error loading messages", status: "error", isClosable: true });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // Récupérer l'utilisateur connecté depuis le localStorage
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setUser(storedUser);
      setDecodedUser(storedUser);
    }
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);

      const [missionsRes, usersRes, vehiclesRes] = await Promise.all([
        axios.get(`${BASE_URL}/missions`, {
          withCredentials: true
        }),
        axios.get(`${BASE_URL}/users`, {
          withCredentials: true
        }),
        axios.get(`${BASE_URL}/vehicules`, {
          withCredentials: true
        })
      ]);

      // Trier les missions par date_mission en ordre décroissant
      const sortedMissions = missionsRes.data.sort((a, b) => {
        return new Date(b.date_mission) - new Date(a.date_mission);
      });

      setUsers(usersRes.data);
      setVehicles(vehiclesRes.data);
      setTableData(sortedMissions);
    } catch (err) {
      console.error("Fetch error:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Error fetching data", status: "error", isClosable: true });
    } finally {
      setLoading(false);
    }
  };

  const getAmbulancierName = (userId) => {

    const user = users.find(u => u.id == userId);

    return user ? `${user.nom} ${user.prenom}` : 'N/A';
  };

  const getVehicleTypeByAmbulancier = async (ambulancierId) => {
    try {
      const res = await axios.get(`${BASE_URL}/vehicules?user_id=${ambulancierId}`, {
        withCredentials: true
      });

      return res.data[0]?.type_vehicule || 'N/A';
    } catch (err) {
      console.error("Error fetching vehicle type:", err);
      return 'N/A';
    }
  };

  // View handler
  const handleView = async (mission) => {
    // Rediriger vers la page de détails
    navigate(`/admin/missions/${mission.id}`);
  };

  // Handle file upload for piece jointe
  const handleFileUpload = async (event, missionId) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (file.type !== 'application/pdf') {
      toast({ title: 'Veuillez sélectionner un fichier PDF', status: 'error', isClosable: true });
      return;
    }

    // Validate file size (max 50MB)
    if (file.size > 50 * 1024 * 1024) {
      toast({ title: 'Le fichier ne doit pas dépasser 50MB', status: 'error', isClosable: true });
      return;
    }

    try {
      // Convertir le fichier en base64 pour votre API
      const reader = new FileReader();
      reader.onload = async function (e) {
        const base64Data = e.target.result;

        try {
          const response = await axios.put(
            `${BASE_URL}/missions/${missionId}/piece-jointe`,
            { piece_jointe: base64Data },
            {
              withCredentials: true,
              // Augmenter les timeouts pour les gros fichiers
              timeout: 60000, // 60 secondes
              maxContentLength: 50 * 1024 * 1024, // 50MB
              maxBodyLength: 50 * 1024 * 1024, // 50MB
            }
          );

          if (response.status === 200) {
            toast({ title: 'Pièce jointe uploadée avec succès', status: 'success', isClosable: true });

            // Update viewData - marquer qu'un fichier existe
            setViewData(prev => ({
              ...prev,
              piece_jointe: 'uploaded' // Juste un indicateur
            }));

            // Refresh missions data
            fetchData();
          }
        } catch (error) {
          console.error('Error uploading file:', error);
          if (error.response?.status === 413) {
            toast({ title: 'Fichier trop volumineux (max 50MB)', status: 'error', isClosable: true });
          } else if (error.response?.status === 400) {
            toast({ title: error.response.data.error || 'Format de fichier invalide', status: 'error', isClosable: true });
          } else {
            toast({ title: 'Erreur lors de l\'upload de la pièce jointe', status: 'error', isClosable: true });
          }
        }
      };

      reader.readAsDataURL(file);
    } catch (error) {
      console.error('Error reading file:', error);
      toast({ title: 'Erreur lors de la lecture du fichier', status: 'error', isClosable: true });
    }
  };


  // Handle file download
  const handleFileDownload = async (missionId) => {
    try {
      // Utiliser la route dédiée pour le téléchargement
      const response = await axios.get(
        `${BASE_URL}/missions/${missionId}/piece-jointe/download`,
        {
          responseType: 'blob',
          withCredentials: true,
        }
      );

      // Créer un blob et le télécharger
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `mission-${missionId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast({ title: 'Téléchargement réussi', status: 'success', isClosable: true });
    } catch (error) {
      console.error('Error downloading file:', error);
      if (error.response?.status === 404) {
        toast({ title: 'Aucune pièce jointe disponible', status: 'error', isClosable: true });
      } else {
        toast({ title: 'Erreur lors du téléchargement', status: 'error', isClosable: true });
      }
    }
  };

  // Edit handler
  const handleEdit = (mission) => {
    if (!mission?.id) return;
    navigate(`/admin/missions/edit/${mission.id}`);
  };

  // Update handler
  const handleUpdate = async () => {
    try {
      // Validation des champs obligatoires
      const newInvalidFields = {};
      const requiredFields = [
        { key: 'type_mission', label: 'Type de Mission' },
        { key: 'adresse', label: 'Adresse de Mission', condition: editData.type_mission !== 'Téléconsultation' },
        { key: 'ville', label: 'Ville', condition: editData.type_mission !== 'Téléconsultation' },
        { key: 'etat_mission', label: 'État de Mission' },
        { key: 'date_mission', label: 'Date de Mission', condition: editData.etat_mission === 'planifiée' },
        { key: 'cause', label: 'Cause' },
        { key: 'prix', label: 'Prix' },
        { key: 'paiement', label: 'Mode de Paiement' },
        { key: 'paye', label: 'Statut de Paiement' },
        { key: 'type_ambulance', label: "Type d'Ambulance", condition: editData.type_mission === 'ambulance' },
        { key: 'ambulancier_id', label: 'Ambulancier', condition: editData.type_mission === 'ambulance' },
        { key: 'nurse_id', label: 'Infirmier', condition: editData.type_mission === 'Acte infirmier' }
      ];

      let firstInvalid = null;
      for (const field of requiredFields) {
        if (field.condition === false) continue;
        let value = editData;
        let fieldKey = field.key;
        if (field.key.includes('.')) {
          const [parent, child] = field.key.split('.');
          value = value[parent]?.[child];
          fieldKey = `${parent}_${child}`;
        } else {
          value = value[field.key];
        }
        if (value === undefined || value === null || value === '' || (typeof value === 'string' && value.trim() === '')) {
          newInvalidFields[fieldKey] = `Le champ "${field.label}" est obligatoire.`;
          if (!firstInvalid) firstInvalid = field.label;
        }
      }

      if (Object.keys(newInvalidFields).length > 0) {
        toast({
          title: 'Champs obligatoires manquants',
          description: `Veuillez remplir tous les champs obligatoires. Premier champ manquant : ${firstInvalid}`,
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      // If ambulancier_id has changed and mission is not planifiée, update vehicle statuses
      if (editData.ambulancier_id !== initialData.ambulancier_id && editData.etat_mission !== "planifiée") {
        // Get all vehicles
        const vehiclesRes = await axios.get(`${BASE_URL}/vehicules`, {
          withCredentials: true
        });
        // Set previous vehicle to available
        if (initialData.ambulancier_id) {
          const prevVehicle = vehiclesRes.data.find(v => v.user_id == initialData.ambulancier_id);
          if (prevVehicle) {
            await axios.put(`${BASE_URL}/vehicules/${prevVehicle.id}`, {
              ...prevVehicle,
              statut: "disponible"
            }, {
              withCredentials: true
            });
          }
        }

        // Set new vehicle to en mission
        if (editData.ambulancier_id) {
          const newVehicle = vehiclesRes.data.find(v => v.user_id == editData.ambulancier_id);
          if (newVehicle) {
            await axios.put(`${BASE_URL}/vehicules/${newVehicle.id}`, {
              ...newVehicle,
              statut: "en mission"
            }, {
              withCredentials: true
            });
          }
        }
      }

      // Créer une copie de editData sans les coordonnées et nettoyer les champs vides
      const dataToSend = { ...editData };
      delete dataToSend.location;

      // Convertir les champs ID vides en null
      if (dataToSend.ambulance_id === '' || dataToSend.ambulance_id === undefined) {
        dataToSend.ambulance_id = null;
      } else if (dataToSend.ambulance_id) {
        dataToSend.ambulance_id = parseInt(dataToSend.ambulance_id);
      }

      if (dataToSend.ambulancier_id === '' || dataToSend.ambulancier_id === undefined) {
        dataToSend.ambulancier_id = null;
      } else if (dataToSend.ambulancier_id) {
        dataToSend.ambulancier_id = parseInt(dataToSend.ambulancier_id);
      }

      if (dataToSend.doctor_id === '' || dataToSend.doctor_id === undefined) {
        dataToSend.doctor_id = null;
      } else if (dataToSend.doctor_id) {
        dataToSend.doctor_id = parseInt(dataToSend.doctor_id);
      }

      if (dataToSend.nurse_id === '' || dataToSend.nurse_id === undefined) {
        dataToSend.nurse_id = null;
      } else if (dataToSend.nurse_id) {
        dataToSend.nurse_id = parseInt(dataToSend.nurse_id);
      }

      if (dataToSend.client_id === '' || dataToSend.client_id === undefined) {
        dataToSend.client_id = null;
      } else if (dataToSend.client_id) {
        dataToSend.client_id = parseInt(dataToSend.client_id);
      }

      if (dataToSend.patient_id === '' || dataToSend.patient_id === undefined) {
        dataToSend.patient_id = null;
      } else if (dataToSend.patient_id) {
        dataToSend.patient_id = parseInt(dataToSend.patient_id);
      }

      await axios.put(`${BASE_URL}/missions/${editData.id}`, dataToSend, {
        withCredentials: true
      });

      // Mettre à jour les coordonnées dans missionLocations
      if (editData.location) {
        setMissionLocations(prev => ({
          ...prev,
          [editData.id]: editData.location
        }));
      }

      setTableData(prevData =>
        prevData.map(item => item.id === editData.id ? editData : item)
      );

      toast({ title: "Mission mise à jour", status: "success", isClosable: true });
      handleEditClose();
    } catch (err) {
      console.error("Update error:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Erreur lors de la mise à jour", status: "error", isClosable: true });
    }
  };

  // Delete handler
  const handleDelete = async () => {
    try {
      await axios.delete(`${BASE_URL}/missions/${selectedId}`, {
        withCredentials: true
      });

      setTableData(prevData => prevData.filter(item => item.id !== selectedId));
      toast({ title: "Mission supprimée", status: "success", isClosable: true });
      onAlertClose();
    } catch (err) {
      console.error("Delete error:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Erreur lors de la suppression", status: "error", isClosable: true });
    }
  };

  // Cancel handler
  // Fonction pour ouvrir la popup de sélection
  const handleCancel = (missionId) => {
    const mission = tableData.find(m => m.id === missionId);
    setMissionToCancel(mission);
    setMotifAnnulation('');
    setCancelModalOpen(true);
  };

  // Fonction pour confirmer l'annulation de mission
  const handleConfirmStatus = async (status) => {
    if (status === 'annulée' && !motifAnnulation) {
      toast({ title: "Veuillez sélectionner un motif d'annulation", status: "warning", isClosable: true });
      return;
    }
    try {
      // Récupérer d'abord la mission complète
      const missionResponse = await axios.get(`${BASE_URL}/missions/${missionToCancel.id}`, {
        withCredentials: true
      });

      const missionData = missionResponse.data;

      // Mettre à jour avec toutes les données existantes + le nouveau statut
      await axios.put(`${BASE_URL}/missions/${missionToCancel.id}`, {
        ...missionData,
        statut: status,
        motif_annulation: status === 'annulée' ? motifAnnulation : null
      }, {
        withCredentials: true
      });

      setTableData(prevData => prevData.map(item =>
        item.id === missionToCancel.id ? { ...item, statut: status, motif_annulation: status === 'annulée' ? motifAnnulation : null } : item
      ));

      const statusMessage = status === 'annulée' ? 'Mission annulée' : 'Mission marquée comme dérangement';
      toast({ title: statusMessage, status: "success", isClosable: true });

      // Fermer la popup
      setCancelModalOpen(false);
      setMissionToCancel(null);
      setMotifAnnulation('');
    } catch (err) {
      console.error("Status update error:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Erreur lors de la mise à jour", status: "error", isClosable: true });
    }
  };

  // Complete handler
  const handleComplete = async (missionId) => {
    try {
      // Récupérer d'abord la mission complète
      const missionResponse = await axios.get(`${BASE_URL}/missions/${missionId}`, {
        withCredentials: true
      });

      const missionData = missionResponse.data;

      // Mettre à jour avec toutes les données existantes + le nouveau statut
      await axios.put(`${BASE_URL}/missions/${missionId}`, {
        ...missionData,
        statut: 'terminée'
      }, {
        withCredentials: true
      });

      setTableData(prevData => prevData.map(item =>
        item.id === missionId ? { ...item, statut: 'terminée' } : item
      ));
      toast({ title: "Mission terminée", status: "success", isClosable: true });
    } catch (err) {
      console.error("Complete error:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Erreur lors de la finalisation", status: "error", isClosable: true });
    }
  };

  // Basculer une mission en mode automatique ou manuel
  const handleToggleAutoMission = async (missionId, isAutoEnabled) => {
    try {
      const endpoint = isAutoEnabled
        ? `${BASE_URL}/missions/${missionId}/autofin`
        : `${BASE_URL}/missions/${missionId}/auto`;

      await axios.put(endpoint, {}, {
        withCredentials: true
      });

      setTableData((prevData) =>
        prevData.map((item) =>
          item.id === missionId
            ? {
              ...item,
              auto: isAutoEnabled ? 0 : 1,
              ...(isAutoEnabled ? {} : { statut: 'en cours' })
            }
            : item
        )
      );

      toast({
        title: isAutoEnabled ? "Mode manuel activé" : "Mode automatique activé",
        status: "success",
        isClosable: true
      });
    } catch (err) {
      console.error("Auto mission toggle error:", err);
      console.error("Error details:", err.response?.data);
      toast({
        title: isAutoEnabled
          ? "Erreur lors du passage en mode manuel"
          : "Erreur lors de l'activation auto mission",
        status: "error",
        isClosable: true
      });
    }
  };

  // Generate invoice handler


  const getPreferredId = (...values) => {
    for (const value of values) {
      if (value !== undefined && value !== null && value !== '') {
        return value;
      }
    }
    return null;
  };

  const findUserById = (id) => {
    if (id === null || id === undefined || id === '') return undefined;
    return users.find((u) => String(u.id) === String(id));
  };

  const hasTravelOrigin = (mission) => {
    if (!mission) return false;
    const missionType = mission.type_mission?.toLowerCase?.() || '';

    if (missionType === 'ambulance') {
      return !!mission.ambulancier_id;
    }

    if (missionType === 'acte infirmier') {
      const nurseId = getPreferredId(mission.nurse_id, mission.nurse, mission.nurseId);
      return !!nurseId;
    }

    if (missionType === 'consultation à domicile' || missionType === 'consultation a domicile') {
      const doctorId = getPreferredId(mission.doctor_id, mission.doctor, mission.doctorId);
      return !!doctorId;
    }

    return false;
  };

  // Modifier le mappedTableData pour utiliser les références et éviter les recalculs inutiles
  const mappedTableData = useMemo(() => {
    return tableData.map((row) => {
      // Type Ambulance : utiliser directement mission.type_ambulance, sinon chercher dans les véhicules
      const typeAmbulance = row.type_mission === "ambulance"
        ? (row.type_ambulance || vehicles.find(v => v.user_id == row.ambulancier_id)?.type_vehicule || '-')
        : '-';

      const bonDeCommande = row.bon_de_commande || '';

      // Intervenant selon le type de mission
      let nameIntervenant = 'N/A';
      const missionType = (row.type_mission || '').toLowerCase();

      if (missionType === "ambulance") {
        nameIntervenant = getAmbulancierName(row.ambulancier_id);
      } else if (missionType === "consultation à domicile" || missionType === "consultation a domicile" || missionType === "téléconsultation" || missionType === "teleconsultation") {
        const doctorId = getPreferredId(row.doctor_id, row.doctor, row.doctorId);
        const doctor = findUserById(doctorId) || doctors.find(d => d.id == doctorId);
        if (doctor) {
          const fullName = `${doctor.nom || ''} ${doctor.prenom || ''}`.trim();
          nameIntervenant = fullName || `Médecin #${doctorId}`;
        } else if (doctorId) {
          nameIntervenant = `Médecin #${doctorId}`;
        } else {
          nameIntervenant = 'N/A';
        }
      } else if (missionType === "acte infirmier") {
        const nurseId = getPreferredId(row.nurse_id, row.nurse, row.nurseId);
        const nurse = findUserById(nurseId) || nurses.find(n => n.id == nurseId);
        if (nurse) {
          const fullName = `${nurse.nom || ''} ${nurse.prenom || ''}`.trim();
          nameIntervenant = fullName || `Infirmier #${nurseId}`;
        } else if (nurseId) {
          nameIntervenant = `Infirmier #${nurseId}`;
        } else {
          nameIntervenant = 'N/A';
        }
      }

      // Get patient phone number
      const patient = patients.find(p => p.id === row.patient_id);
      const num = patient ? patient.téléphone : '';
      const patient_name = patient ? `${patient.nom} ${patient.prenom}` : 'N/A';
      // Utiliser directement unreadMessagesByMission pour le compteur
      const unreadCount = unreadMessagesByMission[row.id] || 0;
      return {
        id: row.id,
        etat_mission: row.etat_mission,
        type_ambulance: typeAmbulance,
        bon_de_commande: bonDeCommande,
        ambulancier: nameIntervenant,
        num: num,
        patient_name: patient_name,
        date_mission: row.date_mission ? new Date(row.date_mission).toLocaleString("fr-FR", {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        }) : '',
        créé_le: row.créé_le,
        statut: row.statut || 'créée',
        type_mission: row.type_mission,
        actions: (
          <Menu
            placement="left-start"
            onOpen={() => setIsActionsMenuOpen(true)}
            onClose={() => setIsActionsMenuOpen(false)}
          >
            <MenuButton
              as={IconButton}
              icon={<Icon as={MdMoreVert} w="18px" h="18px" />}
              aria-label="Actions"
              variant="ghost"
              size="sm"
              w="32px"
              h="32px"
              borderRadius="6px"
              border="1px solid rgba(69,156,233,0.2)"
              color="#656C7A"
              bg="transparent"
              _hover={{ bg: '#F9F9F9' }}
              _active={{ bg: '#F9F9F9' }}
            />
            <MenuList
              minW="220px"
              borderRadius="12px"
              border="1px solid #E5E5E5"
              boxShadow="0px 7px 18px rgba(0, 0, 0, 0.09)"
              p="10px"
              bg="white"
            >
              <MenuItem
                onClick={() => handleView(row)}
                bg="#F9F9F9"
                borderRadius="6px"
                mb="4px"
                h="auto"
                py="12px"
                px="10px"
                _hover={{ bg: '#F0F0F0' }}
              >
                <Flex align="center" gap="10px">
                  <Icon as={MdVisibility} w="18px" h="18px" color="#455879" />
                  <Text fontSize="14px" fontWeight="400" color="#455879" fontFamily="Poppins, sans-serif">
                    Voir les détails
                  </Text>
                </Flex>
              </MenuItem>

              <MenuItem
                onClick={() => handleOpenChat(row.id)}
                borderRadius="6px"
                mb="4px"
                h="auto"
                py="12px"
                px="10px"
                _hover={{ bg: '#F9F9F9' }}
                position="relative"
              >
                <Flex align="center" gap="10px" w="100%">
                  <Icon as={MdChat} w="18px" h="18px" color="#455879" />
                  <Text fontSize="14px" fontWeight="400" color="#455879" fontFamily="Poppins, sans-serif">
                    Envoyer un message
                  </Text>
                  {unreadCount > 0 && (
                    <Badge
                      ml="auto"
                      colorScheme="red"
                      borderRadius="full"
                      minW="20px"
                      h="20px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      fontSize="xs"
                    >
                      {unreadCount}
                    </Badge>
                  )}
                </Flex>
              </MenuItem>

              {hasPermission('missions_edit') && (
                <MenuItem
                  onClick={() => handleToggleAutoMission(row.id, !!row.auto)}
                  borderRadius="6px"
                  mb="4px"
                  h="auto"
                  py="12px"
                  px="10px"
                  _hover={{ bg: '#F9F9F9' }}
                >
                  <Flex align="center" gap="10px">
                    <Icon
                      as={row.auto ? MdToggleOff : MdAutorenew}
                      w="18px"
                      h="18px"
                      color="#455879"
                    />
                    <Text fontSize="14px" fontWeight="400" color="#455879" fontFamily="Poppins, sans-serif">
                      {row.auto ? "Passer en mission manuelle" : "Activer auto mission"}
                    </Text>
                  </Flex>
                </MenuItem>
              )}

              {hasPermission('missions_edit') && (
                <MenuItem
                  onClick={() => handleComplete(row.id)}
                  isDisabled={row.statut === 'terminée' || row.statut === 'annulée'}
                  borderRadius="6px"
                  mb="4px"
                  h="auto"
                  py="12px"
                  px="10px"
                  _hover={{ bg: '#F9F9F9' }}
                  _disabled={{ opacity: 0.5, cursor: 'not-allowed' }}
                >
                  <Flex align="center" gap="10px">
                    <Icon as={MdCheckCircle} w="18px" h="18px" color="#455879" />
                    <Text fontSize="14px" fontWeight="400" color="#455879" fontFamily="Poppins, sans-serif">
                      Terminer la mission
                    </Text>
                  </Flex>
                </MenuItem>
              )}

              {hasPermission('missions_edit') && (
                <MenuItem
                  onClick={() => handleCancel(row.id)}
                  isDisabled={row.statut === 'annulée' || row.statut === 'terminée'}
                  borderRadius="6px"
                  mb="4px"
                  h="auto"
                  py="12px"
                  px="10px"
                  _hover={{ bg: '#F9F9F9' }}
                  _disabled={{ opacity: 0.5, cursor: 'not-allowed' }}
                >
                  <Flex align="center" gap="10px">
                    <Icon as={MdCancel} w="18px" h="18px" color="#455879" />
                    <Text fontSize="14px" fontWeight="400" color="#455879" fontFamily="Poppins, sans-serif">
                      Annuler la mission
                    </Text>
                  </Flex>
                </MenuItem>
              )}

              {hasPermission('missions_edit') && (
                <MenuItem
                  onClick={() => handleEdit(row)}
                  borderRadius="6px"
                  mb="4px"
                  h="auto"
                  py="12px"
                  px="10px"
                  _hover={{ bg: '#F9F9F9' }}
                >
                  <Flex align="center" gap="10px">
                    <Icon as={MdEdit} w="18px" h="18px" color="#455879" />
                    <Text fontSize="14px" fontWeight="400" color="#455879" fontFamily="Poppins, sans-serif">
                      Modifier la Mission
                    </Text>
                  </Flex>
                </MenuItem>
              )}

              {hasPermission('missions_delete') && (
                <Box borderTop="1px solid #F1F1F4" mt="4px" pt="10px">
                  <MenuItem
                    onClick={() => {
                      setSelectedId(row.id);
                      onAlertOpen();
                    }}
                    borderRadius="6px"
                    h="auto"
                    py="10px"
                    px="10px"
                    _hover={{ bg: '#F9F9F9' }}
                  >
                    <Flex align="center" gap="10px">
                      <Icon as={MdDelete} w="18px" h="18px" color="#F8285A" />
                      <Text fontSize="14px" fontWeight="400" color="#F8285A" fontFamily="Poppins, sans-serif">
                        Supprimer
                      </Text>
                    </Flex>
                  </MenuItem>
                </Box>
              )}
            </MenuList>
          </Menu>
        ),
      };
    });
  }, [tableData, users, vehicles, unreadMessagesByMission, patients, doctors, nurses]);

  const [travelTime, setTravelTime] = useState(null);
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [missionToCancel, setMissionToCancel] = useState(null);
  const [motifAnnulation, setMotifAnnulation] = useState('');

  // Fonction pour calculer la distance entre deux points en kilomètres
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Rayon de la Terre en km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  // Fonction pour calculer le temps de trajet avec Google Maps
  const parseLocationString = (locString) => {
    if (!locString || typeof locString !== 'string') return null;
    const parts = locString.split(',').map(part => parseFloat(part.trim()));
    if (parts.length !== 2 || parts.some(isNaN)) return null;
    return { lat: parts[0], lng: parts[1] };
  };

  const calculateTravelTime = async (missionId) => {
    try {
      // Récupérer les données de la mission
      const mission = tableData.find(m => m.id === missionId);
      if (!mission) {
        toast({ title: 'Mission non trouvée', status: 'error', isClosable: true });
        return;
      }

      const missionType = (mission.type_mission || '').toLowerCase();
      let originCoords = null;

      if (missionType === 'ambulance') {
        const vehicle = vehicles.find(v => v.user_id === mission.ambulancier_id);
        if (!vehicle) {
          toast({ title: 'Véhicule non trouvé', status: 'error', isClosable: true });
          return;
        }

        if (!vehicle.tracker_id) {
          toast({ title: 'Aucun tracker disponible', status: 'error', isClosable: true });
          return;
        }

        const vehicleLocation = await fetchVehicleLocation(vehicle.tracker_id);
        if (!vehicleLocation || !vehicleLocation.lat || !vehicleLocation.lng) {
          toast({ title: 'Localisation du véhicule non disponible', status: 'error', isClosable: true });
          return;
        }
        originCoords = vehicleLocation;
      } else if (missionType === 'acte infirmier') {
        const nurseId = getPreferredId(mission.nurse_id, mission.nurse, mission.nurseId);
        const nurse = findUserById(nurseId) || nurses.find(n => n.id == nurseId);
        const nurseLoc = nurse?.loc || nurse?.location;
        originCoords = parseLocationString(nurseLoc);
        if (!originCoords) {
          toast({ title: "Localisation de l'infirmier indisponible", status: 'error', isClosable: true });
          return;
        }
      } else if (missionType === 'consultation à domicile' || missionType === 'consultation a domicile') {
        const doctorId = getPreferredId(mission.doctor_id, mission.doctor, mission.doctorId);
        const doctor = findUserById(doctorId) || doctors.find(d => d.id == doctorId);
        const doctorLoc = doctor?.loc || doctor?.location;
        originCoords = parseLocationString(doctorLoc);
        if (!originCoords) {
          toast({ title: "Localisation du médecin indisponible", status: 'error', isClosable: true });
          return;
        }
      } else {
        toast({ title: 'Type de mission non pris en charge pour ce calcul', status: 'warning', isClosable: true });
        return;
      }

      // Vérifier que Google Maps est chargé
      if (!window.google || !window.google.maps) {
        toast({ title: 'Google Maps non disponible', status: 'error', isClosable: true });
        return;
      }

      // Utiliser Google Maps Directions Service
      const directionsService = new window.google.maps.DirectionsService();

      const request = {
        origin: new window.google.maps.LatLng(originCoords.lat, originCoords.lng),
        destination: mission.adresse,
        travelMode: window.google.maps.TravelMode.DRIVING,
        unitSystem: window.google.maps.UnitSystem.METRIC,
        avoidHighways: false,
        avoidTolls: false
      };

      directionsService.route(request, (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          const route = result.routes[0];
          const leg = route.legs[0];

          const distance = leg.distance.text;
          const duration = leg.duration.text;

          // Stocker le résultat dans l'état
          setTravelTime({
            distance: distance,
            duration: duration,
            missionId: missionId
          });

          // Afficher le résultat dans un toast
          toast({
            title: `Temps de trajet calculé`,
            description: `Distance: ${distance} - Temps: ${duration}`,
            status: 'success',
            duration: 5000,
            isClosable: true,
          });
        } else {
          toast({
            title: 'Impossible de calculer le trajet',
            description: `Erreur: ${status}`,
            status: 'error',
            isClosable: true
          });
        }
      });

    } catch (error) {
      console.error('Erreur lors du calcul du temps:', error);
      toast({ title: 'Erreur lors du calcul du temps de trajet', status: 'error', isClosable: true });
    }
  };

  // Fonction pour récupérer la position d'un véhicule
  const fetchVehicleLocation = async (trackerId) => {
    try {
      const data = {
        // Utiliser le hash depuis la config (variable d'environnement)
        hash: config.navixy.hash,
        tracker_id: trackerId
      };
      const response = await axios.post(
        `${config.navixy.apiUrl}/tracker/get_state`,
        data,
        {
          headers: { 'Content-Type': 'application/json' },
          // Ne pas envoyer de cookies/credentials vers Navixy pour éviter les erreurs CORS
          withCredentials: false,
        }
      );
      return {
        lat: response.data.state.gps.location.lat,
        lng: response.data.state.gps.location.lng
      };
    } catch (error) {
      console.error('Error fetching vehicle location:', error);
      return null;
    }
  };

  // Modifier la fonction fetchAmbulanciers pour inclure les distances
  const fetchAmbulanciers = async (typeAmbulance) => {
    try {
      const [usersRes, vehiclesRes] = await Promise.all([
        axios.get(`${BASE_URL}/users`, {
          withCredentials: true
        }),
        axios.get(`${BASE_URL}/vehicules`, {
          withCredentials: true
        })
      ]);

      // Filter ambulanciers who have a vehicle of the selected type
      const ambulanciers = usersRes.data.filter(user => user.rôle === "ambulancier");

      const vehicles = vehiclesRes.data;
      // Déterminer la ville en fonction du contexte (modal d'édition ou d'ajout)
      const currentVille = isEditOpen ? editData?.ville : newMissionData.ville;
      const currentEtatMission = isEditOpen ? editData?.etat_mission : newMissionData.etat_mission;

      // Filter vehicles by type and ville
      const filteredVehicles = vehicles.filter(vehicle => {
        // Si le type sélectionné est TAS, inclure aussi les TAR
        const isMatchingType = typeAmbulance === "TAS"
          ? (vehicle.type_vehicule === "TAS" || vehicle.type_vehicule === "TAR")
          : vehicle.type_vehicule === typeAmbulance;

        return isMatchingType &&
          vehicle.ville == currentVille &&
          (currentEtatMission === "planifiée" || vehicle.statut === "disponible");
      });

      // Get unique ambulancier IDs from filtered vehicles
      const availableAmbulancierIds = [...new Set(filteredVehicles.map(vehicle => vehicle.user_id))];

      // Filter ambulanciers to only those with available vehicles
      const availableAmbulanciers = ambulanciers.filter(ambulancier =>
        availableAmbulancierIds.includes(ambulancier.id)
      );

      // Get mission location
      const missionLocation = missionLocations['new'];

      // Add distance information to each ambulancier
      const ambulanciersWithDistance = await Promise.all(availableAmbulanciers.map(async (ambulancier) => {
        const vehicle = vehicles.find(v => v.user_id === ambulancier.id);

        if (vehicle && vehicle.tracker_id && missionLocation) {
          try {
            const vehicleLocation = await fetchVehicleLocation(vehicle.tracker_id);

            if (vehicleLocation) {
              const distance = calculateDistance(
                missionLocation.lat,
                missionLocation.lng,
                vehicleLocation.lat,
                vehicleLocation.lng
              );
              return {
                ...ambulancier,
                distance: Math.round(distance * 10) / 10,
                vehicle_status: vehicle.statut,
                vehicle_type: vehicle.type_vehicule // Add vehicle type to the ambulancier object
              };
            }
          } catch (error) {
            console.error(`Error fetching location for vehicle ${vehicle.tracker_id}:`, error);
          }
        }
        return {
          ...ambulancier,
          distance: null,
          vehicle_status: vehicle?.statut || 'unknown',
          vehicle_type: vehicle?.type_vehicule || 'unknown' // Add vehicle type even if location is not available
        };
      }));

      // Sort ambulanciers by distance
      const sortedAmbulanciers = ambulanciersWithDistance.sort((a, b) => {
        if (a.distance === null) return 1;
        if (b.distance === null) return -1;
        return a.distance - b.distance;
      });

      setAvailableAmbulanciers(sortedAmbulanciers);
    } catch (err) {
      console.error("Error fetching ambulanciers:", err);
      toast({
        title: "Error",
        description: "Failed to fetch ambulanciers",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Add useEffect to refetch ambulanciers when ville changes
  useEffect(() => {
    if (newMissionData.type_ambulance && newMissionData.ville) {
      fetchAmbulanciers(newMissionData.type_ambulance);
    } else {
      setAvailableAmbulanciers([]);
    }
  }, [newMissionData.type_ambulance, newMissionData.ville]);

  const fetchPatients = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/patients?limit=10000`, {
        withCredentials: true
      });
      // Support pour la nouvelle structure paginée et l'ancienne structure
      let patientsData = [];
      if (Array.isArray(res.data?.data)) {
        patientsData = res.data.data;
      } else if (Array.isArray(res.data)) {
        patientsData = res.data;
      }
      setPatients(patientsData);
    } catch (err) {
      console.error("Error fetching patients:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Error fetching patients", status: "error", isClosable: true });
    }
  };



  const fetchDoctors = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/users`, {
        withCredentials: true
      });
      const doctorsList = res.data.filter(user => user.rôle === 'médecin');

      setDoctors(doctorsList);
    } catch (err) {
      console.error("Error fetching doctors:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Error fetching doctors", status: "error", isClosable: true });
    }
  };

  useEffect(() => {
    if (newMissionData.type_ambulance) {
      fetchAmbulanciers(newMissionData.type_ambulance);
    }
  }, [newMissionData.type_ambulance]);

  useEffect(() => {
    fetchPatients();
  }, []);

  useEffect(() => {
    fetchDoctors();
  }, []);


  const filteredPatients = useMemo(() => {
    return patients.filter(patient =>
      `${patient.nom} ${patient.prenom}`.toLowerCase().includes(searchPatient.toLowerCase())
    );
  }, [patients, searchPatient]);

  const [isAdding, setIsAdding] = useState(false);

  // 1. Ajouter un état pour les champs invalides
  const [invalidFields, setInvalidFields] = useState({});

  // removed standalone gmaps link logic (now auto-détecté dans l'input d'adresse)

  // 2. Mettre à jour handleAdd pour remplir invalidFields
  const handleAdd = async () => {
    if (isAdding) return; // Empêche les doubles clics

    const newInvalidFields = {};
    const requiredFields = [
      { key: 'type_mission', label: 'Type de Mission' },
      { key: 'adresse', label: 'Adresse de Mission', condition: newMissionData.type_mission !== 'Téléconsultation' },
      { key: 'ville', label: 'Ville', condition: newMissionData.type_mission !== 'Téléconsultation' },
      { key: 'etat_mission', label: 'État de Mission' },
      { key: 'date_mission', label: 'Date de Mission', condition: newMissionData.etat_mission === 'planifiée' },
      { key: 'cause', label: 'Cause' },
      { key: 'prix', label: 'Prix' },
      { key: 'paiement', label: 'Mode de Paiement' },
      { key: 'paye', label: 'Statut de Paiement' },
      { key: 'new_patient.nom', label: 'Nom du patient' },
      { key: 'new_patient.prenom', label: 'Prénom du patient' },
      { key: 'new_patient.téléphone', label: 'Téléphone du patient' },
      { key: 'type_ambulance', label: "Type d'Ambulance", condition: newMissionData.type_mission === 'ambulance' },
      { key: 'ambulancier_id', label: 'Ambulancier', condition: newMissionData.type_mission === 'ambulance' },
      { key: 'nurse_id', label: 'Infirmier', condition: newMissionData.type_mission === 'Acte infirmier' },
      { key: 'nurse_type', label: 'Spécialité de l\'Infirmier', condition: newMissionData.nurse_id !== '' },
      { key: 'doctor_id', label: 'Docteur', condition: (newMissionData.type_mission === "ambulance" && newMissionData.type_ambulance === "TAR") || newMissionData.type_mission === "Consultation à domicile" || newMissionData.type_mission === "Téléconsultation" },
    ];
    let firstInvalid = null;
    for (const field of requiredFields) {
      if (field.condition === false) continue;
      let value = newMissionData;
      let fieldKey = field.key;
      if (field.key.includes('.')) {
        const [parent, child] = field.key.split('.');
        value = value[parent]?.[child];
        fieldKey = `${parent}_${child}`;
      } else {
        value = value[field.key];
      }
      if (value === undefined || value === null || value === '' || (typeof value === 'string' && value.trim() === '')) {
        newInvalidFields[fieldKey] = `Le champ "${field.label}" est obligatoire.`;
        if (!firstInvalid) firstInvalid = field.label;
      }
    }
    setInvalidFields(newInvalidFields);
    if (Object.keys(newInvalidFields).length > 0) {
      toast({
        title: 'Champs obligatoires manquants',
        description: `Veuillez remplir tous les champs obligatoires. Premier champ manquant : ${firstInvalid}`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setIsAdding(true);
      let patientId = newMissionData.patient_id;

      // Ajout du log demandé
      // Vérifier si l'ambulancier a déjà une mission planifiée
      if (newMissionData.ambulancier_id) {
        const missionsRes = await axios.get(`${BASE_URL}/missions`, {
          withCredentials: true
        });

        const existingMission = missionsRes.data.find(mission =>
          mission.ambulancier_id == newMissionData.ambulancier_id &&
          mission.etat_mission == "planifiée"
        );

        if (existingMission) {

          const ambulancier = users.find(u => u.id == newMissionData.ambulancier_id);
          const timeDiff = new Date(existingMission.date_mission) - new Date(newMissionData.date_mission);
          const hours = Math.floor(timeDiff / (1000 * 60 * 60));
          const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

          if (hours >= -12 && hours < 12) {
            const confirmationData = {
              ambulancier: ambulancier,
              existingMission: existingMission,
              remainingTime: { hours, minutes },
              missionData: newMissionData,
              patientId: patientId
            };

            setMissionConfirmationData(confirmationData);
            onMissionConfirmationOpen();
            setIsAdding(false);
            return; // Stop here and wait for user confirmation
          }
        }
      }

      // Continue with mission creation if no existing mission or after confirmation
      await createMission(newMissionData, patientId);
      setIsAdding(false);
    } catch (err) {
      setIsAdding(false);
      console.error("Add error:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Erreur lors de l'ajout de la mission", status: "error", isClosable: true });
    }
  };

  const createMission = async (missionData, patientId) => {
    try {
      if (!newMissionData.patient_id) {
        // Ensure client_id and type_client are properly set for new patient
        const newPatientData = {
          ...missionData.new_patient,
          client_id: missionData.client_id || null,
          type_client: missionData.type_client === "assurance" ? "Assurance" :
            missionData.type_client === "entreprise" ? "B2B" :
              missionData.type_client === "particulier" ? "B2C" : "Assurance"
        };

        const newPatientRes = await axios.post(`${BASE_URL}/patients`, newPatientData, {
          withCredentials: true
        });
        patientId = newPatientRes.data.id;
      }

      // Update vehicle status to "en mission" only if mission is not planifiée
      if (missionData.etat_mission !== "planifiée" && missionData.ambulancier_id) {
        const vehiclesRes = await axios.get(`${BASE_URL}/vehicules`, {
          withCredentials: true
        });

        const vehicle = vehiclesRes.data.find(v => v.user_id == missionData.ambulancier_id);
        if (vehicle) {
          await axios.put(`${BASE_URL}/vehicules/${vehicle.id}`, {
            ...vehicle,
            statut: "en mission"
          }, {
            withCredentials: true
          });
        }
      }

      // Résoudre automatiquement l'ambulance_id à partir de l'ambulancier_id si absent (sans champ dans le formulaire)
      let resolvedAmbulanceId = missionData.ambulance_id || null;
      if (!resolvedAmbulanceId && missionData.ambulancier_id) {
        try {
          // Essayer d'abord avec les véhicules déjà chargés en mémoire
          const localVehicle = vehicles.find(v => v.user_id == missionData.ambulancier_id);
          if (localVehicle) {
            resolvedAmbulanceId = localVehicle.id;
          } else {
            // Fallback: requête API pour garantir la résolution
            const vehiclesRes2 = await axios.get(`${BASE_URL}/vehicules`, {
              withCredentials: true
            });
            const found = vehiclesRes2.data.find(v => v.user_id == missionData.ambulancier_id);
            if (found) {
              resolvedAmbulanceId = found.id;
            }
          }
        } catch (e) {
          console.error("Erreur lors de la résolution de l'ambulance_id:", e);
        }
      }

      // Préparer les données pour l'envoi
      const finalMissionData = {
        ...missionData,
        patient_id: patientId,
        // Convertir les champs ID vides en null ou en entier
        nurse_id: missionData.nurse_id ? parseInt(missionData.nurse_id) : null,
        doctor_id: missionData.doctor_id ? parseInt(missionData.doctor_id) : null,
        ambulancier_id: missionData.ambulancier_id ? parseInt(missionData.ambulancier_id) : null,
        ambulance_id: resolvedAmbulanceId ? parseInt(resolvedAmbulanceId) : null,
        client_id: missionData.client_id && missionData.client_id !== "" ? parseInt(missionData.client_id) : 1000000, // Temporairement mis à 1 au lieu de null
        créé_par: user.id,
        // Inclure la localisation si disponible
        loc: missionData.loc || null,
        // Inclure le type d'infirmier si disponible
        nurse_type: missionData.nurse_type || null,
        // Inclure les champs de correspondance
        correspondance: missionData.correspondance || null,
        correspondance_details: missionData.correspondance_details || null,
      };

      // Supprimer les champs qui ne doivent pas être envoyés
      delete finalMissionData.add_new_patient;
      delete finalMissionData.new_patient;

      const response = await axios.post(`${BASE_URL}/missions`, finalMissionData, {
        withCredentials: true
      });

      // Stocker les coordonnées pour la nouvelle mission
      if (missionLocations['new']) {
        setMissionLocations(prev => ({
          ...prev,
          [response.data.id]: missionLocations['new'],
          'new': null
        }));
      }

      // Create notifications for each user involved in the mission
      const notifications = [];

      // Get user details for the message
      const usersRes = await axios.get(`${BASE_URL}/users`, {
        withCredentials: true
      });

      // Get patient details
      const patient = patients.find(p => p.id == missionData.patient_id);

      // Get vehicle details for nurse information
      const vehiclesRes = await axios.get(`${BASE_URL}/vehicules`, {
        withCredentials: true
      });
      const vehicle = vehiclesRes.data.find(v => v.user_id == missionData.ambulancier_id);

      // Create notification for ambulancier if exists
      if (missionData.ambulancier_id) {
        const ambulancier = usersRes.data.find(u => u.id == missionData.ambulancier_id);
        const doctor = usersRes.data.find(u => u.id == missionData.doctor_id);
        const nurse = missionData?.nurse_id ? usersRes.data.find(u => u.id == missionData.nurse_id) : null;

        const message = `Nouvelle mission:
Type: ${missionData.type_mission || 'N/A'}
cause: ${missionData.cause || 'N/A'}
Date: ${missionData.date_mission || 'N/A'}
Adresse: ${missionData.adresse || 'N/A'}
Bon de Commande: ${missionData.bon_de_commande || 'N/A'}
Demande Matériel: ${missionData.demande_materiel || 'N/A'}

Patient:
${patient?.nom || 'N/A'} ${patient?.prenom || 'N/A'}
Téléphone: ${patient?.téléphone || 'N/A'}

Médecin:
${doctor?.nom || 'N/A'} ${doctor?.prenom || 'N/A'}
Téléphone: ${doctor?.téléphone || 'N/A'}

Infirmier:
${nurse?.nom || 'N/A'} ${nurse?.prenom || 'N/A'}
Téléphone: ${nurse?.téléphone || 'N/A'}`;

        notifications.push({
          user_id: missionData.ambulancier_id,
          mission_id: response.data.id,
          message: message,
          date_notification: missionData.date_mission || new Date().toISOString(),
          type: "mission",
          statut: "nonlue"
        });
      }

      // Create notification for doctor if exists
      if (missionData.doctor_id) {
        const doctor = usersRes.data.find(u => u.id == missionData.doctor_id);
        const ambulancier = usersRes.data.find(u => u.id == missionData.ambulancier_id);
        const nurse = missionData?.nurse_id ? usersRes.data.find(u => u.id == missionData.nurse_id) : null;

        const message = `Nouvelle mission:
Type: ${missionData.type_mission || 'N/A'}
cause: ${missionData.cause || 'N/A'}
Date: ${missionData.date_mission || 'N/A'}
Adresse: ${missionData.adresse || 'N/A'} 
Bon de Commande: ${missionData.bon_de_commande || 'N/A'}
Demande Matériel: ${missionData.demande_materiel || 'N/A'}

Patient:
${patient?.nom || 'N/A'} ${patient?.prenom || 'N/A'}
Téléphone: ${patient?.téléphone || 'N/A'}

Ambulancier:
${ambulancier?.nom || 'N/A'} ${ambulancier?.prenom || 'N/A'}
Téléphone: ${ambulancier?.téléphone || 'N/A'}

Infirmier:
${nurse?.nom || 'N/A'} ${nurse?.prenom || 'N/A'}
Téléphone: ${nurse?.téléphone || 'N/A'}`;

        notifications.push({
          user_id: missionData.doctor_id,
          mission_id: response.data.id,
          message: message,
          date_notification: missionData.date_mission || new Date().toISOString(),
          type: "mission",
          statut: "nonlue"
        });
      }

      // Create notification for nurse if exists in the vehicle
      if (missionData?.nurse_id) {
        const nurse = usersRes.data.find(u => u.id == missionData.nurse_id);
        const ambulancier = usersRes.data.find(u => u.id == missionData.ambulancier_id);
        const doctor = usersRes.data.find(u => u.id == missionData.doctor_id);

        if (nurse) {
          const message = `Nouvelle mission:
          Type: ${missionData.type_mission || 'N/A'}
          cause: ${missionData.cause || 'N/A'}
          Date: ${missionData.date_mission || 'N/A'}
          Adresse: ${missionData.adresse || 'N/A'}
          Bon de Commande: ${missionData.bon_de_commande || 'N/A'}
          Demande Matériel: ${missionData.demande_materiel || 'N/A'}
                  
          Patient:
          ${patient?.nom || 'N/A'} ${patient?.prenom || 'N/A'}
          Téléphone: ${patient?.téléphone || 'N/A'}
                  
          Ambulancier:
          ${ambulancier?.nom || 'N/A'} ${ambulancier?.prenom || 'N/A'}
          Téléphone: ${ambulancier?.téléphone || 'N/A'}
                  
          Médecin:
          ${doctor?.nom || 'N/A'} ${doctor?.prenom || 'N/A'}
          Téléphone: ${doctor?.téléphone || 'N/A'}`;

          notifications.push({
            user_id: missionData.nurse_id,
            mission_id: response.data.id,
            message: message,
            date_notification: missionData.date_mission || new Date().toISOString(),
            type: "mission",
            statut: "nonlue"
          });
        }
      }

      // Create notification for nurse if mission type is "Acte infirmier"
      if (missionData.type_mission === "Acte infirmier" && missionData.nurse_id) {
        const nurse = usersRes.data.find(u => u.id == missionData.nurse_id);
        const doctor = usersRes.data.find(u => u.id == missionData.doctor_id);
        const ambulancier = usersRes.data.find(u => u.id == missionData.ambulancier_id);

        if (nurse) {
          const message = `Nouvelle mission d'acte infirmier:
Type: ${missionData.type_mission || 'N/A'}
cause: ${missionData.cause || 'N/A'}
Date: ${missionData.date_mission || 'N/A'}
Adresse: ${missionData.adresse || 'N/A'}
Bon de Commande: ${missionData.bon_de_commande || 'N/A'}
Demande Matériel: ${missionData.demande_materiel || 'N/A'}

Patient:
${patient?.nom || 'N/A'} ${patient?.prenom || 'N/A'}
Téléphone: ${patient?.téléphone || 'N/A'}

Médecin:
${doctor?.nom || 'N/A'} ${doctor?.prenom || 'N/A'}
Téléphone: ${doctor?.téléphone || 'N/A'}

Ambulancier:
${ambulancier?.nom || 'N/A'} ${ambulancier?.prenom || 'N/A'}
Téléphone: ${ambulancier?.téléphone || 'N/A'}`;

          notifications.push({
            user_id: missionData.nurse_id,
            mission_id: response.data.id,
            message: message,
            date_notification: missionData.date_mission || new Date().toISOString(),
            type: "mission",
            statut: "nonlue"
          });
        }
      }

      // Create all notifications
      for (const notification of notifications) {
        try {
          await axios.post(`${BASE_URL}/notifications`, notification, {
            withCredentials: true
          });
        } catch (err) {
          console.error("Error creating notification:", err);
          console.error("Notification data:", notification);
        }
      }

      if (missionData.type_mission === "ambulance") {
        // Récupérer l'id de la mission créée
        const missionId = response.data.id;
        // Récupérer la localisation de la mission et la formater en string "lat,lng"
        let loc = null;
        const locObj = missionLocations['new'];
        if (locObj && typeof locObj.lat === 'number' && typeof locObj.lng === 'number') {
          loc = `${locObj.lat},${locObj.lng}`;
        }
        // Récupérer le tracker_id du véhicule sélectionné
        const vehicle = vehicles.find(v => v.user_id == missionData.ambulancier_id);
        const trackerId = vehicle?.tracker_id || null;
        // Générer un UUID pour id
        const id = uuidv4();
        // Créer l'objet map
        const map = {
          id: id,
          missionid: missionId,
          loc: loc,
          tracker_id: trackerId,
          fin: 0
        };
        // Afficher la data dans la console

        // Créer l'entrée /map avec la data map
        try {
          const mapResponse = await axios.post(
            `${BASE_URL}/map`,
            map,
            {
              withCredentials: true
            }
          );

          const phone = patients.find(p => p.id == missionData.patient_id)?.téléphone || missionData.new_patient?.téléphone;
          if (phone && map.id) {
            const message = `Omnidoc Santé\nVotre ambulance est en route. Suivez sa localisation en direct ici : https://omnidocsante.ma/prestation/${map.id}`;
            try {
              await sendSMS(phone, message);
            } catch (smsErr) {
              console.error('[DEBUG] Erreur envoi SMS', smsErr);
            }
          } else {
            console.warn('[DEBUG] Aucun numéro de téléphone patient pour SMS ou id map manquant');
          }
        } catch (err) {
          console.error('[DEBUG] Erreur création /map:', err);
        }
      }
      // Cas Consultation à domicile -> map avec userid = doctor_id
      else if (missionData.type_mission === "Consultation à domicile" && missionData.doctor_id) {
        const missionId = response.data.id;
        let loc = null;
        const locObj = missionLocations['new'];
        if (locObj && typeof locObj.lat === 'number' && typeof locObj.lng === 'number') {
          loc = `${locObj.lat},${locObj.lng}`;
        }
        const id = uuidv4();
        const map = {
          id: id,
          missionid: missionId,
          loc: loc,
          userid: parseInt(missionData.doctor_id),
          fin: 0
        };
        try {
          const mapResponse = await axios.post(
            `${BASE_URL}/map`,
            map,
            {
              withCredentials: true
            }
          );

          const phone = patients.find(p => p.id == missionData.patient_id)?.téléphone || missionData.new_patient?.téléphone;
          if (phone && map.id) {
            const message = `Omnidoc Santé\nVotre médecin est en route. Suivez sa localisation en direct ici : https://omnidocsante.ma/prestation/${map.id}`;
            try {
              await sendSMS(phone, message);
            } catch (smsErr) {
              console.error('[DEBUG] Erreur envoi SMS', smsErr);
            }
          } else {
            console.warn('[DEBUG] Aucun numéro de téléphone patient pour SMS ou id map manquant');
          }
        } catch (err) {
          console.error('[DEBUG] Erreur création /map (consultation):', err);
        }
      }
      // Cas Acte infirmier -> map avec userid = nurse_id
      else if (missionData.type_mission === "Acte infirmier" && missionData.nurse_id) {
        const missionId = response.data.id;
        let loc = null;
        const locObj = missionLocations['new'];
        if (locObj && typeof locObj.lat === 'number' && typeof locObj.lng === 'number') {
          loc = `${locObj.lat},${locObj.lng}`;
        }
        const id = uuidv4();
        const map = {
          id: id,
          missionid: missionId,
          loc: loc,
          userid: parseInt(missionData.nurse_id),
          fin: 0
        };
        try {
          const mapResponse = await axios.post(
            `${BASE_URL}/map`,
            map,
            {
              withCredentials: true
            }
          );

          const phone = patients.find(p => p.id == missionData.patient_id)?.téléphone || missionData.new_patient?.téléphone;
          if (phone && map.id) {
            const message = `Omnidoc Santé\nVotre infirmier est en route. Suivez sa localisation en direct ici : https://omnidocsante.ma/prestation/${map.id}`;
            try {
              await sendSMS(phone, message);
            } catch (smsErr) {
              console.error('[DEBUG] Erreur envoi SMS', smsErr);
            }
          } else {
            console.warn('[DEBUG] Aucun numéro de téléphone patient pour SMS ou id map manquant');
          }
        } catch (err) {
          console.error('[DEBUG] Erreur création /map (acte infirmier):', err);
        }
      }

      // Fetch updated data after adding new mission
      await fetchData();
      await fetchPatients(); // <-- Ajouté pour rafraîchir la liste des patients

      toast({ title: "Mission ajoutée avec succès", status: "success", isClosable: true });

      // Retourner la réponse pour le stepper (inclut désormais la logique map + SMS)
      return response.data;
    } catch (err) {
      console.error("Error creating mission:", err);
      toast({ title: "Erreur lors de la création de la mission", status: "error", isClosable: true });
    }
  };

  // Add logs for state changes
  useEffect(() => {
    scrollToBottom();
  }, [chatMessages]);

  const handleCloseChat = (missionId) => {
    setOpenChats(prev => ({
      ...prev,
      [missionId]: false
    }));
  };

  const decodeToken = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  };

  // Détecte si une chaîne est une URL d'image (jpg, png, gif, webp, svg, etc.)
  const isImageUrl = (text) => {
    try {
      const trimmed = text.trim();
      // Doit commencer par http(s)://
      if (!/^https?:\/\//i.test(trimmed)) return false;
      const url = new URL(trimmed);
      const pathname = url.pathname.toLowerCase();
      // Extension image connue
      if (/\.(jpg|jpeg|png|gif|webp|svg|bmp|tiff|avif)(\?.*)?$/i.test(pathname)) return true;
      // Hébergeurs d'images connus
      const imageHosts = [
        'imgur.com', 'i.imgur.com',
        'images.unsplash.com', 'unsplash.com',
        'pbs.twimg.com', 'abs.twimg.com',
        'media.giphy.com', 'giphy.com',
        'i.redd.it', 'preview.redd.it',
        'cdn.discordapp.com', 'media.discordapp.net',
        'upload.wikimedia.org',
        'googleusercontent.com',
        'cloudinary.com', 'res.cloudinary.com',
      ];
      return imageHosts.some(host => url.hostname.includes(host));
    } catch {
      return false;
    }
  };

  // Gérer le collage d'image depuis le presse-papier (Ctrl+V)
  const handlePaste = (e, missionId) => {
    const items = e.clipboardData?.items;
    if (!items) return;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.startsWith('image/')) {
        e.preventDefault();
        const file = item.getAsFile();
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (ev) => {
          setPastedImage({ dataUrl: ev.target.result, missionId });
        };
        reader.readAsDataURL(file);
        return; // Une seule image à la fois
      }
    }
    // Si pas d'image → laisser le texte se coller normalement
  };

  const handleSendPastedImage = async (missionId) => {
    if (!pastedImage) return;
    await handleSendMessage(missionId, 'image', pastedImage.dataUrl);
    setPastedImage(null);
  };

  const handleMessageChange = (e) => {
    const value = e.target.value;
    setNewMessage(value);
  };

  const handleSendMessage = async (missionId, type = 'text', mediaData = null) => {
    let messageToSend = newMessage.trim();

    // Détecter automatiquement si le texte est une URL d'image
    if (type === 'text' && messageToSend && isImageUrl(messageToSend)) {
      type = 'image_url';
      mediaData = messageToSend;
      messageToSend = '';
    }

    if (type === 'text' && (!messageToSend)) {
      toast({
        title: "Erreur",
        description: "Le message ne peut pas être vide",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if ((type === 'audio' || type === 'image') && !mediaData) {
      toast({
        title: "Erreur",
        description: "Données média manquantes",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const messageData = {
        mission_id: missionId,
        type: type === 'image_url' ? 'image_url' : type,
        // message contient soit l'URL (image_url), soit le texte normal/légende
        message: type === 'image_url' ? mediaData : messageToSend,
        // media_data contient les données binaires (base64) pour audio/image
        media_data: (type === 'audio' || type === 'image') ? mediaData : null
      };

      const response = await createMessage(messageData);

      const transformedMessage = {
        ...response.data,
        user_id: response.data.sender_id,
        content: response.data.message,
        media_data: response.data.media_data,
        type: response.data.type,
        user_name: `${response.data.nom} ${response.data.prenom}`,
        user_photo: response.data.photo
      };

      // Le message est désormais diffusé par le backend après l'insertion réussie via l'API


      // Mettre à jour l'état local
      setChatMessages(prev => {
        const currentMessages = prev[missionId] || [];
        const messageExists = currentMessages.some(m => m.id === transformedMessage.id);
        if (messageExists) {
          return prev;
        }
        return {
          ...prev,
          [missionId]: [...currentMessages, transformedMessage]
        };
      });

      setNewMessage('');
      setTimeout(scrollToBottom, 100);

      toast({
        title: "Succès",
        description: "Message envoyé",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Erreur lors de l\'envoi du message:', error);
      toast({
        title: "Erreur",
        description: error.response?.data?.message || "Impossible d'envoyer le message",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Handler for image upload
  const handleImageUpload = (missionId) => {
    imageInputRef.current?.click();
  };

  const handleImageChange = async (event, missionId) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      toast({
        title: "Erreur",
        description: "Veuillez sélectionner un fichier image",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (file.size > 5 * 1024 * 1024) { // 5MB limit
      toast({
        title: "Erreur",
        description: "L'image ne doit pas dépasser 5MB",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const base64 = e.target.result;
      // Mettre en prévisualisation au lieu d'envoyer direct
      setPastedImage({ dataUrl: base64, missionId });
    };
    reader.readAsDataURL(file);

    // Reset input
    event.target.value = '';
  };

  // Handler for audio recording
  const handleAudioUpload = async (missionId) => {
    if (isRecording) {
      if (mediaRecorder && mediaRecorder.state !== 'inactive') {
        try {
          mediaRecorder.stop();
        } catch (err) {
          console.error('Error stopping recorder:', err);
          setIsRecording(false);
          setMediaRecorder(null);
        }
      } else {
        setIsRecording(false);
        setMediaRecorder(null);
      }
    } else {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const recorder = new MediaRecorder(stream);
        const chunks = [];

        recorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            chunks.push(event.data);
          }
        };

        recorder.onstop = async () => {
          try {
            if (chunks.length > 0) {
              const blob = new Blob(chunks, { type: 'audio/webm' });
              const reader = new FileReader();
              reader.onload = async (e) => {
                try {
                  const base64 = e.target.result;
                  await handleSendMessage(missionId, 'audio', base64);
                } catch (sendErr) {
                  console.error('Error sending audio message:', sendErr);
                }
              };
              reader.readAsDataURL(blob);
            }
          } catch (err) {
            console.error('Error in onstop:', err);
          } finally {
            stream.getTracks().forEach(track => track.stop());
            setIsRecording(false);
            setMediaRecorder(null);
          }
        };

        setMediaRecorder(recorder);
        recorder.start();
        setIsRecording(true);
      } catch (error) {
        console.error('Error starting recording:', error);
        toast({
          title: "Erreur",
          description: "Impossible d'accéder au microphone",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setIsRecording(false);
      }
    }
  };

  const handleAudioChange = async (event, missionId) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('audio/')) {
      toast({
        title: "Erreur",
        description: "Veuillez sélectionner un fichier audio",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (file.size > 10 * 1024 * 1024) { // 10MB limit
      toast({
        title: "Erreur",
        description: "L'audio ne doit pas dépasser 10MB",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const base64 = e.target.result;
      await handleSendMessage(missionId, 'audio', base64);
    };
    reader.readAsDataURL(file);

    // Reset input
    event.target.value = '';
  };

  // Modifier la fonction handleMinimizeChat
  const handleMinimizeChat = (missionId) => {
    setMinimizedChats(prev => ({
      ...prev,
      [missionId]: !prev[missionId]
    }));

    // Si on maximise le chat, attendre que l'animation soit terminée avant de défiler
    if (minimizedChats[missionId]) {
      setTimeout(() => {
        scrollToBottom();
      }, 300); // Attendre la fin de l'animation de transition
    }
  };

  // Ajouter une fonction pour obtenir le nom du patient
  const getPatientName = (missionId) => {
    const mission = tableData.find(m => m.id === parseInt(missionId));
    if (mission) {
      const patient = patients.find(p => p.id === mission.patient_id);
      if (patient) {
        return `${patient.nom} ${patient.prenom}`;
      }
    }
    return `Chat Mission #${missionId}`;
  };

  const getChatPosition = (missionId) => {
    const openChatsArray = Object.keys(openChats).filter(id => openChats[id]);
    const index = openChatsArray.indexOf(missionId);
    return index * 370 + 20;
  };

  const handleLocationSelect = (locationData) => {

    setNewMissionData(prev => ({
      ...prev,
      adresse: locationData.formattedAddress,
      loc: prev.type_mission === 'ambulance' ? prev.loc : `${locationData.location.lat},${locationData.location.lng}`
    }));

    setMissionLocations(prev => ({
      ...prev,
      [newMissionData.id || 'new']: locationData.location
    }));
  };

  const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);

  useEffect(() => {
    if (!window.google) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        setIsGoogleMapsLoaded(true);
      };
      document.head.appendChild(script);

      return () => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      };
    } else {
      setIsGoogleMapsLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  // Ajouter un intervalle pour rafraîchir les données toutes les 5 secondes
  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        if (isActionsMenuOpen) {
          return;
        }

        const response = await axios.get(`${BASE_URL}/missions`, {
          withCredentials: true
        });

        // Trier les missions par date_mission en ordre décroissant
        const sortedMissions = response.data.sort((a, b) => {
          return new Date(b.date_mission) - new Date(a.date_mission);
        });

        // Éviter un re-render inutile toutes les 5s (sinon le menu actions se ferme)
        setTableData(prevData => {
          const prevSerialized = JSON.stringify(prevData);
          const nextSerialized = JSON.stringify(sortedMissions);
          return prevSerialized === nextSerialized ? prevData : sortedMissions;
        });

        // Si le modal de visualisation est ouvert, mettre à jour les données de la mission en cours
        if (isViewOpen && viewData) {
          const updatedMission = sortedMissions.find(mission => mission.id === viewData.id);
          if (updatedMission) {
            setViewData(updatedMission);
          }
        }
      } catch (error) {
        console.error("Error refreshing data:", error);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [isViewOpen, viewData, isActionsMenuOpen]);



  useEffect(() => {
    if (isAddOpen) {
      setNewMissionData(prev => ({
        ...prev,
        date_mission: prev.etat_mission === "urgente" ? dayjs().tz('Africa/Casablanca').format('YYYY-MM-DDTHH:mm') : prev.date_mission
      }));
    }
  }, [isAddOpen]);

  // Ajout de la fonction pour gérer la saisie patient
  const handlePatientFieldChange = (field, value) => {
    setNewMissionData(prev => {
      const updatedPatient = { ...prev.new_patient, [field]: value };
      // Recherche d'un patient existant
      const found = patients.find(
        p =>
          p.nom.trim().toLowerCase() === (updatedPatient.nom || '').trim().toLowerCase() &&
          p.prenom.trim().toLowerCase() === (updatedPatient.prenom || '').trim().toLowerCase() &&
          p.téléphone.trim() === (updatedPatient.téléphone || '').trim()
      );
      return {
        ...prev,
        new_patient: updatedPatient,
        patient_id: found ? found.id : ""
      };
    });
  };

  // Filtrage des médecins selon la ville sélectionnée pour le modal d'ajout
  const filteredDoctorsForAdd = useMemo(() => {
    const ville = newMissionData.ville;
    if (!ville) return doctors;
    return doctors.filter(doc => doc.ville === ville);
  }, [doctors, newMissionData.ville]);

  // Filtrage des infirmiers selon la ville sélectionnée pour le modal d'ajout
  const filteredNursesForAdd = useMemo(() => {
    const ville = newMissionData.ville;
    if (!ville) return nurses;
    return nurses.filter(nurse => nurse.ville === ville);
  }, [nurses, newMissionData.ville]);

  // Filtrage des médecins selon la ville sélectionnée pour le modal d'édition
  const filteredDoctorsForEdit = useMemo(() => {
    const ville = editData?.ville;
    if (!ville) return doctors;
    return doctors.filter(doc => doc.ville === ville);
  }, [doctors, editData?.ville]);

  // Filtrage des infirmiers selon la ville sélectionnée pour le modal d'édition
  const filteredNursesForEdit = useMemo(() => {
    const ville = editData?.ville;
    if (!ville) return nurses;
    return nurses.filter(nurse => nurse.ville === ville);
  }, [nurses, editData?.ville]);

  // Update search logic to include bon_de_commande (ref), num, patient_name and id (Référence)
  const filteredTableData = useMemo(() => {
    const searchLower = searchQuery.toLowerCase();
    return mappedTableData.filter(row => {
      return (
        (row.id?.toString() || '').includes(searchLower) ||
        (row.patient_name?.toLowerCase() || '').includes(searchLower) ||
        (row.ambulancier?.toLowerCase() || '').includes(searchLower) ||
        (row.type_ambulance?.toLowerCase() || '').includes(searchLower) ||
        (row.bon_de_commande?.toLowerCase() || '').includes(searchLower) ||
        (row.etat_mission?.toLowerCase() || '').includes(searchLower) ||
        (row.date_mission?.toLowerCase() || '').includes(searchLower) ||
        (row.statut?.toLowerCase() || '').includes(searchLower) ||
        (row.type_mission?.toLowerCase() || '').includes(searchLower) ||
        (row.num?.toLowerCase() || '').includes(searchLower)
      );
    });
  }, [mappedTableData, searchQuery]);

  // Calculer les statistiques des missions
  const missionStats = useMemo(() => {
    const total = tableData.length;
    const terminees = tableData.filter(m => m.statut === 'terminée').length;
    const enCours = tableData.filter(m => m.statut === 'en cours' || m.statut === 'créée').length;
    const annulees = tableData.filter(m => m.statut === 'annulée').length;

    return {
      total,
      terminees,
      enCours,
      annulees
    };
  }, [tableData]);

  // (Plus d’API /api/calls/active ici : tout est géré par JsSIP/WebRTC)

  // Appel sortant WebRTC via JsSIP (direct PBX)
  const callWebRTC = async (number) => {
    if (!sipUA) {
      toast({
        title: "Softphone non initialisé",
        description: "Connecte d'abord le téléphone (extension / SIP).",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (!number || !String(number).trim()) {
      toast({
        title: "Numéro manquant",
        description: "Veuillez saisir un numéro à appeler.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    try {
      console.log(`📞 Calling ${number}`);

      // Check if we're on HTTPS or localhost
      const isSecure = window.location.protocol === 'https:' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      console.log('   🔒 Secure context:', isSecure);

      // Get microphone stream FIRST and pass it to JsSIP (comme dans le mini-projet qui fonctionne)
      console.log('   🎤 Getting microphone...');
      let localStream;
      try {
        localStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
        console.log('   ✅ Microphone ready, tracks:', localStream.getAudioTracks().length);
        console.log('   🎤 Track enabled:', localStream.getAudioTracks()[0]?.enabled);
        console.log('   🎤 Track muted:', localStream.getAudioTracks()[0]?.muted);
      } catch (micError) {
        console.error('   ❌ Microphone error:', micError.name, micError.message);
        throw micError;
      }

      // Options exactement comme dans le mini-projet qui fonctionne
      const options = {
        mediaConstraints: { audio: true, video: false },
        mediaStream: localStream, // Pass our microphone stream
        pcConfig: {
          iceServers: [], // Local network - no STUN (comme dans le mini-projet)
          bundlePolicy: 'max-bundle', // Utiliser 'max-bundle' comme dans le mini-projet
          rtcpMuxPolicy: 'require',
          iceTransportPolicy: 'all'
        },
        rtcOfferConstraints: {
          offerToReceiveAudio: true,
          offerToReceiveVideo: false
        }
      };

      const targetUri = `sip:${String(number).trim()}@${PBX_IP}`;
      console.log('   📞 Calling', targetUri);

      const session = sipUA.call(targetUri, options);
      setCurrentSipSession(session);
      attachSessionEvents(session);

      session.on('progress', () => {
        console.log('📞 Sonnerie (WebRTC)…');
        toast({
          title: 'Appel en cours',
          description: `Sonnerie vers ${number}...`,
          status: 'info',
          duration: 2000,
          isClosable: true,
        });
      });
    } catch (err) {
      console.error('❌ Erreur appel WebRTC:', err);
      toast({
        title: "Erreur lors de l'appel",
        description: err.message || "Impossible de lancer l'appel WebRTC (micro ou connexion). Vérifiez les permissions du navigateur.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const hangupWebRTC = () => {
    if (currentSipSession) {
      try {
        console.log('📞 Raccrochage de l\'appel...');

        // Arrêter l'enregistrement automatique avant de terminer la session
        stopCallRecording();

        // Arrêter tous les tracks audio locaux
        const pc = currentSipSession.connection;
        if (pc) {
          pc.getSenders().forEach(sender => {
            if (sender.track) {
              sender.track.stop();
              console.log('🛑 Track local arrêté:', sender.track.id);
            }
          });
        }

        // Terminer la session
        currentSipSession.terminate();
        console.log('✅ Appel terminé');
      } catch (e) {
        console.error('❌ Erreur terminate session:', e);
      }

      // Nettoyer l'audio distant
      if (remoteAudioRef.current) {
        remoteAudioRef.current.srcObject = null;
      }

      setCurrentSipSession(null);
      setIncomingCall(null);
    }

    // Arrêter le bip d'appel entrant lié à la popup missions
    if (incomingBeepRef.current) {
      clearInterval(incomingBeepRef.current);
      incomingBeepRef.current = null;
    }

    // Arrêter la sonnerie éventuelle du softphone global (mini‑projet)
    if (typeof window !== 'undefined' && typeof window.stopRingtone === 'function') {
      try {
        window.stopRingtone();
        console.log('🔕 Sonnerie arrêtée via stopRingtone()');
      } catch (e) {
        console.warn('Impossible d\'arrêter la sonnerie via stopRingtone:', e);
      }
    }
  };

  // Répondre à un appel entrant WebRTC (version simplifiée comme dans le mini‑projet)
  const answerIncomingCall = async () => {
    if (!incomingCall?.session) {
      console.error('❌ Aucune session d\'appel entrant disponible');
      toast({
        title: 'Erreur',
        description: 'Pas d\'appel entrant à répondre.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const session = incomingCall.session;

    try {
      console.log('📞 ====== ANSWERING CALL ======');
      console.log('   Session state:', session.status);

      // Attacher les événements AVANT de répondre
      attachSessionEvents(session);

      // Demander le micro comme dans le mini‑projet
      let localStream;
      try {
        console.log('   🎤 Getting microphone...');
        localStream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: false,
        });
        console.log('   ✅ Microphone ready for answer');
      } catch (e) {
        console.error('   ❌ Microphone error:', e);
        toast({
          title: 'Erreur micro',
          description: 'Accès au microphone refusé. Autorisez le micro dans votre navigateur.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      // Réponse WebRTC simple (sans modification manuelle du SDP)
      session.answer({
        mediaConstraints: { audio: true, video: false },
        mediaStream: localStream,
        pcConfig: {
          iceServers: [],          // même config que pour l’appel sortant
          bundlePolicy: 'max-bundle',
          rtcpMuxPolicy: 'require',
        },
      });

      console.log('   ✅ Answer sent');

      setCurrentSipSession(session);
      setIncomingCall(null);

      // Arrêter le bip d'appel entrant lié à la popup missions
      if (incomingBeepRef.current) {
        clearInterval(incomingBeepRef.current);
        incomingBeepRef.current = null;
      }

      // Si la sonnerie du softphone mini‑projet est en cours, l'arrêter
      if (typeof window !== 'undefined' && typeof window.stopRingtone === 'function') {
        try {
          window.stopRingtone();
          console.log('🔕 Sonnerie arrêtée via stopRingtone() après réponse');
        } catch (e) {
          console.warn('Impossible d\'arrêter la sonnerie via stopRingtone après réponse:', e);
        }
      }

      toast({
        title: 'Appel accepté',
        description: 'Vous pouvez maintenant parler.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (err) {
      console.error('❌ Erreur lors de la réponse à l\'appel entrant:', err);

      toast({
        title: '❌ Erreur lors de la réponse',
        description: err.message || 'Impossible de répondre à l\'appel.',
        status: 'error',
        duration: 6000,
        isClosable: true,
      });

      try {
        session.terminate();
      } catch (e) {
        console.error('Erreur terminate:', e);
      }
      setIncomingCall(null);
      setCurrentSipSession(null);
    }
  };

  // Rejeter / raccrocher l'appel entrant avant réponse
  const rejectIncomingCall = () => {
    if (!incomingCall?.session) return;

    // Récupérer le channel AMI (soit depuis incomingCall missions, soit depuis callsContext)
    const channelToHangup = incomingCall.channel || callsContext?.incomingCall?.channel;

    // Terminer la session WebRTC
    try {
      incomingCall.session.terminate();
      console.log('📴 Session WebRTC terminée');
    } catch (e) {
      console.error('Erreur terminate sur appel entrant:', e);
    }

    // Arrêter le bip d'appel entrant lié à la popup missions
    if (incomingBeepRef.current) {
      clearInterval(incomingBeepRef.current);
      incomingBeepRef.current = null;
    }

    // Raccrocher aussi côté PBX via AMI pour arrêter la sonnerie des téléphones fixes
    if (channelToHangup && callsContext?.rejectCall) {
      try {
        console.log('📴 Rejet AMI de l\'appel sur le channel', channelToHangup);
        callsContext.rejectCall(channelToHangup).catch(err => {
          console.error('Erreur lors du rejet AMI de l\'appel:', err);
        });
      } catch (err) {
        console.error('Erreur lors du rejet AMI de l\'appel:', err);
      }
    } else {
      console.warn('⚠️ Pas de channel AMI disponible pour raccrocher l\'appel côté PBX');
    }

    // Nettoyer l'état local
    setIncomingCall(null);
  };

  // Handler pour la connexion téléphone (appel API backend + initialisation JsSIP)
  const handleConnectPhone = async () => {
    try {
      if (!phoneExtension || !sipPassword) {
        toast({
          title: 'Champs obligatoires',
          description: 'Merci de saisir l’extension et le mot de passe SIP.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const ext = String(phoneExtension).trim();
      const passToUse = sipPassword.trim();
      const domain = sipDomain.trim() || PBX_IP; // Utiliser le domaine si fourni, sinon l'IP

      if (!passToUse) {
        toast({
          title: 'Mot de passe requis',
          description: 'Le mot de passe SIP ne peut pas être vide.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      setPhoneExtension(ext);

      // Nettoyer l'ancienne connexion si elle existe
      if (sipUA) {
        try {
          sipUA.stop();
          sipUA.unregister();
        } catch (e) {
          console.warn('Erreur nettoyage ancien UA:', e);
        }
        setSipUA(null);
        setSipRegistered(false);
        setIsPhoneConnected(false);
      }

      // Sauvegarder l'extension utilisée pour la lier au contexte des appels (CallsContext)
      try {
        if (typeof window !== 'undefined' && window.localStorage) {
          window.localStorage.setItem('softphone_extension', ext);
          console.log('☎️ Extension softphone enregistrée dans localStorage:', ext);
        }
        // Informer le CallsContext de la nouvelle extension suivie
        if (callsContext?.setExtension) {
          callsContext.setExtension(ext);
          console.log('☎️ Extension mise à jour dans CallsContext:', ext);
        }
      } catch (e) {
        console.warn('Impossible de mettre à jour l\'extension softphone:', e);
      }

      // Utiliser JsSIP depuis le paquet NPM
      const JsSIPLib = JsSIP;

      // Patch WebSocketInterface pour ignorer les keepalive "-1" envoyés par le PBX
      if (!JsSIPLib.__patchedKeepAlive) {
        try {
          const WSI = JsSIPLib.WebSocketInterface;
          if (WSI && WSI.prototype && WSI.prototype._onMessage) {
            const originalOnMessage = WSI.prototype._onMessage;
            WSI.prototype._onMessage = function (event) {
              const data = event && event.data;
              if (typeof data === 'string' && data.trim() === '-1') {
                console.log('🔁 Keepalive "-1" reçu du PBX, ignoré');
                return;
              }
              return originalOnMessage.call(this, event);
            };
            JsSIPLib.__patchedKeepAlive = true;
            console.log('✅ Patch keepalive "-1" appliqué sur WebSocketInterface');
          }
        } catch (e) {
          console.warn('Impossible de patcher WebSocketInterface pour les keepalive "-1":', e);
        }
      }

      // Initialiser JsSIP (softphone WebRTC) pour cette extension avec la même lib que le mini‑projet
      try {
        const wsPort = 8089; // port WebSocket Grandstream typique
        const socketWebRTC = new JsSIPLib.WebSocketInterface(
          `wss://${PBX_IP}:${wsPort}/ws`
        );

        const sipUri = `sip:${ext}@${domain}`;
        console.log('🔌 Tentative connexion SIP:', {
          uri: sipUri,
          wsUrl: `wss://${PBX_IP}:${wsPort}/ws`,
          extension: ext,
          domain: domain,
          passwordLength: passToUse.length,
          hasPassword: !!passToUse
        });

        const configuration = {
          sockets: [socketWebRTC],
          uri: sipUri,
          password: passToUse,
          register: true,
          session_timers: false,
        };

        const ua = new JsSIPLib.UA(configuration);

        ua.on('connected', () => {
          console.log('✅ WebRTC WebSocket connecté');
          setIsPhoneConnected(true);
        });
        ua.on('registered', () => {
          console.log('✅ Extension WebRTC enregistrée:', ext);
          setSipRegistered(true);
          onPhoneModalClose(); // Fermer le modal seulement quand l'enregistrement est confirmé
          toast({
            title: 'Téléphone connecté',
            description: `Extension ${ext} enregistrée avec succès.`,
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
        });
        ua.on('registrationFailed', (e) => {
          const response = e.response;
          const statusCode = response?.status_code;
          const wwwAuth = response?.getHeader('WWW-Authenticate') || '';
          const realm = wwwAuth.match(/realm="([^"]+)"/)?.[1] || 'non spécifié';
          const algorithm = wwwAuth.match(/algorithm=([^,\s]+)/)?.[1] || 'non spécifié';

          console.error('❌ Enregistrement WebRTC échoué:', {
            cause: e.cause,
            statusCode,
            realm,
            algorithm,
            uri: sipUri,
            extension: ext,
            domain: domain,
            passwordLength: passToUse.length,
            hasPassword: !!passToUse,
            wwwAuthenticate: wwwAuth
          });

          setSipRegistered(false);
          setIsPhoneConnected(false);

          let errorMessage = `❌ Échec d'enregistrement pour l'extension ${ext}`;

          if (statusCode === 403 || e.cause === 'Rejected') {
            errorMessage += `\n\nLe serveur PBX a rejeté l'enregistrement (403 Forbidden).`;
            errorMessage += `\n\n🔧 Causes possibles :`;

            errorMessage += `\n\n1️⃣ EXTENSION DÉJÀ ENREGISTRÉE AILLEURS :`;
            errorMessage += `\n   ⚠️ L'extension ${ext} est probablement déjà connectée sur un autre appareil ou logiciel`;
            errorMessage += `\n   📍 Solutions :`;
            errorMessage += `\n   • Déconnectez l'extension ${ext} des autres appareils (téléphone physique, autre softphone, etc.)`;
            errorMessage += `\n   • Dans le PBX : Extensions → ${ext} → Vérifiez les connexions actives`;
            errorMessage += `\n   • Attendez quelques secondes et réessayez`;

            errorMessage += `\n\n2️⃣ EXTENSION DÉSACTIVÉE OU BLOQUÉE :`;
            errorMessage += `\n   • Vérifiez que l'extension ${ext} est activée dans le PBX`;
            errorMessage += `\n   • Vérifiez qu'elle n'est pas bloquée ou restreinte`;
            errorMessage += `\n   • Dans le PBX : Extensions → ${ext} → Vérifiez le statut`;

            errorMessage += `\n\n3️⃣ WEBRTC NON AUTORISÉ POUR CETTE EXTENSION :`;
            errorMessage += `\n   • Vérifiez que WebRTC/WebSocket est autorisé pour l'extension ${ext}`;
            errorMessage += `\n   • Dans le PBX : Extensions → ${ext} → WebRTC Settings → Enable WebRTC`;
            errorMessage += `\n   • Vérifiez qu'il n'y a pas de restriction sur le nombre de connexions simultanées`;

            errorMessage += `\n\n4️⃣ LIMITE DE CONNEXIONS ATTEINTE :`;
            errorMessage += `\n   • Le PBX peut avoir une limite sur le nombre de connexions simultanées`;
            errorMessage += `\n   • Vérifiez les paramètres de limitation dans le PBX`;

          } else if (statusCode === 401 || e.cause === 'Authentication Error') {
            errorMessage += `\n\nLe serveur PBX refuse l'authentification (401 Unauthorized).`;
            errorMessage += `\n\n🔧 Solutions à vérifier :`;

            errorMessage += `\n\n1️⃣ MOT DE PASSE SIP (le plus probable) :`;
            errorMessage += `\n   ⚠️ Le mot de passe que vous avez saisi est incorrect ou ne correspond pas à l'extension ${ext}`;
            errorMessage += `\n   📍 Où le trouver :`;
            errorMessage += `\n   • Interface admin PBX Grandstream → Extensions → Extension ${ext}`;
            errorMessage += `\n   • Onglet "Account Settings" ou "SIP Settings"`;
            errorMessage += `\n   • Cherchez "SIP Password", "Secret", "Auth Password" ou "Password"`;
            errorMessage += `\n   • ⚠️ Ce n'est PAS le mot de passe admin du PBX !`;

            errorMessage += `\n\n2️⃣ EXTENSION EXISTE ET EST CONFIGURÉE :`;
            errorMessage += `\n   • Vérifiez que l'extension ${ext} existe bien sur le PBX`;
            errorMessage += `\n   • Vérifiez que WebRTC/WebSocket est activé pour cette extension`;
            errorMessage += `\n   • Dans le PBX : Extensions → ${ext} → WebRTC Settings → Enable WebRTC`;

            errorMessage += `\n\n3️⃣ DOMAINE SIP :`;
            errorMessage += `\n   • Actuellement utilisé : "${domain}"`;
            errorMessage += `\n   • Realm serveur : "${realm}"`;
            if (realm && realm !== 'non spécifié' && realm.toLowerCase() === domain.toLowerCase()) {
              errorMessage += `\n   ✅ Le domaine correspond au realm (${realm})`;
            } else if (realm && realm !== 'non spécifié') {
              errorMessage += `\n   ⚠️ Le domaine "${domain}" ne correspond pas au realm "${realm}"`;
              errorMessage += `\n   💡 Essayez de mettre "${realm}" dans le champ "Domaine SIP"`;
            }

            errorMessage += `\n\n4️⃣ TESTER AVEC UNE AUTRE EXTENSION :`;
            errorMessage += `\n   • Si vous avez accès à une autre extension (ex: 300, 301, 302), testez avec celle-ci`;
            errorMessage += `\n   • Cela permettra de savoir si le problème est spécifique à l'extension ${ext}`;
          } else {
            errorMessage += `\n\nCause: ${e.cause || 'Inconnue'}`;
            errorMessage += `\nCode HTTP: ${statusCode || 'N/A'}`;

            if (statusCode) {
              errorMessage += `\n\n💡 Code HTTP ${statusCode} :`;
              if (statusCode === 404) {
                errorMessage += ` Extension non trouvée sur le PBX.`;
              } else if (statusCode === 408) {
                errorMessage += ` Timeout : Le serveur n'a pas répondu à temps.`;
              } else if (statusCode >= 500) {
                errorMessage += ` Erreur serveur PBX. Contactez l'administrateur.`;
              }
            }
          }

          let toastTitle = '❌ Erreur d\'enregistrement SIP';
          if (statusCode === 403 || e.cause === 'Rejected') {
            toastTitle = '❌ Enregistrement rejeté (403)';
          } else if (statusCode === 401 || e.cause === 'Authentication Error') {
            toastTitle = '❌ Erreur d\'authentification SIP (401)';
          }

          toast({
            title: toastTitle,
            description: errorMessage,
            status: 'error',
            duration: 15000,
            isClosable: true,
          });
        });

        ua.on('newRTCSession', (e) => {
          const session = e.session;

          // Appel entrant WebRTC : on affiche un bandeau avec Répondre / Raccrocher
          if (e.originator === 'remote') {
            const caller = session.remote_identity?.uri?.user || 'Inconnu';
            console.log('📞 ====== INCOMING CALL ======');
            console.log('   From:', caller);
            console.log('   Session state:', session.status);
            console.log('   Direction:', session.direction);

            // On ne modifie plus manuellement le SDP ici : on laisse JsSIP gérer
            setIncomingCall({ session, from: caller });
          }
        });

        ua.start();
        setSipUA(ua);
        // Le modal sera fermé automatiquement dans ua.on('registered') si succès
        // Le toast de succès sera aussi affiché dans ua.on('registered')
      } catch (err) {
        console.error('Erreur initialisation JsSIP:', err);
        setSipRegistered(false);
        setIsPhoneConnected(false);
        toast({
          title: 'Erreur WebRTC',
          description: `Impossible d'initialiser JsSIP: ${err.message || 'Erreur inconnue'}`,
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        return;
      }
    } catch (error) {
      console.error('Erreur connexion téléphone:', error);
      toast({
        title: 'Erreur',
        description: error.response?.data?.message || 'Erreur lors de la connexion au téléphone.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Fonctions de validation par étape
  const validateStep1 = () => {
    if (!newMissionData.type_mission) {
      toast({
        title: 'Champ obligatoire',
        description: 'Veuillez sélectionner un type de mission',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    return true;
  };

  const validateStep2 = () => {
    const newInvalidFields = {};
    const requiredFields = [
      { key: 'etat_mission', label: 'État de Mission' },
      { key: 'date_mission', label: 'Date de Mission', condition: newMissionData.etat_mission === 'planifiée' },
      { key: 'cause', label: 'Cause' },
      { key: 'adresse', label: 'Adresse de Mission', condition: newMissionData.type_mission !== 'Téléconsultation' },
      { key: 'ville', label: 'Ville', condition: newMissionData.type_mission !== 'Téléconsultation' },
      { key: 'type_ambulance', label: "Type d'Ambulance", condition: newMissionData.type_mission === 'ambulance' },
      { key: 'ambulancier_id', label: 'Ambulancier', condition: newMissionData.type_mission === 'ambulance' },
      { key: 'nurse_id', label: 'Infirmier', condition: newMissionData.type_mission === 'Acte infirmier' },
      { key: 'doctor_id', label: 'Docteur', condition: (newMissionData.type_mission === "ambulance" && newMissionData.type_ambulance === "TAR") || newMissionData.type_mission === "Consultation à domicile" || newMissionData.type_mission === "Téléconsultation" },
    ];

    let firstInvalid = null;
    for (const field of requiredFields) {
      if (field.condition === false) continue;
      let value = newMissionData[field.key];
      if (value === undefined || value === null || value === '' || (typeof value === 'string' && value.trim() === '')) {
        newInvalidFields[field.key] = `Le champ "${field.label}" est obligatoire.`;
        if (!firstInvalid) firstInvalid = field.label;
      }
    }

    if (Object.keys(newInvalidFields).length > 0) {
      setInvalidFields(newInvalidFields);
      toast({
        title: 'Champs obligatoires manquants',
        description: `Veuillez remplir tous les champs obligatoires. Premier champ manquant : ${firstInvalid}`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    return true;
  };

  const validateStep3 = () => {
    const newInvalidFields = {};
    const requiredFields = [
      { key: 'new_patient.nom', label: 'Nom du patient' },
      { key: 'new_patient.prenom', label: 'Prénom du patient' },
      { key: 'new_patient.téléphone', label: 'Téléphone du patient' },
    ];

    let firstInvalid = null;
    for (const field of requiredFields) {
      if (field.condition === false) continue;
      let value = newMissionData;
      let fieldKey = field.key;
      if (field.key.includes('.')) {
        const [parent, child] = field.key.split('.');
        value = value[parent]?.[child];
        fieldKey = `${parent}_${child}`;
      } else {
        value = value[field.key];
      }
      if (value === undefined || value === null || value === '' || (typeof value === 'string' && value.trim() === '')) {
        newInvalidFields[fieldKey] = `Le champ "${field.label}" est obligatoire.`;
        if (!firstInvalid) firstInvalid = field.label;
      }
    }

    if (Object.keys(newInvalidFields).length > 0) {
      setInvalidFields(newInvalidFields);
      toast({
        title: 'Champs obligatoires manquants',
        description: `Veuillez remplir tous les champs obligatoires. Premier champ manquant : ${firstInvalid}`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    return true;
  };

  // Fonction pour passer à l'étape suivante
  const handleNextStep = async () => {
    let isValid = false;
    if (activeStep === 0) {
      isValid = validateStep1();
    } else if (activeStep === 1) {
      isValid = validateStep2();
    } else if (activeStep === 2) {
      isValid = validateStep3();
      if (isValid) {
        // Dernière étape avant confirmation - créer la mission
        await handleAddWithStepper();
        return;
      }
    }

    if (isValid && activeStep < steps.length - 1) {
      setActiveStep(activeStep + 1);
    }
  };

  // Fonction pour revenir à l'étape précédente
  const handlePrevStep = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  // Modifier handleAdd pour qu'il passe à l'étape de confirmation après création
  const handleAddWithStepper = async () => {
    if (isAdding) return;

    const newInvalidFields = {};
    const requiredFields = [
      { key: 'type_mission', label: 'Type de Mission' },
      { key: 'adresse', label: 'Adresse de Mission', condition: newMissionData.type_mission !== 'Téléconsultation' },
      { key: 'ville', label: 'Ville', condition: newMissionData.type_mission !== 'Téléconsultation' },
      { key: 'etat_mission', label: 'État de Mission' },
      { key: 'date_mission', label: 'Date de Mission', condition: newMissionData.etat_mission === 'planifiée' },
      { key: 'cause', label: 'Cause' },
      { key: 'type_client', label: 'Type de Client' },
      { key: 'client_id', label: 'Client', condition: newMissionData.type_client !== 'particulier' },
      { key: 'bon_de_commande', label: 'Bon de Commande', condition: newMissionData.type_client !== 'particulier' },
      { key: 'prix', label: 'Prix', condition: newMissionData.type_client !== 'assurance' },
      { key: 'paiement', label: 'Mode de Paiement', condition: newMissionData.type_client !== 'assurance' },
      { key: 'paye', label: 'Statut de Paiement', condition: newMissionData.type_client !== 'assurance' },
      { key: 'new_patient.nom', label: 'Nom du patient' },
      { key: 'new_patient.prenom', label: 'Prénom du patient' },
      { key: 'new_patient.téléphone', label: 'Téléphone du patient' },
      { key: 'correspondance', label: 'Correspondance', condition: newMissionData.type_client === 'particulier' },
      { key: 'correspondance_details', label: 'Détails de Correspondance', condition: newMissionData.type_client === 'particulier' && (newMissionData.correspondance === 'Médecin' || newMissionData.correspondance === 'Confrère') },
      { key: 'type_ambulance', label: "Type d'Ambulance", condition: newMissionData.type_mission === 'ambulance' },
      { key: 'ambulancier_id', label: 'Ambulancier', condition: newMissionData.type_mission === 'ambulance' },
      { key: 'nurse_id', label: 'Infirmier', condition: newMissionData.type_mission === 'Acte infirmier' },
      { key: 'nurse_type', label: 'Spécialité de l\'Infirmier', condition: newMissionData.nurse_id !== '' },
      { key: 'doctor_id', label: 'Docteur', condition: (newMissionData.type_mission === "ambulance" && newMissionData.type_ambulance === "TAR") || newMissionData.type_mission === "Consultation à domicile" || newMissionData.type_mission === "Téléconsultation" },
    ];
    let firstInvalid = null;
    for (const field of requiredFields) {
      if (field.condition === false) continue;
      let value = newMissionData;
      let fieldKey = field.key;
      if (field.key.includes('.')) {
        const [parent, child] = field.key.split('.');
        value = value[parent]?.[child];
        fieldKey = `${parent}_${child}`;
      } else {
        value = value[field.key];
      }
      if (value === undefined || value === null || value === '' || (typeof value === 'string' && value.trim() === '')) {
        newInvalidFields[fieldKey] = `Le champ "${field.label}" est obligatoire.`;
        if (!firstInvalid) firstInvalid = field.label;
      }
    }
    setInvalidFields(newInvalidFields);
    if (Object.keys(newInvalidFields).length > 0) {
      toast({
        title: 'Champs obligatoires manquants',
        description: `Veuillez remplir tous les champs obligatoires. Premier champ manquant : ${firstInvalid}`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setIsAdding(true);
      let patientId = newMissionData.patient_id;

      if (newMissionData.ambulancier_id) {
        const missionsRes = await axios.get(`${BASE_URL}/missions`, {
          withCredentials: true
        });

        const existingMission = missionsRes.data.find(mission =>
          mission.ambulancier_id == newMissionData.ambulancier_id &&
          mission.etat_mission == "planifiée"
        );

        if (existingMission) {
          const ambulancier = users.find(u => u.id == newMissionData.ambulancier_id);
          const timeDiff = new Date(existingMission.date_mission) - new Date(newMissionData.date_mission);
          const hours = Math.floor(timeDiff / (1000 * 60 * 60));
          const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

          if (hours >= -12 && hours < 12) {
            const confirmationData = {
              ambulancier: ambulancier,
              existingMission: existingMission,
              remainingTime: { hours, minutes },
              missionData: newMissionData,
              patientId: patientId
            };

            setMissionConfirmationData(confirmationData);
            onMissionConfirmationOpen();
            setIsAdding(false);
            return;
          }
        }
      }

      const response = await createMission(newMissionData, patientId);
      if (response && response.id) {
        setCreatedMissionId(response.id);
        setActiveStep(3); // Passer à l'étape de confirmation
      }
      setIsAdding(false);
    } catch (err) {
      setIsAdding(false);
      console.error("Add error:", err);
      console.error("Error details:", err.response?.data);
      toast({ title: "Erreur lors de l'ajout de la mission", status: "error", isClosable: true });
    }
  };

  return (
    <Box pt={{ base: "200px", md: "160px", xl: "160px" }}>
      {/* Cartes de statistiques - affichées conditionnellement */}
      {showStats && (
        <SimpleGrid
          mb="20px"
          columns={{ base: 1, md: 2, lg: 4 }}
          spacing="10px"
          position="relative"
          zIndex={1}>
          <MissionStatCard
            title="Total de les missions"
            value={missionStats.total}

            isPositive={true}
            iconColor="#7239EA"
            subtitle="vs semaine précédente"
          />
          <MissionStatCard
            title="Total de mission terminées"
            value={missionStats.terminees}

            isPositive={true}
            iconColor="#29BACD"
            subtitle="vs semaine précédente"
          />
          <MissionStatCard
            title="Total de mission en cours"
            value={missionStats.enCours}

            isPositive={false}
            iconColor="#459CE9"
            subtitle="vs semaine précédente"
          />
          <MissionStatCard
            title="Total de mission Annulée"
            value={missionStats.annulees}

            isPositive={true}
            iconColor="#F8285A"
            subtitle="vs semaine précédente"
          />
        </SimpleGrid>
      )}


      <SimpleGrid mb="20px" columns={{ sm: 1, md: 1 }} spacing={{ base: "20px", xl: "20px" }}>
        {loading ? (
          <LoadingSpinner message="Chargement des missions..." size="sm" />
        ) : (
          <ComplexTable
            columnsData={columnsDataComplex}
            tableData={filteredTableData}
            preservePagination={true}
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
            onAddClick={() => navigate('/admin/missions/create')}
            viewMode={viewMode}
            setViewMode={setViewMode}
          />
        )}
      </SimpleGrid>

      {/* Add Modal with Stepper */}
      <Modal isOpen={isAddOpen} onClose={handleAddClose} size="6xl" zIndex={1000}>
        <ModalOverlay />
        <ModalContent
          maxW="75%"
          maxH="95vh"
          borderRadius="12px"
          position="fixed"
          top="1%"
          bottom="1%"
          right="1%"
          left="23%"
          m="0"
          display="flex"
          flexDirection="column"
        >
          <ModalHeader
            borderBottom="1px solid"
            borderColor="gray.200"
            pb="20px"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexShrink={0}
          >
            <Text fontSize="18px" fontWeight="600" color="#455879" fontFamily="Oswald, sans-serif">
              Créer une mission
            </Text>
            <ModalCloseButton />
          </ModalHeader>
          <ModalBody p="20px" flex="1" overflowY="auto" minH="0">
            {!useGoogleMaps().loaded ? (
              <LoadingSpinner message="Chargement de l'API Google Maps..." size="md" />
            ) : createdMissionId ? (
              // Étape 4: Confirmation
              <Box>
                <Flex gap="40px" align="flex-start">
                  {/* Sidebar avec étapes */}
                  <Box
                    bg="blue.50"
                    borderRadius="6px"
                    p="20px"
                    minW="296px"
                    alignSelf="flex-start"
                  >
                    <Stepper index={3} orientation="vertical" gap="0" colorScheme="blue">
                      {steps.map((step, index) => (
                        <Step key={index}>
                          <StepIndicator
                            borderColor="#29BACD"
                            borderWidth="1px"
                            borderRadius="100px"
                            size="28px"
                          >
                            <StepStatus
                              complete={
                                <Box
                                  w="28px"
                                  h="28px"
                                  borderRadius="100px"
                                  bg="#29BACD"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <Icon as={MdCheckCircle} w="16px" h="16px" color="white" />
                                </Box>
                              }
                              incomplete={<StepNumber />}
                              active={<StepNumber />}
                            />
                          </StepIndicator>
                          <Box flexShrink="0" w="256px">
                            <StepTitle fontSize="14px" fontWeight="500" color="#29BACD">
                              {step.title}
                            </StepTitle>
                            <StepDescription fontSize="11px" color="#455879">
                              {step.description}
                            </StepDescription>
                          </Box>
                          {index < steps.length - 1 && <StepSeparator />}
                        </Step>
                      ))}
                    </Stepper>
                  </Box>

                  {/* Contenu de confirmation */}
                  <Box flex="1" display="flex" flexDirection="column" alignItems="center" justifyContent="center" py="120px">
                    {(() => {
                      const createdMission = tableData.find(m => m.id === createdMissionId);
                      return (
                        <>
                          <Box w="140px" h="140px" mb="40px">
                            <Image
                              src={missioncImg}
                              alt="Mission créée avec succès"
                              w="100%"
                              h="100%"
                              objectFit="contain"
                            />
                          </Box>
                          <VStack spacing="20px" align="stretch" w="100%">
                            <Text fontSize="20px" fontWeight="600" color="#455879" textAlign="center">
                              Mission créée avec succès.
                            </Text>
                            <Box borderTop="1px solid" borderColor="gray.200" pt="10px" pb="10px">
                              <HStack justify="center" spacing="10px">
                                <Text fontSize="13px" color="#455879">
                                  Réf mission
                                </Text>
                                <Text fontSize="13px" fontWeight="600" color="#455879">
                                  {createdMission?.bon_de_commande || `MTC-${createdMissionId}`}
                                </Text>
                                <Text fontSize="13px" color="#455879">
                                  Statut
                                </Text>
                                <Badge bg="#459CE9" color="white" borderRadius="20px" px="6px" py="2px" fontSize="11px">
                                  {createdMission?.statut || "En cours"}
                                </Badge>
                                <Text fontSize="13px" color="#459CE9" textDecoration="underline" cursor="pointer" onClick={() => {
                                  handleView(createdMission);
                                  handleAddClose();
                                }}>
                                  Voir la mission
                                </Text>
                              </HStack>
                            </Box>
                            <Text fontSize="13px" color="#656C7A" textAlign="center">
                              La mission a été enregistrée avec succès dans le système. Vous pouvez désormais consulter les détails complets de cette mission, revenir à la liste générale, ou créer une nouvelle mission si nécessaire.
                            </Text>
                            <HStack spacing="10px" justify="center">
                              <Button
                                leftIcon={<MdAdd />}
                                bg="#459CE9"
                                color="white"
                                _hover={{ bg: "#3a8bd4" }}
                                onClick={() => {
                                  setCreatedMissionId(null);
                                  setActiveStep(0);
                                  setNewMissionData({
                                    type_mission: "",
                                    cause: "",
                                    date_mission: dayjs().tz('Africa/Casablanca').format('YYYY-MM-DDTHH:mm'),
                                    adresse: "",
                                    adresse_destination: null,
                                    bon_de_commande: "",
                                    demande_materiel: "",
                                    patient_id: "",
                                    doctor_id: "",
                                    ambulance_id: "",
                                    statut: "créée",
                                    prix: "0",
                                    paiement: "espèces",
                                    paye: 0,
                                    ville: "",
                                    type_ambulance: "",
                                    ambulancier_id: "",
                                    nurse_id: "",
                                    nurse_type: "",
                                    etat_mission: "urgente",
                                    urgence: true,
                                    add_new_patient: false,
                                    client_id: "",
                                    type_client: "particulier",
                                    perimetre: '',
                                    loc: "",
                                    correspondance: "",
                                    correspondance_details: "",
                                    new_patient: {
                                      nom: "",
                                      prenom: "",
                                      téléphone: "",
                                      adresse: "",
                                      ville: "",
                                      type_client: "B2C",
                                      client_id: ""
                                    }
                                  });
                                }}
                              >
                                Créer une nouvelle mission
                              </Button>
                              <Button
                                variant="outline"
                                borderColor="gray.200"
                                color="#455879"
                                onClick={handleAddClose}
                              >
                                Retour à la liste
                              </Button>
                            </HStack>
                          </VStack>
                        </>
                      );
                    })()}
                  </Box>
                </Flex>
              </Box>
            ) : (
              <Flex gap="40px" align="flex-start">
                {/* Sidebar avec étapes */}
                <Box
                  bg="blue.50"
                  borderRadius="6px"
                  p="20px"
                  minW="296px"
                  alignSelf="flex-start"
                >
                  <Stepper index={activeStep} orientation="vertical" gap="0" colorScheme="blue">
                    {steps.map((step, index) => {
                      const isComplete = index < activeStep;
                      const isActive = index === activeStep;
                      return (
                        <Step key={index}>
                          <StepIndicator
                            borderColor={isComplete ? "#29BACD" : isActive ? "#459CE9" : "rgba(69,156,233,0.2)"}
                            borderWidth="1px"
                            borderRadius="100px"
                            size="28px"
                          >
                            <StepStatus
                              complete={
                                <Box
                                  w="28px"
                                  h="28px"
                                  borderRadius="100px"
                                  bg="#29BACD"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <Icon as={MdCheckCircle} w="16px" h="16px" color="white" />
                                </Box>
                              }
                              incomplete={
                                <Box
                                  w="28px"
                                  h="28px"
                                  borderRadius="100px"
                                  border="1px solid"
                                  borderColor="rgba(69,156,233,0.2)"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <StepNumber />
                                </Box>
                              }
                              active={
                                <Box
                                  w="28px"
                                  h="28px"
                                  borderRadius="100px"
                                  border="1px solid"
                                  borderColor="#459CE9"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <StepNumber color="#459CE9" />
                                </Box>
                              }
                            />
                          </StepIndicator>
                          <Box flexShrink="0" w="256px">
                            <StepTitle
                              fontSize={isActive ? "14px" : "13px"}
                              fontWeight={isActive || isComplete ? "500" : "400"}
                              color={isComplete ? "#29BACD" : isActive ? "#459CE9" : "#455879"}
                            >
                              {step.title}
                            </StepTitle>
                            <StepDescription fontSize="11px" color="#455879">
                              {step.description}
                            </StepDescription>
                          </Box>
                          {index < steps.length - 1 && <StepSeparator />}
                        </Step>
                      );
                    })}
                  </Stepper>
                </Box>

                {/* Contenu des étapes */}
                <Box flex="1" p="20px">
                  {activeStep === 0 && (
                    // Étape 1: Type de Mission
                    <VStack spacing="20px" align="stretch" w="100%">
                      <VStack spacing="10px" align="stretch" w="100%">
                        <Text
                          fontSize="16px"
                          fontWeight="600"
                          color="#455879"
                          fontFamily="Poppins, sans-serif"
                          w="100%"
                          lineHeight="14px"
                        >
                          Sélectionnez le type de mission à créer :
                        </Text>
                        <Text fontSize="12px" fontWeight="400" color="#656C7A" fontFamily="Poppins, sans-serif" textAlign="left" w="100%">
                          Choisissez le type de mission pour démarrer la configuration
                        </Text>
                      </VStack>
                      <SimpleGrid columns={2} spacing="20px">
                        {[
                          { value: "Téléconsultation", label: "Téléconsultation", image: teleconsultationImg, description: "Consultation à distance entre patient et médecin" },
                          { value: "Consultation à domicile", label: "Consultation à domicile", image: consultationDomicileImg, description: "Intervention à domicile par un professionnel" },
                          { value: "Acte infirmier", label: "Acte infirmier", image: acteInfirmierImg, description: "Réalisation d'un soin par une infirmière" },
                          { value: "ambulance", label: "Ambulance", image: ambulanceImg, description: "Transport d'urgence d'un patient en ambulance" },
                        ].map((type) => (
                          <Box
                            key={type.value}
                            p="20px"
                            border="1px solid"
                            borderColor={newMissionData.type_mission === type.value ? "#459CE9" : "gray.200"}
                            borderRadius="6px"
                            cursor="pointer"
                            onClick={() => {
                              setNewMissionData(prev => ({
                                ...prev,
                                type_mission: type.value,
                                type_ambulance: type.value === "Téléconsultation" || type.value === "Consultation à domicile" || type.value === "Acte infirmier" ? "" : prev.type_ambulance,
                                ambulancier_id: type.value === "Téléconsultation" || type.value === "Consultation à domicile" || type.value === "Acte infirmier" ? "" : prev.ambulancier_id,
                                doctor_id: type.value === "Acte infirmier" ? "" : prev.doctor_id,
                                nurse_id: type.value === "Acte infirmier" ? "" : prev.nurse_id,
                                loc: ""
                              }));
                              setInvalidFields(prev => ({ ...prev, type_mission: undefined }));
                              // Valider le choix et passer automatiquement à l'étape 2
                              if (activeStep === 0) {
                                setActiveStep(1);
                              }
                            }}
                            bg="white"
                            _hover={{ borderColor: "#459CE9" }}
                            h="126px"
                            display="flex"
                            flexDirection="column"
                            gap="10px"
                          >
                            <Box
                              w="38px"
                              h="38px"
                              borderRadius="6px"
                              bg="#E3F2FD"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              p="6px"
                            >
                              <Image
                                src={type.image}
                                alt={type.value}
                                w="100%"
                                h="100%"
                                objectFit="contain"
                              />
                            </Box>
                            <Text
                              fontSize="16px"
                              fontWeight="600"
                              color={newMissionData.type_mission === type.value ? "#459CE9" : "#455879"}
                              fontFamily="Poppins, sans-serif"
                            >
                              {type.label}
                            </Text>
                            <Text
                              fontSize="12px"
                              fontWeight="400"
                              color="#656C7A"
                              fontFamily="Poppins, sans-serif"
                            >
                              {type.description}
                            </Text>
                          </Box>
                        ))}
                      </SimpleGrid>
                      {invalidFields.type_mission && (
                        <Text color="red.500" fontSize="sm">{invalidFields.type_mission}</Text>
                      )}
                    </VStack>
                  )}

                  {activeStep === 1 && (
                    // Étape 2: Informations générales
                    <VStack spacing="40px" align="stretch">
                      <HStack spacing="10px" justify="space-between">
                        <VStack spacing="10px" align="flex-start">
                          <Text fontSize="16px" fontWeight="600" color="#455879">
                            Informations générales
                          </Text>
                          <Text fontSize="12px" color="#656C7A">
                            Renseignez les infos de base liées à la mission.
                          </Text>
                        </VStack>
                        {newMissionData.type_mission && (
                          <Box
                            bg="white"
                            border="1px solid"
                            borderColor="gray.200"
                            borderRadius="6px"
                            p="10px"
                          >
                            <HStack spacing="5px">
                              <Box w="20px" h="20px">
                                <Image
                                  src={
                                    newMissionData.type_mission === "Téléconsultation" ? teleconsultationImg :
                                      newMissionData.type_mission === "Consultation à domicile" ? consultationDomicileImg :
                                        newMissionData.type_mission === "Acte infirmier" ? acteInfirmierImg : ambulanceImg
                                  }
                                  alt={newMissionData.type_mission}
                                  w="100%"
                                  h="100%"
                                  objectFit="contain"
                                />
                              </Box>
                              <Text fontSize="12px" fontWeight="700" color="#455879">
                                {newMissionData.type_mission}
                              </Text>
                            </HStack>
                          </Box>
                        )}
                      </HStack>

                      <VStack spacing="20px" align="stretch">
                        {/* 1. État de mission */}
                        <FormControl isRequired>
                          <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                            État de mission <Text as="span" color="#F8285A">*</Text>
                          </FormLabel>
                          <RadioGroup
                            value={newMissionData.etat_mission}
                            onChange={(value) => {
                              setNewMissionData(prev => ({
                                ...prev,
                                etat_mission: value,
                                urgence: value === "urgente",
                                date_mission: value === "urgente" || value === "Aller-Retour"
                                  ? dayjs().tz('Africa/Casablanca').format('YYYY-MM-DDTHH:mm')
                                  : prev.date_mission
                              }));
                            }}
                          >
                            <HStack spacing="20px" py="12px">
                              <Radio value="urgente">Urgente</Radio>
                              <Radio value="planifiée">Planifiée</Radio>
                              <Radio value="Aller-Retour">Aller-Retour</Radio>
                            </HStack>
                          </RadioGroup>
                          {invalidFields.etat_mission && (
                            <Text color="red.500" fontSize="sm">{invalidFields.etat_mission}</Text>
                          )}
                        </FormControl>

                        {/* Date de mission */}
                        {newMissionData.etat_mission === "planifiée" && (
                          <FormControl isRequired>
                            <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                              Date de Mission <Text as="span" color="#F8285A">*</Text>
                            </FormLabel>
                            <Input
                              type="datetime-local"
                              value={newMissionData.date_mission}
                              onChange={(e) => setNewMissionData(prev => ({ ...prev, date_mission: e.target.value }))}
                              h="42px"
                              borderRadius="6px"
                            />
                            {invalidFields.date_mission && (
                              <Text color="red.500" fontSize="sm">{invalidFields.date_mission}</Text>
                            )}
                          </FormControl>
                        )}

                        {/* 2. Ville */}
                        {newMissionData.type_mission !== "Téléconsultation" && (
                          <FormControl isRequired>
                            <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                              Ville <Text as="span" color="#F8285A">*</Text>
                            </FormLabel>
                            <Select
                              value={newMissionData.ville}
                              onChange={(e) => {
                                setNewMissionData(prev => ({
                                  ...prev,
                                  ville: e.target.value,
                                  ambulance_id: ""
                                }));
                              }}
                              h="42px"
                              borderRadius="6px"
                            >
                              <option value="">Sélectionner une ville</option>
                              {newMissionData.type_mission === "Consultation à domicile"
                                ? [...new Set(doctors.map(doc => doc.ville).filter(Boolean))].map((ville) => (
                                  <option key={ville} value={ville}>
                                    {ville}
                                  </option>
                                ))
                                : newMissionData.type_mission === "Acte infirmier"
                                  ? [...new Set(nurses.map(nurse => nurse.ville).filter(Boolean))].map((ville) => (
                                    <option key={ville} value={ville}>
                                      {ville}
                                    </option>
                                  ))
                                  : uniqueVilles.map((ville) => (
                                    <option key={ville} value={ville}>
                                      {ville}
                                    </option>
                                  ))}
                            </Select>
                            {invalidFields.ville && (
                              <Text color="red.500" fontSize="sm">{invalidFields.ville}</Text>
                            )}
                          </FormControl>
                        )}

                        {/* 3. Adresse de Mission */}
                        {newMissionData.type_mission !== "Téléconsultation" && (
                          <FormControl isRequired>
                            <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                              Adresse de Mission <Text as="span" color="#F8285A">*</Text>
                            </FormLabel>
                            <MissionAddressAutocomplete
                              value={newMissionData.adresse}
                              onChange={(value) => setNewMissionData(prev => ({ ...prev, adresse: value }))}
                              placeholder="Entrez l'adresse de la mission"
                              onLocationSelect={handleLocationSelect}
                            />
                            {invalidFields.adresse && (
                              <Text color="red.500" fontSize="sm">{invalidFields.adresse}</Text>
                            )}
                          </FormControl>
                        )}

                        {/* 4. Adresse de Destination */}
                        {newMissionData.type_mission === "ambulance" && (
                          <FormControl>
                            <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                              Adresse de Destination
                            </FormLabel>
                            <MissionAddressAutocomplete
                              value={newMissionData.adresse_destination || ''}
                              onChange={(value) => setNewMissionData(prev => ({ ...prev, adresse_destination: value || null }))}
                              placeholder="Entrez l'adresse de destination"
                              onLocationSelect={(locationData) => {
                                setNewMissionData(prev => ({
                                  ...prev,
                                  adresse_destination: locationData.formattedAddress || null,
                                  loc: prev.type_mission === 'ambulance' ? `${locationData.location.lat},${locationData.location.lng}` : prev.loc
                                }));
                              }}
                            />
                          </FormControl>
                        )}

                        {/* 5. Cause */}
                        <FormControl isRequired>
                          <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                            Cause <Text as="span" color="#F8285A">*</Text>
                          </FormLabel>
                          <Select
                            placeholder="Sélectionner la cause…"
                            value={newMissionData.cause}
                            onChange={(e) => setNewMissionData(prev => ({ ...prev, cause: e.target.value }))}
                            h="42px"
                            borderRadius="6px"
                          >
                            <option value="Urgences vitales">1. Urgences vitales</option>
                            <option value="Urgences cardiovasculaires">2. Urgences cardiovasculaires</option>
                            <option value="Urgences neurologiques">3. Urgences neurologiques</option>
                            <option value="Urgences respiratoires">4. Urgences respiratoires</option>
                            <option value="Urgences digestives & abdominales">5. Urgences digestives & abdominales</option>
                            <option value="Urgences infectieuses">6. Urgences infectieuses</option>
                            <option value="Urgences traumatiques">7. Urgences traumatiques</option>
                            <option value="Urgences psychiatriques">8. Urgences psychiatriques</option>
                            <option value="Urgences pédiatriques">9. Urgences pédiatriques</option>
                            <option value="Autres urgences fréquentes">10. Autres urgences fréquentes</option>
                          </Select>
                          {invalidFields.cause && (
                            <Text color="red.500" fontSize="sm">{invalidFields.cause}</Text>
                          )}
                        </FormControl>

                        {/* 6. Type d'ambulance */}
                        {newMissionData.type_mission === "ambulance" && (
                          <FormControl isRequired>
                            <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                              Type d'Ambulance <Text as="span" color="#F8285A">*</Text>
                            </FormLabel>
                            <HStack spacing="20px" py="12px">
                              <Checkbox
                                isChecked={newMissionData.type_ambulance === "TAS"}
                                onChange={() => {
                                  setNewMissionData(prev => ({ ...prev, type_ambulance: "TAS" }));
                                  fetchAmbulanciers("TAS");
                                }}
                              >
                                TAS
                              </Checkbox>
                              <Checkbox
                                isChecked={newMissionData.type_ambulance === "TAR"}
                                onChange={() => {
                                  setNewMissionData(prev => ({ ...prev, type_ambulance: "TAR" }));
                                  fetchAmbulanciers("TAR");
                                }}
                              >
                                TAR
                              </Checkbox>
                            </HStack>
                            {invalidFields.type_ambulance && (
                              <Text color="red.500" fontSize="sm">{invalidFields.type_ambulance}</Text>
                            )}
                          </FormControl>
                        )}

                        {/* Ambulancier pour missions ambulance */}
                        {newMissionData.type_mission === "ambulance" && (
                          <FormControl isRequired>
                            <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                              Ambulancier <Text as="span" color="#F8285A">*</Text>
                            </FormLabel>
                            <Select
                              value={newMissionData.ambulancier_id}
                              onChange={(e) => {
                                const value = e.target.value;
                                const vehicle = vehicles.find(v => String(v.user_id) === String(value));
                                setNewMissionData(prev => ({ ...prev, ambulancier_id: value, ambulance_id: vehicle ? vehicle.id : '' }));
                              }}
                              isDisabled={!newMissionData.type_ambulance || !newMissionData.ville}
                              h="42px"
                              borderRadius="6px"
                            >
                              <option value="">Sélectionner un ambulancier</option>
                              {availableAmbulanciers.map((ambulancier) => (
                                <option key={ambulancier.id} value={ambulancier.id}>
                                  {ambulancier.nom} {ambulancier.prenom}
                                  {ambulancier.distance !== null ? ` (${ambulancier.distance} km)` : ''}
                                  {ambulancier.vehicle_status === "en mission" ? " - En mission" : ""}
                                  {` - ${ambulancier.vehicle_type}`}
                                </option>
                              ))}
                            </Select>
                            {invalidFields.ambulancier_id && (
                              <Text color="red.500" fontSize="sm">{invalidFields.ambulancier_id}</Text>
                            )}
                          </FormControl>
                        )}

                        {/* 7. Médecin */}
                        {newMissionData.type_mission !== "Acte infirmier" && (
                          <FormControl isRequired={(newMissionData.type_mission === "ambulance" && newMissionData.type_ambulance === "TAR") || newMissionData.type_mission === "Consultation à domicile" || newMissionData.type_mission === "Téléconsultation"}>
                            <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                              Docteur assigné <Text as="span" color="#F8285A">*</Text>
                            </FormLabel>
                            <Select
                              value={newMissionData.doctor_id}
                              onChange={(e) => setNewMissionData(prev => ({ ...prev, doctor_id: e.target.value }))}
                              placeholder="Rechercher un Intervenant assigné..."
                              h="42px"
                              borderRadius="6px"
                            >
                              <option value="">Sélectionner un docteur</option>
                              {filteredDoctorsForAdd.map(doctor => {
                                let distance = null;
                                if (doctor.loc && missionLocations['new']) {
                                  const [dLat, dLng] = doctor.loc.split(',').map(Number);
                                  const mLat = missionLocations['new']?.lat;
                                  const mLng = missionLocations['new']?.lng;
                                  if (!isNaN(dLat) && !isNaN(dLng) && typeof mLat === 'number' && typeof mLng === 'number') {
                                    distance = calculateDistance(mLat, mLng, dLat, dLng);
                                  }
                                }
                                return (
                                  <option key={doctor.id} value={doctor.id}>
                                    {doctor.nom} {doctor.prenom}
                                    {doctor.specialty ? ` (${doctor.specialty})` : ''}
                                    {distance !== null ? ` (${distance.toFixed(1)} km)` : ''}
                                  </option>
                                );
                              })}
                            </Select>
                            {invalidFields.doctor_id && (
                              <Text color="red.500" fontSize="sm">{invalidFields.doctor_id}</Text>
                            )}
                          </FormControl>
                        )}



                        {/* 9. Périmètre */}
                        {(newMissionData.type_mission === "ambulance" || newMissionData.type_mission === "Acte infirmier" || newMissionData.type_mission === "Consultation à domicile") && (
                          <FormControl isRequired>
                            <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                              Périmètre
                            </FormLabel>
                            <RadioGroup
                              value={newMissionData.perimetre}
                              onChange={value => {
                                setNewMissionData(prev => ({
                                  ...prev,
                                  perimetre: value
                                }));
                              }}
                            >
                              <HStack spacing="20px" py="12px">
                                <Radio value="urbain">Urbain</Radio>
                                <Radio value="rayon 50">Rayon 50</Radio>
                                {newMissionData.type_mission === "ambulance" && (
                                  <>
                                    <Radio value="interurbain">Interurbain</Radio>
                                    <Radio value="aéroport">Aéroport</Radio>
                                    <Radio value="aéroport avec accès piste">Aéroport avec accès piste</Radio>
                                  </>
                                )}
                              </HStack>
                            </RadioGroup>
                          </FormControl>
                        )}

                        {/* Infirmier pour Acte infirmier */}
                        {newMissionData.type_mission === "Acte infirmier" && (
                          <>
                            <FormControl isRequired>
                              <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                                Infirmier <Text as="span" color="#F8285A">*</Text>
                              </FormLabel>
                              <Select
                                value={newMissionData.nurse_id}
                                onChange={(e) => setNewMissionData(prev => ({
                                  ...prev,
                                  nurse_id: e.target.value,
                                  nurse_type: ""
                                }))}
                                h="42px"
                                borderRadius="6px"
                              >
                                <option value="">Sélectionner un infirmier</option>
                                {filteredNursesForAdd.map(nurse => {
                                  let distance = null;
                                  if (nurse.loc && missionLocations['new']) {
                                    const [nLat, nLng] = nurse.loc.split(',').map(Number);
                                    const mLat = missionLocations['new']?.lat;
                                    const mLng = missionLocations['new']?.lng;
                                    if (!isNaN(nLat) && !isNaN(nLng) && typeof mLat === 'number' && typeof mLng === 'number') {
                                      distance = calculateDistance(mLat, mLng, nLat, nLng);
                                    }
                                  }
                                  return (
                                    <option key={nurse.id} value={nurse.id}>
                                      {nurse.nom} {nurse.prenom}
                                      {nurse.specialty ? ` (${nurse.specialty})` : ''}
                                      {distance !== null ? ` (${distance.toFixed(1)} km)` : ''}
                                    </option>
                                  );
                                })}
                              </Select>
                              {invalidFields.nurse_id && (
                                <Text color="red.500" fontSize="sm">{invalidFields.nurse_id}</Text>
                              )}
                            </FormControl>

                            {newMissionData.nurse_id && (
                              <FormControl isRequired>
                                <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                                  Spécialité de l'Infirmier <Text as="span" color="#F8285A">*</Text>
                                </FormLabel>
                                <Select
                                  value={newMissionData.nurse_type}
                                  onChange={(e) => setNewMissionData(prev => ({ ...prev, nurse_type: e.target.value }))}
                                  h="42px"
                                  borderRadius="6px"
                                >
                                  <option value="">Sélectionner une spécialité</option>
                                  <option value="polyvalent">Polyvalent</option>
                                  <option value="anesthesiste">Anesthésiste</option>
                                </Select>
                                {invalidFields.nurse_type && (
                                  <Text color="red.500" fontSize="sm">{invalidFields.nurse_type}</Text>
                                )}
                              </FormControl>
                            )}
                          </>
                        )}
                      </VStack>
                    </VStack>
                  )}

                  {activeStep === 2 && (
                    <VStack spacing="40px" align="stretch">
                      <HStack spacing="10px" justify="space-between">
                        <VStack spacing="10px" align="flex-start">
                          <Text fontSize="16px" fontWeight="600" color="#455879">
                            Patient
                          </Text>
                          <Text fontSize="12px" color="#656C7A">
                            Ajoutez les infos du patient associés.
                          </Text>
                        </VStack>
                        {newMissionData.type_mission && (
                          <Box
                            bg="white"
                            border="1px solid"
                            borderColor="gray.200"
                            borderRadius="6px"
                            p="10px"
                          >
                            <HStack spacing="5px">
                              <Box w="20px" h="20px">
                                <Image
                                  src={
                                    newMissionData.type_mission === "Téléconsultation" ? teleconsultationImg :
                                      newMissionData.type_mission === "Consultation à domicile" ? consultationDomicileImg :
                                        newMissionData.type_mission === "Acte infirmier" ? acteInfirmierImg : ambulanceImg
                                  }
                                  alt={newMissionData.type_mission}
                                  w="100%"
                                  h="100%"
                                  objectFit="contain"
                                />
                              </Box>
                              <Text fontSize="12px" fontWeight="700" color="#455879">
                                {newMissionData.type_mission}
                              </Text>
                            </HStack>
                          </Box>
                        )}
                      </HStack>

                      <VStack spacing="20px" align="stretch">


                        {/* Patient */}
                        <FormControl isRequired>
                          <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                            Patient <Text as="span" color="#F8285A">*</Text>
                          </FormLabel>
                          <VStack spacing="10px" align="stretch">
                            <Input
                              placeholder="Nom"
                              value={newMissionData.new_patient.nom}
                              onChange={e => handlePatientFieldChange('nom', e.target.value)}
                              h="42px"
                              borderRadius="6px"
                            />
                            {invalidFields.new_patient_nom && (
                              <Text color="red.500" fontSize="sm">{invalidFields.new_patient_nom}</Text>
                            )}
                            <Input
                              placeholder="Prénom"
                              value={newMissionData.new_patient.prenom}
                              onChange={e => handlePatientFieldChange('prenom', e.target.value)}
                              h="42px"
                              borderRadius="6px"
                            />
                            {invalidFields.new_patient_prenom && (
                              <Text color="red.500" fontSize="sm">{invalidFields.new_patient_prenom}</Text>
                            )}
                            <InputGroup h="42px">
                              <InputLeftElement w="80px" borderRight="1px solid" borderColor="gray.200">
                                <HStack spacing="5px" px="10px">
                                  <Text fontSize="13px" color="#656C7A">+212</Text>
                                  <Icon as={MdArrowForward} w="16px" h="16px" transform="rotate(90deg)" />
                                </HStack>
                              </InputLeftElement>
                              <Input
                                pl="90px"
                                placeholder="Saisissez numéro de téléphone..."
                                value={newMissionData.new_patient.téléphone}
                                onChange={e => {
                                  const digitsOnly = e.target.value.replace(/[^0-9]/g, '');
                                  handlePatientFieldChange('téléphone', digitsOnly);
                                }}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                h="42px"
                                borderRadius="6px"
                              />
                            </InputGroup>
                            {invalidFields.new_patient_téléphone && (
                              <Text color="red.500" fontSize="sm">{invalidFields.new_patient_téléphone}</Text>
                            )}
                            {newMissionData.patient_id && (
                              <Text color="green.600" fontSize="sm">
                                Patient existant détecté, il sera utilisé pour la mission.
                              </Text>
                            )}
                          </VStack>
                        </FormControl>

                        {/* Prix et paiement pour non-assurance */}
                        {newMissionData.type_client !== "assurance" && (
                          <>
                            <FormControl isRequired>
                              <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                                Prix (MAD) <Text as="span" color="#F8285A">*</Text>
                              </FormLabel>
                              <Input
                                type="number"
                                step="0.01"
                                value={newMissionData.prix}
                                onChange={(e) => setNewMissionData(prev => ({ ...prev, prix: e.target.value }))}
                                placeholder="Entrez le prix"
                                h="42px"
                                borderRadius="6px"
                              />
                              {invalidFields.prix && (
                                <Text color="red.500" fontSize="sm">{invalidFields.prix}</Text>
                              )}
                            </FormControl>

                            <FormControl isRequired>
                              <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                                Mode de Paiement <Text as="span" color="#F8285A">*</Text>
                              </FormLabel>
                              <Select
                                value={newMissionData.paiement}
                                onChange={(e) => setNewMissionData(prev => ({ ...prev, paiement: e.target.value }))}
                                h="42px"
                                borderRadius="6px"
                              >
                                <option value="espèces">Espèces</option>
                                <option value="cheque">Chèque</option>
                                <option value="virement">Virement</option>
                              </Select>
                              {invalidFields.paiement && (
                                <Text color="red.500" fontSize="sm">{invalidFields.paiement}</Text>
                              )}
                            </FormControl>

                            <FormControl isRequired>
                              <FormLabel fontSize="13px" fontWeight="500" color="#455879">
                                Statut de Paiement <Text as="span" color="#F8285A">*</Text>
                              </FormLabel>
                              <Select
                                value={newMissionData.paye}
                                onChange={(e) => setNewMissionData(prev => ({ ...prev, paye: parseInt(e.target.value) }))}
                                h="42px"
                                borderRadius="6px"
                              >
                                <option value={0}>Non Payé</option>
                                <option value={1}>Payé</option>
                              </Select>
                              {invalidFields.paye && (
                                <Text color="red.500" fontSize="sm">{invalidFields.paye}</Text>
                              )}
                            </FormControl>
                          </>
                        )}
                      </VStack>
                    </VStack>
                  )}
                </Box>
              </Flex>
            )}
          </ModalBody>
          {!createdMissionId && (
            <ModalFooter
              borderTop="1px solid"
              borderColor="gray.200"
              pt="20px"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              flexShrink={0}
            >
              <Button
                variant="ghost"
                leftIcon={<Icon as={MdArrowBack} />}
                onClick={handlePrevStep}
                isDisabled={activeStep === 0}
                opacity={activeStep === 0 ? 0.3 : 1}
                color="#455879"
                fontSize="13px"
                fontWeight="500"
              >
                Étape précédente
              </Button>
              <HStack spacing="7px">

                <Button
                  bg="#459CE9"
                  color="white"
                  rightIcon={<Icon as={MdArrowForward} />}
                  onClick={handleNextStep}
                  isLoading={activeStep === 2 && isAdding}
                  isDisabled={activeStep === 2 && isAdding}
                  fontSize="13px"
                  fontWeight="500"
                >
                  {activeStep === 2 ? "Créer la mission" : "Étape suivante"}
                </Button>
              </HStack>
            </ModalFooter>
          )}
        </ModalContent>
      </Modal>

      {/* View Modal */}
      <Modal isOpen={isViewOpen} onClose={onViewClose} size="6xl" zIndex={10000}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <HStack spacing={4} align="center">
              <Text fontSize="2xl" fontWeight="bold">Détails de la Mission</Text>
              <Badge
                colorScheme={
                  viewData?.statut === "créée" ? "blue" :
                    viewData?.statut === "en cours" ? "yellow" :
                      viewData?.statut === "terminée" ? "green" :
                        viewData?.statut === "annulée" ? "red" : "gray"
                }
                fontSize="md"
                px={3}
                py={1}
                borderRadius="full"
              >
                {viewData?.statut}
              </Badge>



              <Button
                colorScheme="blue"
                mr={3}
                onClick={() => calculateTravelTime(viewData.id)}
                isDisabled={!hasTravelOrigin(viewData)}
                title="Calculer le temps de trajet de l'intervenant vers le patient"
              >
                {travelTime && travelTime.missionId === viewData.id ? (
                  <>⏱️ {travelTime.duration}</>
                ) : (
                  <>⏱️ Temps restant</>
                )}
              </Button>
            </HStack>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {viewData && (
              <Box>
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
                  {/* Mission Info Section */}
                  <Box p={4} bg="gray.50" borderRadius="lg">
                    <Text fontSize="lg" fontWeight="bold" mb={4} color="blue.600">Informations de la Mission</Text>
                    <SimpleGrid columns={2} spacing={4}>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Type de Mission</Text>
                        <Text>{viewData.type_mission || "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Créée par</Text>
                        <Text>{(() => {
                          const creatorId = viewData?.créé_par || viewData?.cree_par || viewData?.created_by;
                          if (!creatorId) return "Non spécifié";
                          const u = users.find(us => us.id == creatorId);
                          return u ? `${u.nom} ${u.prenom}` : String(creatorId);
                        })()}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Date</Text>
                        <Text>{viewData.date_mission ? new Date(viewData.date_mission).toLocaleString("fr-FR", {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">État de Mission</Text>
                        <Text>{viewData.etat_mission || "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Urgence</Text>
                        <Badge colorScheme={viewData.urgence ? "red" : "gray"}>
                          {viewData.urgence ? "Oui" : "Non"}
                        </Badge>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Cause</Text>
                        <Text>{viewData.cause || "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Bon de Commande</Text>
                        <Text>{viewData.bon_de_commande || "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Demande Matériel</Text>
                        <Text>{viewData.demande_materiel || "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Adresse</Text>
                        <Text>{viewData.adresse || "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Adresse de Destination</Text>
                        <Text>{viewData.adresse_destination || "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Ambulance (Véhicule)</Text>
                        <Text>{(() => {
                          if (!viewData.ambulance_id) return "Non spécifié";
                          const v = vehicles.find(vh => vh.id == viewData.ambulance_id);
                          return v ? `#${v.id} — ${v.type_vehicule}${v.ville ? ` — ${v.ville}` : ''}` : `#${viewData.ambulance_id}`;
                        })()}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Ville</Text>
                        <Text>{viewData.ville || "Non spécifié"}</Text>
                      </Box>
                    </SimpleGrid>
                  </Box>

                  {/* Suivi de Mission Section */}
                  <Box p={4} bg="gray.50" borderRadius="lg">

                    <Text fontSize="lg" fontWeight="bold" mb={4} color="blue.600">Suivi de Mission</Text>
                    <SimpleGrid columns={2} spacing={4}>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Heure d'Affectation</Text>
                        <Text>{viewData.heure_affectation ? new Date(viewData.heure_affectation).toLocaleTimeString("fr-FR", {
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Heure de Départ</Text>
                        <Text>{viewData.heure_depart ? new Date(viewData.heure_depart).toLocaleTimeString("fr-FR", {
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Temps de Départ</Text>
                        <Text>{viewData.temps_depart ? new Date(`1970-01-01T${viewData.temps_depart}`).toLocaleTimeString("fr-FR", {
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Heure d'Arrivée</Text>
                        <Text>{viewData.heure_arrivee ? new Date(viewData.heure_arrivee).toLocaleTimeString("fr-FR", {
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Temps d'Arrivée</Text>
                        <Text>{viewData.temps_arrivee ? new Date(`1970-01-01T${viewData.temps_arrivee}`).toLocaleTimeString("fr-FR", {
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Heure de Départ avec patient</Text>
                        <Text>{viewData.heure_redepart ? new Date(viewData.heure_redepart).toLocaleTimeString("fr-FR", {
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">temps de Départ avec patient</Text>
                        <Text>{viewData.temps_redepart ? new Date(`1970-01-01T${viewData.temps_redepart}`).toLocaleTimeString("fr-FR", {
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Heure de Fin</Text>
                        <Text>{viewData.heure_fin ? new Date(viewData.heure_fin).toLocaleTimeString("fr-FR", {
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Temps de Fin</Text>
                        <Text>{viewData.temps_fin ? new Date(`1970-01-01T${viewData.temps_fin}`).toLocaleTimeString("fr-FR", {
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Temps total de l'intervention</Text>
                        <Text>{viewData.temps_total ? new Date(`1970-01-01T${viewData.temps_total}`).toLocaleTimeString("fr-FR", {
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : "Non spécifié"}</Text>
                      </Box>
                    </SimpleGrid>
                  </Box>

                  {/* Patient Info Section */}
                  <Box p={4} bg="gray.50" borderRadius="lg">
                    <Text fontSize="lg" fontWeight="bold" mb={4} color="blue.600">Informations du Patient</Text>
                    {(() => {
                      const patient = patients.find(p => p.id === viewData.patient_id);
                      if (patient) {
                        return (
                          <SimpleGrid columns={2} spacing={4}>
                            <Box>
                              <Text fontWeight="semibold" color="gray.600">Nom</Text>
                              <Text>{patient.nom} {patient.prenom}</Text>
                            </Box>
                            <Box>
                              <Text fontWeight="semibold" color="gray.600">Téléphone</Text>
                              <Text>{patient.téléphone || "Non spécifié"}</Text>
                            </Box>
                            <Box>
                              <Text fontWeight="semibold" color="gray.600">Email</Text>
                              <Text>{patient.email || "Non spécifié"}</Text>
                            </Box>
                            <Box>
                              <Text fontWeight="semibold" color="gray.600">Adresse</Text>
                              <Text>{patient.adresse || "Non spécifié"}</Text>
                            </Box>
                            <Box>
                              <Text fontWeight="semibold" color="gray.600">Adresse de Destination</Text>
                              <Text>{patient.adresse_destination || "Non spécifié"}</Text>
                            </Box>
                            <Box>
                              <Text fontWeight="semibold" color="gray.600">Ville</Text>
                              <Text>{patient.ville || "Non spécifié"}</Text>
                            </Box>
                            <Box>
                              <Text fontWeight="semibold" color="gray.600">Date de Naissance</Text>
                              <Text>{patient.date_naissance ? new Date(patient.date_naissance).toLocaleDateString("fr-FR") : "Non spécifié"}</Text>
                            </Box>
                          </SimpleGrid>
                        );
                      }
                      return <Text color="gray.500">Aucun patient associé</Text>;
                    })()}
                  </Box>

                  {/* Medical Info Section */}
                  <Box p={4} bg="gray.50" borderRadius="lg">
                    <Text fontSize="lg" fontWeight="bold" mb={4} color="blue.600">Informations Médicales</Text>
                    <SimpleGrid columns={2} spacing={4}>
                      {viewData.type_mission == "acte infirmier" ? (
                        <>
                          <Box>
                            <Text fontWeight="semibold" color="gray.600">Infirmier</Text>
                            {(() => {
                              const nurseId = getPreferredId(viewData?.nurse_id, viewData?.nurse, viewData?.nurseId);
                              const nurse = findUserById(nurseId) || nurses.find(n => n.id == nurseId);
                              return <Text>{nurse ? `${nurse.nom} ${nurse.prenom}` : "Non assigné"}</Text>;
                            })()}
                          </Box>
                          <Box>
                            <Text fontWeight="semibold" color="gray.600">Téléphone Infirmier</Text>
                            {(() => {
                              const nurseId = getPreferredId(viewData?.nurse_id, viewData?.nurse, viewData?.nurseId);
                              const nurse = findUserById(nurseId) || nurses.find(n => n.id == nurseId);
                              return <Text>{nurse?.téléphone || "Non spécifié"}</Text>;
                            })()}
                          </Box>
                        </>
                      ) : (
                        <>
                          <Box>
                            <Text fontWeight="semibold" color="gray.600">Médecin</Text>
                            {(() => {
                              const doctorId = getPreferredId(viewData?.doctor_id, viewData?.doctor, viewData?.doctorId);
                              const doctor = findUserById(doctorId) || doctors.find(d => d.id == doctorId);

                              return <Text>{doctor ? `${doctor.nom} ${doctor.prenom}` : "Non assigné"}</Text>;
                            })()}
                          </Box>
                          <Box>
                            <Text fontWeight="semibold" color="gray.600">Téléphone Médecin</Text>
                            {(() => {
                              const doctorId = getPreferredId(viewData?.doctor_id, viewData?.doctor, viewData?.doctorId);
                              const doctor = findUserById(doctorId) || doctors.find(d => d.id == doctorId);
                              return <Text>{doctor?.téléphone || "Non spécifié"}</Text>;
                            })()}
                          </Box>
                        </>
                      )}
                    </SimpleGrid>
                  </Box>

                  {/* Ambulance Info Section */}
                  {viewData.type_mission === "ambulance" && (
                    <Box p={4} bg="gray.50" borderRadius="lg">
                      <Text fontSize="lg" fontWeight="bold" mb={4} color="blue.600">Informations de l'Ambulance</Text>
                      <SimpleGrid columns={2} spacing={4}>
                        <Box>
                          <Text fontWeight="semibold" color="gray.600">Type d'Ambulance</Text>
                          {(() => {
                            // Utiliser directement viewData.type_ambulance, sinon fallback sur vehicle?.type_vehicule
                            const vehicle = vehicles.find(v => v.user_id === viewData.ambulancier_id);
                            return <Text>{viewData.type_ambulance || vehicle?.type_vehicule || "Non spécifié"}</Text>;
                          })()}
                        </Box>
                        <Box>
                          <Text fontWeight="semibold" color="gray.600">Ambulancier</Text>
                          {(() => {
                            const ambulancier = users.find(u => u.id === viewData.ambulancier_id);
                            return <Text>{ambulancier ? `${ambulancier.nom} ${ambulancier.prenom}` : "Non assigné"}</Text>;
                          })()}
                        </Box>
                        <Box>
                          <Text fontWeight="semibold" color="gray.600">Téléphone Ambulancier</Text>
                          {(() => {
                            const ambulancier = users.find(u => u.id === viewData.ambulancier_id);
                            return <Text>{ambulancier?.téléphone || "Non spécifié"}</Text>;
                          })()}
                        </Box>
                        <Box>
                          <Text fontWeight="semibold" color="gray.600">Ville</Text>
                          <Text>{viewData.ville || "Non spécifié"}</Text>
                        </Box>
                      </SimpleGrid>
                    </Box>
                  )}

                  {/* Pièce Jointe Section */}
                  <Box p={4} bg="purple.50" borderRadius="lg" border="2px solid" borderColor="purple.200">
                    <Text fontSize="lg" fontWeight="bold" mb={4} color="purple.600">Pièce Jointe</Text>

                    {viewData.piece_jointe ? (
                      <VStack spacing={4} align="stretch">
                        <HStack justify="space-between" align="center">
                          <Box>
                            <Text fontWeight="semibold" color="gray.600">Fichier actuel</Text>
                            <Text fontSize="sm" color="gray.500">
                              {viewData.piece_jointe === 'exists' || viewData.piece_jointe === 'uploaded' || viewData.piece_jointe ?
                                `mission-${viewData.id}.pdf` :
                                'Fichier PDF'
                              }
                            </Text>
                          </Box>
                          <HStack spacing={2}>
                            <IconButton
                              icon={<MdDownload />}
                              size="sm"
                              colorScheme="blue"
                              variant="outline"
                              onClick={() => handleFileDownload(viewData.id)}
                              aria-label="Télécharger"
                            />
                            <Button
                              size="sm"
                              colorScheme="purple"
                              variant="outline"
                              leftIcon={<MdAttachFile />}
                              onClick={() => document.getElementById('piece-jointe-upload').click()}
                            >
                              Remplacer
                            </Button>
                          </HStack>
                        </HStack>
                      </VStack>
                    ) : (
                      <VStack spacing={4}>
                        <Text color="gray.500" textAlign="center">
                          Aucune pièce jointe uploadée
                        </Text>
                        <Button
                          leftIcon={<MdAttachFile />}
                          colorScheme="purple"
                          variant="outline"
                          onClick={() => document.getElementById('piece-jointe-upload').click()}
                        >
                          Ajouter une pièce jointe
                        </Button>
                      </VStack>
                    )}

                    {/* Hidden file input */}
                    <Input
                      id="piece-jointe-upload"
                      type="file"
                      accept=".pdf"
                      style={{ display: 'none' }}
                      onChange={(e) => handleFileUpload(e, viewData.id)}
                    />
                  </Box>

                  {/* Payment Info Section */}
                  <Box p={4} bg="gray.50" borderRadius="lg">
                    <Text fontSize="lg" fontWeight="bold" mb={4} color="blue.600">Informations de Paiement</Text>
                    <SimpleGrid columns={2} spacing={4}>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Prix</Text>
                        <Text>{viewData.prix ? `${viewData.prix} MAD` : "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Mode de Paiement</Text>
                        <Text>{viewData.paiement || "Non spécifié"}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" color="gray.600">Statut du Paiement</Text>
                        <Badge
                          colorScheme={viewData.paye ? "green" : "red"}
                          fontSize="sm"
                        >
                          {viewData.paye ? "Payé" : "Non Payé"}
                        </Badge>
                      </Box>
                    </SimpleGrid>
                  </Box>
                </SimpleGrid>
              </Box>
            )}
          </ModalBody>
          <ModalFooter>

            <Button colorScheme="blue" mr={3} onClick={onViewClose}>
              Fermer
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>



      {/* Mission Planning Confirmation Alert */}
      <AlertDialog
        isOpen={isMissionConfirmationOpen}
        leastDestructiveRef={cancelRef}
        onClose={onMissionConfirmationClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Mission Planifiée Existante
            </AlertDialogHeader>

            <AlertDialogBody>
              {missionConfirmationData && (
                <>
                  <Text>
                    L'ambulancier {missionConfirmationData.ambulancier?.nom} {missionConfirmationData.ambulancier?.prenom} a déjà une mission planifiée :
                  </Text>
                  <Text mt={2}>
                    Date: {new Date(missionConfirmationData.existingMission.date_mission).toLocaleString("fr-FR")}
                  </Text>
                  <Text>
                    Type: {missionConfirmationData.existingMission.type_mission}
                  </Text>
                  <Text>
                    Adresse: {missionConfirmationData.existingMission.adresse}
                  </Text>
                  <Text mt={2}>
                    Temps restant avant cette mission: {missionConfirmationData.remainingTime.hours} heures et {missionConfirmationData.remainingTime.minutes} minutes
                  </Text>
                  <Text mt={2}>
                    Voulez-vous quand même créer cette nouvelle mission ?
                  </Text>
                </>
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onMissionConfirmationClose}>
                Annuler
              </Button>
              <Button
                colorScheme="green"
                onClick={async () => {
                  try {
                    setIsAdding(true);
                    const response = await createMission(missionConfirmationData.missionData, missionConfirmationData.patientId);
                    if (response && response.id) {
                      setCreatedMissionId(response.id);
                      setActiveStep(3);
                    }
                    setIsAdding(false);
                    onMissionConfirmationClose();
                  } catch (err) {
                    setIsAdding(false);
                    console.error("Error creating mission:", err);
                    toast({ title: "Erreur lors de la création de la mission", status: "error", isClosable: true });
                  }
                }}
                ml={3}
                isLoading={isAdding}
              >
                Créer la mission
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Delete Alert */}
      <AlertDialog
        isOpen={isAlertOpen}
        leastDestructiveRef={cancelRef}
        onClose={onAlertClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Supprimer la Mission
            </AlertDialogHeader>

            <AlertDialogBody>
              Êtes-vous sûr de vouloir supprimer cette mission ? Cette action est irréversible.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onAlertClose}>
                Annuler
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Supprimer
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Chat Modals */}
      {Object.entries(openChats).map(([missionId, isOpen]) => (
        isOpen && (
          <Box
            key={missionId}
            position="fixed"
            bottom={minimizedChats[missionId] ? "0" : "20px"}
            right={`${getChatPosition(missionId)}px`}
            width="350px"
            height={minimizedChats[missionId] ? "50px" : "500px"}
            bg="white"
            borderRadius="lg"
            boxShadow="2xl"
            border="1px solid"
            borderColor="gray.200"
            zIndex={1000}
            display="flex"
            flexDirection="column"
            transition="all 0.3s ease"
            overflow="hidden"
          >
            {/* Professional Header */}
            <Box
              bg="#006133"
              color="white"
              p={3}
              borderTopRadius="lg"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              cursor="pointer"
              onClick={() => handleMinimizeChat(missionId)}
              boxShadow="sm"
            >
              <VStack spacing={0} align="start" flex="1">
                <Text fontWeight="bold" fontSize="md">
                  {getPatientName(missionId)}
                </Text>
                <Text fontSize="xs" opacity={0.9}>
                  Mission #{missionId}
                </Text>
              </VStack>
              <HStack spacing={1}>
                <IconButton
                  icon={<MdClose />}
                  size="sm"
                  variant="ghost"
                  color="white"
                  _hover={{ bg: "whiteAlpha.200" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseChat(missionId);
                  }}
                  aria-label="Fermer le chat"
                />
              </HStack>
            </Box>

            {!minimizedChats[missionId] && (
              <>
                {/* Messages Container */}
                <Box
                  flex="1"
                  overflowY="auto"
                  p={4}
                  display="flex"
                  flexDirection="column"
                  bg="gray.50"
                  css={{
                    '&::-webkit-scrollbar': {
                      width: '6px',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: 'transparent',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      background: '#cbd5e0',
                      borderRadius: '3px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      background: '#a0aec0',
                    },
                  }}
                >
                  {chatMessages[missionId]?.length === 0 ? (
                    <Box textAlign="center" py={8}>
                      <Icon as={MdChat} w={12} h={12} color="gray.300" mb={3} />
                      <Text color="gray.500" fontSize="sm">
                        Aucun message pour le moment
                      </Text>
                      <Text color="gray.400" fontSize="xs" mt={1}>
                        Commencez la conversation...
                      </Text>
                    </Box>
                  ) : (
                    chatMessages[missionId]?.map((message, index) => {
                      if (!message || !message.user_id) {
                        console.warn('Message invalide:', message);
                        return null;
                      }

                      const isCurrentUser = message.user_id === currentUser?.id;
                      const displayName = message.user_name ? message.user_name : 'Utilisateur';
                      const userPhoto = message.user_photo || message.photo;

                      return (
                        <Box
                          key={index}
                          mb={3}
                          alignSelf={isCurrentUser ? "flex-end" : "flex-start"}
                          maxW="85%"
                        >
                          <HStack spacing={2} justifyContent={isCurrentUser ? "flex-end" : "flex-start"}>
                            {!isCurrentUser && (
                              <Avatar
                                size="sm"
                                name={displayName}
                                src={userPhoto}
                                bg="blue.500"
                                color="white"
                              />
                            )}
                            <VStack spacing={1} align={isCurrentUser ? "flex-end" : "flex-start"}>
                              {!isCurrentUser && (
                                <Text fontSize="xs" fontWeight="medium" color="gray.600" px={1}>
                                  {displayName}
                                </Text>
                              )}
                              <Box
                                bg={isCurrentUser ? "blue.500" : "white"}
                                color={isCurrentUser ? "white" : "gray.800"}
                                p={3}
                                borderRadius="lg"
                                borderBottomRightRadius={isCurrentUser ? "4px" : "lg"}
                                borderBottomLeftRadius={isCurrentUser ? "lg" : "4px"}
                                maxW="100%"
                                boxShadow="sm"
                                border={isCurrentUser ? "none" : "1px solid"}
                                borderColor="gray.200"
                              >
                                {message.type === 'text' && (
                                  <Text fontSize="sm" lineHeight="1.4" whiteSpace="pre-wrap">
                                    {message.content}
                                  </Text>
                                )}
                                {(message.type === 'image' || message.type === 'image_url') && (message.media_data || message.message || message.content) && (
                                  <VStack spacing={2} align="start">
                                    <Image
                                      src={message.type === 'image' ? (message.media_data || message.message || message.content) : (message.message || message.content || message.media_data)}
                                      alt="Image partagée"
                                      maxW="220px"
                                      maxH="220px"
                                      borderRadius="md"
                                      cursor="pointer"
                                      objectFit="cover"
                                      onClick={() => handlePreviewImage(message.type === 'image' ? (message.media_data || message.message || message.content) : (message.message || message.content || message.media_data))}
                                      _hover={{ opacity: 0.85, transform: 'scale(1.02)' }}
                                      transition="all 0.2s"
                                      fallback={
                                        <Box
                                          w="220px"
                                          h="100px"
                                          bg="gray.100"
                                          borderRadius="md"
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                        >
                                          <Text fontSize="xs" color="gray.500">Image non disponible</Text>
                                        </Box>
                                      }
                                    />
                                    {message.type === 'image' && message.content && message.content !== message.media_data && (
                                      <Text fontSize="sm" lineHeight="1.4" whiteSpace="pre-wrap">
                                        {message.content}
                                      </Text>
                                    )}

                                  </VStack>
                                )}
                                {message.type === 'audio' && message.media_data && (
                                  <VStack spacing={2} align="start">
                                    <audio
                                      controls
                                      style={{
                                        maxWidth: '200px',
                                        borderRadius: '8px',
                                        background: 'transparent'
                                      }}
                                    >
                                      <source src={message.media_data} type="audio/mpeg" />
                                      Votre navigateur ne supporte pas l'élément audio.
                                    </audio>
                                    {message.content && (
                                      <Text fontSize="sm" lineHeight="1.4" whiteSpace="pre-wrap">
                                        {message.content}
                                      </Text>
                                    )}

                                  </VStack>
                                )}
                              </Box>
                              <Text fontSize="xs" color="gray.500" px={1}>
                                {message.timestamp ? new Date(message.timestamp).toLocaleTimeString('fr-FR', {
                                  hour: '2-digit',
                                  minute: '2-digit'
                                }) : ''}
                              </Text>
                            </VStack>
                            {isCurrentUser && (
                              <Avatar
                                size="sm"
                                name={displayName}
                                src={userPhoto}
                                bg="blue.500"
                                color="white"
                              />
                            )}
                          </HStack>
                        </Box>
                      );
                    })
                  )}
                  <div ref={messagesEndRef} />
                </Box>

                {/* Input Section - Design Telegram style */}
                <Box
                  px={3}
                  pt={2}
                  pb={3}
                  borderTop="1px solid"
                  borderColor="gray.100"
                  bg="white"
                  borderBottomRadius="xl"
                >
                  {/* Preview image collée / uploadée - style compact */}
                  {pastedImage && pastedImage.missionId === missionId && (
                    <Box
                      mb={2}
                      position="relative"
                      display="inline-block"
                    >
                      <Box
                        position="relative"
                        display="inline-block"
                        borderRadius="12px"
                        overflow="hidden"
                        boxShadow="0 2px 8px rgba(0,0,0,0.15)"
                        border="2px solid"
                        borderColor="blue.200"
                      >
                        <Image
                          src={pastedImage.dataUrl}
                          alt="Image à envoyer"
                          maxH="140px"
                          maxW="220px"
                          objectFit="cover"
                          display="block"
                        />
                        {/* Overlay sombre en bas avec label */}
                        <Box
                          position="absolute"
                          bottom={0}
                          left={0}
                          right={0}
                          bg="linear-gradient(transparent, rgba(0,0,0,0.55))"
                          px={2}
                          py={1}
                        >

                        </Box>
                        {/* Bouton × pour supprimer */}
                        <Box
                          position="absolute"
                          top="4px"
                          right="4px"
                          bg="rgba(0,0,0,0.55)"
                          borderRadius="full"
                          w="20px"
                          h="20px"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          cursor="pointer"
                          onClick={() => setPastedImage(null)}
                          _hover={{ bg: "rgba(220,38,38,0.8)" }}
                          transition="background 0.15s"
                          title="Retirer l'image"
                        >
                          <Icon as={MdClose} color="white" w="12px" h="12px" />
                        </Box>
                      </Box>
                    </Box>
                  )}

                  {/* Zone de saisie principale */}
                  <HStack
                    spacing={2}
                    align="flex-end"
                    bg="gray.50"
                    borderRadius="24px"
                    border="1.5px solid"
                    borderColor={pastedImage && pastedImage.missionId === missionId ? "blue.300" : "gray.200"}
                    px={3}
                    py={1}
                    _focusWithin={{
                      borderColor: "blue.400",
                      boxShadow: "0 0 0 2px rgba(66,153,225,0.15)",
                      bg: "white"
                    }}
                    transition="all 0.2s"
                  >
                    {/* Bouton image */}
                    <IconButton
                      icon={<MdImage />}
                      size="sm"
                      variant="ghost"
                      colorScheme="blue"
                      borderRadius="full"
                      minW="32px"
                      h="32px"
                      onClick={() => handleImageUpload(missionId)}
                      title="Joindre une image"
                      _hover={{ bg: "blue.50", color: "blue.500" }}
                      color="gray.400"
                    />

                    {/* Champ de texte */}
                    <Input
                      value={newMessage}
                      onChange={handleMessageChange}
                      placeholder={
                        pastedImage && pastedImage.missionId === missionId
                          ? "Ajouter une légende (optionnel)..."
                          : "Message ou collez une image (Ctrl+V)..."
                      }
                      variant="unstyled"
                      fontSize="14px"
                      lineHeight="1.4"
                      py={1}
                      flex={1}
                      _placeholder={{ color: "gray.400" }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                          e.preventDefault();
                          if (pastedImage && pastedImage.missionId === missionId) {
                            handleSendPastedImage(missionId);
                          } else {
                            handleSendMessage(missionId);
                          }
                        }
                      }}
                      onPaste={(e) => handlePaste(e, missionId)}
                    />

                    {/* Bouton micro */}
                    <IconButton
                      icon={<MdMic />}
                      size="sm"
                      variant="ghost"
                      colorScheme={isRecording ? "red" : "gray"}
                      borderRadius="full"
                      minW="32px"
                      h="32px"
                      onClick={() => handleAudioUpload(missionId)}
                      title={isRecording ? "Arrêter l'enregistrement" : "Enregistrer un audio"}
                      color={isRecording ? "red.500" : "gray.400"}
                      bg={isRecording ? "red.50" : "transparent"}
                      _hover={{ bg: isRecording ? "red.100" : "gray.100" }}
                    />

                    {/* Bouton envoyer */}
                    <IconButton
                      icon={<MdSend />}
                      size="sm"
                      colorScheme="blue"
                      borderRadius="full"
                      minW="32px"
                      h="32px"
                      isDisabled={!newMessage.trim() && !(pastedImage && pastedImage.missionId === missionId)}
                      onClick={() => {
                        if (pastedImage && pastedImage.missionId === missionId) {
                          handleSendPastedImage(missionId);
                        } else {
                          handleSendMessage(missionId);
                        }
                      }}
                      _hover={{ transform: "scale(1.08)", bg: "blue.500" }}
                      _disabled={{ opacity: 0.3, cursor: "not-allowed", transform: "none" }}
                      transition="all 0.15s"
                    />
                  </HStack>

                  {/* Hidden file inputs */}
                  <input
                    type="file"
                    ref={imageInputRef}
                    onChange={(e) => handleImageChange(e, missionId)}
                    accept="image/*"
                    style={{ display: 'none' }}
                  />
                  <input
                    type="file"
                    ref={audioInputRef}
                    onChange={(e) => handleAudioChange(e, missionId)}
                    accept="audio/*"
                    style={{ display: 'none' }}
                  />
                </Box>
              </>
            )}
          </Box>
        )
      ))}

      {/* Popup de sélection pour annuler la mission */}
      <Modal isOpen={cancelModalOpen} onClose={() => setCancelModalOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Choisir le statut de la mission</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} align="stretch">
              <Text>Sélectionnez le nouveau statut pour cette mission :</Text>

              {missionToCancel && (
                <Box p={4} bg="gray.50" borderRadius="md">
                  <Text fontWeight="bold" mb={2}>Détails de la mission :</Text>
                  <Text><strong>ID :</strong> {missionToCancel.id}</Text>
                  <Text>
                    <strong>Patient :</strong>{" "}
                    {(() => {
                      const patient = patients.find(
                        (p) => String(p.id) === String(missionToCancel.patient_id)
                      );
                      return patient
                        ? `${patient.nom} ${patient.prenom}`
                        : "Patient inconnu";
                    })()}
                  </Text>
                  <Text><strong>Adresse :</strong> {missionToCancel.adresse}</Text>
                  <Text><strong>Date :</strong> {new Date(missionToCancel.date_mission).toLocaleDateString('fr-FR')}</Text>
                  <Text><strong>Heure :</strong> {new Date(missionToCancel.date_mission).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</Text>
                </Box>
              )}

              <Box>
                <Text fontWeight="semibold" mb={2} color="red.600">
                  Motif d'annulation <Text as="span" color="red.500">*</Text>
                </Text>
                <select
                  value={motifAnnulation}
                  onChange={(e) => setMotifAnnulation(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    border: '1px solid #E2E8F0',
                    fontSize: '14px',
                    backgroundColor: '#fff'
                  }}
                >
                  <option value="">-- Sélectionner un motif --</option>
                  <option value="non_disponibilite_infirmier">1 - Non disponibilité de l'infirmier</option>
                  <option value="par_medecin_reviseur">2 - Par médecin receveur</option>
                  <option value="demandeur">3 - Demandeur</option>
                </select>
              </Box>

              <VStack spacing={3} align="stretch">
                <Button
                  colorScheme="red"
                  size="lg"
                  onClick={() => handleConfirmStatus('annulée')}
                  leftIcon={<MdCancel />}
                  isDisabled={!motifAnnulation}
                >
                  Annuler la mission
                </Button>
              </VStack>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={() => setCancelModalOpen(false)}>
              Fermer
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Audio distant pour le softphone WebRTC */}
      <audio
        ref={remoteAudioRef}
        autoPlay
        playsInline
        muted={false}
        style={{ display: 'none' }}
        onLoadedMetadata={() => {
          console.log('✅ Métadonnées audio chargées');
          if (remoteAudioRef.current) {
            remoteAudioRef.current.play().catch(err => {
              console.warn('⚠️ Auto-play bloqué, nécessite interaction utilisateur:', err);
            });
          }
        }}
      />

      {/* Modal de prévisualisation d'image */}
      <Modal isOpen={isImagePreviewOpen} onClose={onImagePreviewClose} size="4xl" isCentered>
        <ModalOverlay bg="blackAlpha.800" backdropFilter="blur(5px)" />
        <ModalContent bg="transparent" boxShadow="none">
          <ModalCloseButton color="white" size="lg" zIndex={2} bg="rgba(0,0,0,0.4)" borderRadius="full" top="10px" right="10px" />
          <ModalBody p={0} display="flex" justifyContent="center" alignItems="center">
            <VStack spacing={4} w="full">
              <Image
                src={previewImageUrl}
                maxH="80vh"
                objectFit="contain"
                borderRadius="md"
                bg="white"
                p={1}
              />
              <HStack spacing={4}>
                <Button
                  leftIcon={<MdDownload />}
                  colorScheme="blue"
                  onClick={() => downloadImage(previewImageUrl)}
                  borderRadius="full"
                  size="lg"
                  px={8}
                  boxShadow="lg"
                >
                  Télécharger
                </Button>
                <Button
                  leftIcon={<MdClose />}
                  colorScheme="whiteAlpha"
                  variant="solid"
                  onClick={onImagePreviewClose}
                  borderRadius="full"
                  size="lg"
                  px={8}
                >
                  Fermer
                </Button>
              </HStack>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
} 